'use strict';

var app = angular.module('Application', ['ui.bootstrap', 'ngSanitize', 'ngDragDrop', 'slick', 'pascalprecht.translate', 'angularjs-gauge']);

document.createElement('slick');


/*
 *  Dichiaro l'oggetto LMS per interagire con l'LMS per le chiamate
 *  e i punteggi se presente un test
 */
$.LMS = function (options) {
    var symbolOfScoreAndLastPage = '//';

    String.prototype.replaceAt = function (index, character) {
        return this.substring(0, index) + character + this.substring(index + 1, character.length);
    };

    var defaults = {
        type: '',
        versionSCORM: '1.2',
        linkedBrowsing: false,
        versionAICC: '2.0',
        commit: true,
        test: false,
        debug: false,
        closeBtn: '#js-close',
        getPages: function () {
        },
        numberOfPages: 1,
        completedWithPages: false
    };

    var options = $.extend(defaults, options);

    // invio un messaggio di debug alla console
    // del browser se il parametro di debug viene
    // attivato
    var debugMessage = function (text) {
        if (typeof console == "undefined") {
            window.console = {
                log: function () {
                }
            };
        }
        if (options.debug) {
            console.log(text);
            console.log(' ');
            return true;
        }
        return false;
    };

    // controllo se la variabile passata come parametro
    // è una funzione e può quindi essere richiamata
    function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    };

    var Cmi = {
        settings: {
            obj: false,
            httpArrayRequests: [
                function () {
                    return new XMLHttpRequest()
                },
                function () {
                    return new ActiveXObject("Msxml2.XMLHTTP")
                },
                function () {
                    return new ActiveXObject("Msxml3.XMLHTTP")
                },
                function () {
                    return new ActiveXObject("Microsoft.XMLHTTP")
                }
            ]
        },
        init: function () {
            for (var i = 0; i < this.settings.httpArrayRequests.length; i++) {
                try {
                    this.settings.obj = this.settings.httpArrayRequests[i]();
                }
                catch (e) {
                    continue;
                }
                break;
            }
        },
        getUrl: function (url, message) {
            this.settings.obj.open("POST", url, false);
            this.settings.obj.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            this.settings.obj.send(message);
            return this.settings.obj.responseText;
        },
        getError: function (result) {
            if (result) return parseInt(result.substring(result.indexOf("=") + 1, result.indexOf(String.fromCharCode(13))), 10);
            return false;
        },
        getScore: function (result) {
            var appo = result.toLowerCase().substring(result.toLowerCase().indexOf("score"));
            return appo.substring(appo.indexOf("=") + 1, appo.indexOf(String.fromCharCode(13)))
        },
        getLocation: function (result) {
            var appo = result.substring(result.toLowerCase().indexOf("lesson_location"));
            return appo.substring(appo.indexOf("=") + 1, appo.indexOf(String.fromCharCode(13)));
        },
        getStatus: function (result) {
            var appo = result.substring(result.toLowerCase().indexOf("lesson_status"));
            return appo.substring(appo.indexOf("=") + 1, appo.indexOf(String.fromCharCode(13)));
        },
        getTime: function (result) {
            var appo = result.substring(result.toLowerCase().indexOf("time"));
            return appo.substring(appo.indexOf("=") + 1, appo.indexOf(String.fromCharCode(13)));
        }
    };

    var StringaVisti = {
        settings: {
            string: '',
            pages: '',
            separator: '//'
        },
        make: function () {
            var pages = this.addPages();
            var viewed = '1';
            this.settings.string = this.create(viewed, pages);
            return this.settings.string;
        },
        create: function (lastVisitedPage, totalPages) {
            var radice = lastVisitedPage + this.settings.separator;
            var lezione = this.areAllViewed() ? '1*' : '0*';
            var string = radice + lezione + this.addPages();
            return string;
        },
        getTotalPages: function () {
            return options.numberOfPages;
        },
        areAllViewed: function () {
            var pages = this.getTotalPages();
            if (pages) {
                for (var i = 0; i < pages.length; i++) {
                    var char = this.settings.pages.substr(i, i + 1);
                    if (char == "0") return false;
                }
                return true;
            }
            return false;
        },
        // aggiungo la serie di 1 o 0 per il totale delle pagine
        // che sono presenti all'interno dei moduli
        addPages: function () {
            if (!this.settings.pages) {
                var string = '';
                for (var i = 0; i < this.getTotalPages(); i++) {
                    string = string + '0';
                }
                this.settings.pages = string;
            }
            return this.settings.pages;
        },
        // effettuo l'update di una stringa visti
        // modificando l'ultima pagina visualizzata
        // se la lezione è stata completata
        // tutte le pagine viste a 1
        update: function (string, index, number) {
            var number = (number != "0" && number != "1") ? '1' : number;
            var index = index + 5;
            var string = this.replaceViewed(string, index - 4);
            if (index >= 14) index++
            string = string.replaceAt(index, number);
            this.settings.pages = string.substr(5, string.length);
            if (this.areAllViewed()) string = this.setLezioneAllViewed(string);
            return string;
        },
        // rimpiazzo nella stringa il parametro che indica
        // l'ultima pagina vista
        updateViewed: function (value) {
            return LMS.string.lastViewed = value;
        },
        // rimpiazzo nella stringa il parametro che indica
        // l'ultima pagina vista
        replaceViewed: function (string, value) {
            value = Number(value);
            if (value <= 0 || value > this.getTotalPages()) value = 1;
            if (isNaN(value)) value = 1;
            var string = string.split(this.settings.separator)[1];
            string = value + this.settings.separator + string;
            return string;
        },
        // se sono state visualizzate tutte le pagine
        // setto la lezione a 1
        setLezioneAllViewed: function (string) {
            var lastViewed = this.getLastViewed(string);
            var string = string.replaceAt(2 + lastViewed.length, "1");
            return string;
        },
        // ottengo la StringaVisti da un testo
        getFromText: function (text) {
            return Cmi.getLocation(text);
        },
        // ottengo il valore dell'ultima pagina visualizzata
        getLastViewed: function (string) {
            var page = string.split('//')[0];
            if (page < 1) page = 1;
            return page;
        }
    };

    var URL = {
        settings: {
            params: false
        },
        getParamsArray: function () {
            if (!this.settings.params) {
                var url = window.location.search.substr(1);
                if (url) {
                    var params = new Array();
                    var array = url.split('&');
                    for (var i = 0; i < array.length; i++) {
                        array[i] = array[i].trim();
                        var nameValue = array[i].split('=');
                        params[nameValue[0].trim()] = nameValue[1].trim();
                    }
                    this.settings.params = params;
                }
            }
            return this.settings.params;
        },
        hasParam: function (param) {
            var params = this.getParamsArray();
            for (var key in params) {
                if (key == param) {
                    return params[param];
                }
            }
            return false;
        },
        getNameParam: function (string) {
            var i = string.indexOf("=");
            if (i) {
                return string.substring(0, i).toLowerCase();
            }
            return false;
        },
        getValueParam: function (string) {
            var i = string.indexOf("=");
            if (i) {
                var value = string.substring(i + 1, string.leght).toLowerCase();
                return unescape(value);
            }
            return false;
        },
        hasHTTP: function (url) {
            return url.substring(0, 4).toUpperCase() == "HTTP";
        }
    };

    var AICC = {
        settings: {
            data: false,
            url: '',
            id: '',
            score: 0,
            mastery_score: '',
            idName: 'aicc_sid',
            urlName: 'aicc_url'
        },
        failed: function () {
            return 'F';
        },
        passed: function () {
            return 'P';
        },
        completed: function () {
            return 'C';
        },
        incomplete: function () {
            return 'I';
        },
        version: function () {
            return options.versionAICC;
        },
        url: function () {
            if (!this.settings.url) {
                this.parseURL();
            }
            return this.settings.url;
        },
        id: function () {
            if (!this.settings.id) {
                this.parseURL();
            }
            return this.settings.id;
        },
        location: function () {
            return Cmi.getLocation(this.getData());
        },
        // ritorno lo stato della lezione
        statoLezione: function () {
            var value = Cmi.getStatus(this.getData())
            return value.substring(0, 1);
        },
        getData: function () {
            if (!this.settings.data) {
                var data;
                data = Cmi.getUrl(this.url(), this.createMessage('getparam'));
                if (Cmi.getError(data) != "0") {
                    debugMessage('AICC.getData(): Errore: ' + Cmi.getError(data));
                    LMS.logout();
                }
                else {
                    this.settings.data = data.toLowerCase();
                }
            }
            return this.settings.data;
        },
        setScore: function (score) {
            debugMessage('Mastery' + this.getMasteryScore());
            if (Number(score) >= this.getMasteryScore()) {
                Lezione.setStato(Lezione.passed());
            }
            else {
                Lezione.setStato(Lezione.failed());
            }
            return this.settings.score = score;
        },
        getScore: function () {
            if (!this.settings.score) {
                var data = this.getData();
                var score = Cmi.getScore(data);
                if (LMS.isTest()) {
                    if (isNaN(parseInt(score, 10))) {
                        score = 0;
                    }
                }
                else {
                    score = 0;
                }
                this.settings.score = score;
            }
            return this.settings.score;
        },
        getMasteryScore: function () {
            if (!this.settings.mastery_score) {
                var data = escape(this.getData());
                var string = 'mastery_score%3D';
                var pos = data.indexOf(string);
                if (pos != -1) {
                    mastery_score = data.substring(pos, data.length - 1);
                    pos = mastery_score.indexOf("%0D");
                    this.settings.mastery_score = Number(mastery_score.substring(string.length, pos));
                }
                else this.settings.mastery_score = "";
            }
            return this.settings.mastery_score;
        },
        getAutocertificazione: function () {
            if (!this.settings.autocertificazione) {
                var data = escape(this.getData());
                var string = 'autocertificazione%3Dtrue';
                var pos = data.indexOf(string);
                this.settings.autocertificazione = (pos != -1) ? true : false;
            }
            return this.settings.autocertificazione;
        },
        getReportCompleto: function () {
            if (!this.settings.reportCompleto) {
                var data = escape(this.getData());
                var string = 'reportcompleto%3Dtrue';
                var pos = data.indexOf(string);
                this.settings.reportCompleto = (pos != -1) ? true : false;
            }
            return this.settings.reportCompleto;
        },
        hasParam: function (url) {
            return url.indexOf("=") > -1;
        },
        isIdParam: function (param) {
            return param == "aicc-sid" || param == this.settings.idName;
        },
        isUrlParam: function (param) {
            return param == "aicc-url" || param == this.settings.urlName;
        },
        parseURL: function () {
            var id, url;

            // ottengo l'id dell'AICC
            if (id = URL.hasParam(this.settings.idName)) {
                this.setId(id);
            }

            // ottengo l'url dell'AICC
            if (url = URL.hasParam(this.settings.urlName)) {
                url = !URL.hasHTTP(url) ? unescape("http://") + url : url;
                this.setUrl(unescape(url));
            }

            Time.start();
            if (this.settings.url && this.settings.id) return true;
            return false;
        },
        setId: function (value) {
            return this.settings.id = value;
        },
        setUrl: function (value) {
            return this.settings.url = value;
        },
        hasParamsIdAndUrl: function () {
            if (URL.hasParam(this.settings.idName)) {
                if (URL.hasParam(this.settings.urlName)) {
                    return true;
                }
            }
            return false;
        },
        // creo il messaggio di invio per i vari comandi
        // alla piattaforma AICC
        createMessage: function (command, aicc_data) {
            if (!aicc_data) aicc_data = false;
            return "command=" + command + "&version=" + this.version() + "&session_id=" + this.id() + "&aicc_data=" + aicc_data;
        },
        logout: function () {
            var _return = Cmi.getUrl(this.url(), this.createMessage('exitau'));
            if (Cmi.getError(_return) != "0") {
                debugMessage("Errore nella comunicazione con la piattaforma.\n Il corso verrà  chiuso.");
                return false;
            }
            return true;
        },
        // invio i parametri di aggiornamento per effettuare
        // l'update della piattaforma AICC
        update: function () {
            // se è abilitato l'invio degli aggiornamenti
            if (LMS.isSCORMVersion('1.2')) {
                this.setValue("cmi.core.session_time", Time.timer());
            }
            else {
                this.setValue("cmi.session_time", Time.timer());
            }
            var data = "\r\nScore=" + this.getScore() + "\r\nTime=" + Time.timer() + "\r\nLesson_Status=" + Lezione.stato() + "\r\nLesson_Location=" + Lezione.stringaVisti();
            data = "[core]" + escape(data);
            var message = this.createMessage('putparam', data);
            var error = Cmi.getError(Cmi.getUrl(this.url(), message));
            if (error != "0") {
                debugMessage('AICC:update(): Errore: ' + error);
                debugMessage("Errore nella comunicazione con la piattaforma.\n Il corso verrà  chiuso.");
                return this.logout();
            }
            Time.reset();
            return true;
        },
        getTime: function () {
            return Time.timer();
        }
    };

    var SCORM = {
        settings: { score: 0 },
        failed: function () {
            return "failed";
        },
        passed: function () {
            return "passed";
        },
        completed: function () {
            return 'completed';
        },
        incomplete: function () {
            return 'incomplete';
        },
        statoLezione: function () {
            return (LMS.isSCORMVersion('1.2') ? this.getValue('cmi.core.lesson_status') : this.getValue("cmi.completion_status"));
        },
        init: function () {
            Time.set(this.getTime());
            Time.start();

            // se la lezione non è fallita o passata
            // vuol dire che è incompleta
            if (
                this.failed() != this.getParam().lesson_status &&
                this.passed() != this.getParam().lesson_status
            ) {
                Lezione.setStato("incomplete");
                this.setValue("cmi.core.lesson_status", "incomplete");
                return LMS.commit();
            }
            return false;
        },
        getParam: function () {
            if (!this.settings.param) {
                var obj = new Object();
                var lesson_location = this.getValue(LMS.isSCORMVersion('1.2') ? "cmi.core.lesson_location" : "cmi.location");
                obj.launch_data = this.getValue("cmi.launch_data");
                obj.lesson_status = this.getValue("cmi.core.lesson_status") ? this.getValue("cmi.core.lesson_status") : this.incomplete();
                obj.lesson_location = lesson_location ? lesson_location : false;

                // obj.lesson_location="0//1|2//111|0//1|2//110|0//0|0//00|0//0|0//0|";

                obj.suspend_data = this.getValue("cmi.suspend_data");
                obj.student_data = this.getValue('cmi.student_data._children');
                obj.mastery_score = this.getValue('cmi.student_data.mastery_score');
                obj.raw = this.getValue("cmi.core.score.raw");
                debugMessage(obj);
                this.settings.param = obj;
            }
            return this.settings.param;
        },
        getTime: function () {
            var params = this.getParam();
            var time = params.time;
            if (!time) time = Time.timer();
            return time;
        },
        getMasteryScore: function () {
            var params = this.getParam();
            return Number(params.mastery_score);
        },
        getAutocertificazione: function () {
            var launchData = this.getParam().launch_data;
            if (launchData) {
                var autocertificazione = launchData.split(';')[1].replace("autocertificazione=", "");
                autocertificazione = (autocertificazione == 'true') ? true : false;
                return autocertificazione;
            }
            return false;
        },
        getReportCompleto: function () {
            var launchData = this.getParam().launch_data;
            if (launchData) {
                var param = launchData.split(';')[0].replace("reportcompleto=", "");
                param = (param == 'true') ? true : false;
                return param;
            }
            return false;
        },
        setScore: function (score) {
            if (this.getParam().raw) {
                if (Number(this.getParam().raw) >= Number(score)) {
                    debugMessage('setScore');
                    return false;
                }
            }
            debugMessage('Mastery' + this.getMasteryScore());
            if (Number(score) >= this.getMasteryScore()) {
                debugMessage('TEST PASSED');
                debugMessage(Lezione.passed());
                Lezione.setStato(Lezione.passed());
            }
            else {
                debugMessage('TEST FAILED');
                debugMessage(Lezione.failed());
                Lezione.setStato(Lezione.failed());
            }
            this.settings.param.raw = score;
            this.setValue("cmi.core.score.raw", score);
            this.setValue("cmi.core.lesson_status", Lezione.stato());
            LMS.commit();
            return this.settings.score = score;
        },
        getScore: function () {
            var params = this.getParam();
            return (params.raw) ? Number(params.raw) : 0;
        },
        // ottengo il valore del name passato
        // in parametro
        getValue: function (name) {
            var value, codeError, error = false;
            if (LMS.isSCORMVersion('1.2')) {
                if (API.get()) {
                    value = API.get().LMSGetValue(name);
                    error = this.getErrorDescription();
                }
                else error = true;
            }
            else {
                value = API_1484_11.GetValue(name);
                codeError = API_1484_11.GetLastError().toString();
                if (codeError != "0") {
                    error = API_1484_11.GetErrorString(codeError);
                }
            }
            if (error) debugMessage('SCORM ERROR getting: ' + name);
            return (error && !value) ? false : value.toString();
        },
        // setto il @value al @name
        setValue: function (name, value) {
            if (API.get()) {
                var LMSSetValue;
                LMSSetValue = LMS.isSCORMVersion('1.2') ? API.get().LMSSetValue(name, value) : API_1484_11.SetValue(name, value);
                if (!LMSSetValue.toString()) {
                    debugMessage('Error: ' + name + ', value: ' + value);
                    return false;
                }
                this.settings.param[name] = value;
                return LMSSetValue;
            }
            return false;
        },
        getLastError: function () {
            return API.get().LMSGetLastError().toString();
        },
        getErrorDescription: function (code) {
            if (!code) code = this.getLastError();
            if (code != "0") return API.get().LMSGetErrorString(code);
            return false;
        },
        update: function () {
            // se è abilitato l'invio degli aggiornamenti
            if (options.commit) {
                if (LMS.isSCORMVersion('1.2')) {
                    return LMS.commit();
                }
                else {
                    commitResult = API_1484_11.Commit("");
                    if (commitResult != "true") {
                        debugMessage("Errore: LMSCommit non riuscito. \n" + commitResult);
                        return false;
                    }
                    return true;
                };
            };
            return true;
        }
    };

    var Settings = {
        settings: {
            parsed: false
        },
        string: {
            lastViewed: 0,
            score: 0,
            pages: false
        },
        get: function () {
            return this.string;
        },
        stringify: function () {
            if (!this.get().pages) {
                this.newString();
            }
            return this.get().lastViewed
                + symbolOfScoreAndLastPage
                + this.get().pages
        },
        parse: function () {
            this.get().lastViewed = parseInt(this.getLastViewed());
            this.get().pages = this.getPages();
            return this.get();
        },
        // ottengo il valore dell'ultima pagina visualizzata
        getLastViewed: function () {
            var index = LMS.getAppString();
            if (!index)
                return false;
            return index.split('//')[0];
        },
        getPages: function () {
            if (!LMS.getAppString())
                return false;
            return LMS.getAppString().split(symbolOfScoreAndLastPage)[1];
        },
        updatePages: function (page) {
            var $value = 1;
            if (jQuery.inArray(page - 1, this.get().bookmarks) > -1) $value = 2;
            this.get().pages = this.get().pages.replaceAt((parseInt(page) - 1), $value);
            return this;
        },
        newString: function () {
            this.createPagesString();
            return this.stringify();
        },
        createPagesString: function () {
            var string = ''
            for (var i = 0; i < options.numberOfPages; i++) {
                string += '0';
            }
            this.string.pages = string;
            return string;
        },
        arePagesCompleted: function () {
            for (var i = 0; i < this.get().pages.length; i++) {
                if (this.get().pages.substring(i, i + 1) == 0)
                    return false;
            }
            return true;
        },
        reset: function () {
            this.string.lastViewed = 0;
            this.string.pages = false;
            debugMessage('reset: ' + this.stringify());
        },
        pagesString: function () {
            return this.get().pages;
        }
    };

    var Lezione = {
        settings: {
            stato: '',
            score: 0,
            stringaVisti: '',
            location: '',
            page: ''
        },
        stato: function () {
            return this.settings.stato;
        },
        page: function () {
            return this.settings.page;
        },
        location: function () {
            return this.settings.location;
        },
        stringaVisti: function () {
            if (!this.settings.stringaVisti) this.settings.stringaVisti = StringaVisti.make();
            return this.settings.stringaVisti;
        },
        setPagina: function (n) {
            return this.settings.page = n;
        },
        setArg: function (n) {
            return this.settings.argument = n;
        },
        setStato: function (value) {
            this.settings.stato = value;
            SCORM.setValue("cmi.core.lesson_status", value);
            return this.stato();
        },
        setLocation: function (value) {
            if (!value)
                return false;

            value.replace(" ", "");
            return this.settings.location = value;
        },
        setStringaVisti: function (value) {
            return this.settings.stringaVisti = value;
        },
        getStato: function () {
            return LMS.isAICC() ? AICC.statoLezione() : SCORM.statoLezione();
        },
        // controllo che la lezione sia stata passata
        passed: function () {
            return LMS.isAICC() ? AICC.passed() : SCORM.passed();
        },
        // controllo se la lezione ha avuto esito negativo
        failed: function () {
            return LMS.isAICC() ? AICC.failed() : SCORM.failed();
        },
        completed: function () {
            return LMS.isAICC() ? AICC.completed() : SCORM.completed();
        },
        incomplete: function () {
            return LMS.isAICC() ? AICC.incomplete() : SCORM.incomplete();
        },
        getScore: function () {
            return LMS.isAICC() ? AICC.getScore() : SCORM.getScore();
        },
        getMasteryScore: function () {
            return LMS.isAICC() ? AICC.getMasteryScore() : SCORM.getMasteryScore();
        },
        // controllo se sono state visionate tutte le pagine
        isFinish: function () {
            var isFinish = Settings.arePagesCompleted() || this.getStato() == this.completed();
            return isFinish;
        },
        isCompleted: function () {
            return this.getStato() == this.completed();
        },
        // ottengo l'ultima pagina visualizzata dall'utente
        getLastPageViewed: function () {
            return StringaVisti.getLastViewed(this.stringaVisti());
        },
        getTime: function () {
            return LMS.isAICC() ? AICC.getTime() : SCORM.getTime();
        }
    };

    var Time = {
        settings: {
            timer: "00:00:00"
        },
        // setto il timer
        set: function (value) {
            return this.settings.timer = value;
        },
        timer: function () {
            return this.settings.timer;
        },
        start: function () {
            var time = this.timer();
            var ore = this.getHours(time);
            var minuti = this.getMinutes(time);
            var secondi = this.getSeconds(time);

            // aumento i secondi
            secondi = this.pad2((Number(secondi) + 1));

            // se i secondi raggiungono il 60
            // aumento di 1 il minuto e riazzero i secondi
            if (secondi == 60) {
                secondi = '00';
                minuti = this.pad2((Number(minuti) + 1));
            }

            // se i minuti raggiungono il 60
            // aumento di 1 le ore e riazzero i minuti
            if (minuti == 60) {
                minuti = '00';
                ore = this.pad2((Number(ore) + 1));
            }

            // setto la nuova ora
            this.set(ore + ":" + minuti + ":" + secondi);

            setTimeout(function () {
                Time.start();
            }, 1000);
            return true;
        },
        getHours: function (time) {
            var hours = time.split(':')[0];
            return hours;
        },
        getMinutes: function (time) {
            var minutes = time.split(':')[1];
            return minutes;
        },
        getSeconds: function (time) {
            var seconds = time.split(':')[2];
            return seconds;
        },
        // resetto il timer
        reset: function () {
            return this.set('00:00:00');
        },
        // fixo i numeri al di sotto di 10 con 2 digits
        pad2: function (number) {
            return (number < 10 ? '0' : '') + number;
        }
    };

    var API = {
        settings: {},
        // ottengo le API
        get: function () {
            if (!this.settings.get) {
                var API = null;
                //Search all the parents of the current window if there are any
                if ((window.parent != null) && (window.parent != window)) {
                    API = this.scanParentsForApi(window.parent);
                }
                /*
		If we didn't find the API in this window's chain of parents,
		then search all the parents of the opener window if there is one
                */
                if ((API == null) && (window.top.opener != null)) {
                    API = this.scanParentsForApi(window.top.opener);
                }
                this.settings.get = API;
            }
            return this.settings.get;
        },
        scanParentsForApi: function (win) {
            var nParentsSearched = 0;
            while ((win.API_1484_11 == null) && (win.API == null) &&
                (win.parent != null) && (win.parent != win) &&
                (nParentsSearched <= 500)
            ) {
                nParentsSearched++;
                win = win.parent;
            }
            /*
                If the API doesn't exist in the window we stopped looping on,
                then this will return null.
            */
            if (win.API == null) {
                if (win.API_1484_11 != null) {
                    return win.API_1484_11;
                } else {
                    return null;
                }
            } else {
                return win.API;
            }
        }
    };

    var Test = {
        setScore: function (score) {
            return (LMS.isAICC()) ? AICC.setScore(score) : SCORM.setScore(score);
        }
    };

    var LMS = {
        settings: {
            exit: false,
            connected: false,
            location: ''
        },
        // avvio le definizioni per LMS
        start: function () {
            Cmi.init();
            // effettuo la connessione alla piattaforma
            var connect = this.connect();

            // controllo alla chiusura del browser
            $(window).on('beforeunload', function (event) {
                LMS.manageBrowserExit(event);
            });

            $(document).on('click touchstart', options.closeBtn, function () {
                LMS.exitAu();
                return false;
            });
        },
        // mi connetto alla piattaforma
        // la connessione differisce se la
        // comunicazione è in AICC o in SCORM
        connect: function () {
            if (!this.settings.connected) {
                var connect = false;
                // se è AICC
                if (AICC.hasParamsIdAndUrl()) {
                    debugMessage('AICC: started');
                    this.setType('aicc');
                    if (this.AICCConnect()) connect = true;
                }
                // se è SCORM
                else if (API.get()) {
                    debugMessage('SCORM: started');
                    this.setType('scorm');
                    if (this.SCORMConnect()) connect = true;
                }
                else {
                    this.setType('');
                    connect = true;
                }
                this.settings.connected = connect;
            }
            return (this.settings.connected) ? this.prepare() : false;
        },
        getAppString: function () {
            //return '0//1|0//11111111|0//00000000000|0//0|';
            return SCORM.getValue(LMS.isSCORMVersion('1.2') ? "cmi.core.lesson_location" : "cmi.location");
        },
        location: function () {
            return this.settings.location;
        },
        // connession tramite AICC
        AICCConnect: function () {
            return AICC.parseURL();
        },
        // connessione tramite SCORM
        SCORMConnect: function () {
            var SCORMConnect;
            // se è la versione 1.2
            SCORMConnect = this.isSCORMVersion('1.2') ? API.get().LMSInitialize("") : API_1484_11.Initialize("");
            if (SCORMConnect) {
                SCORM.init();
            }
            return SCORMConnect;
        },
        // ritorno il tipo di comunicazione
        type: function () {
            return options.type;
        },
        // setto il tipo di comunicazione
        setType: function (type) {
            options.type = type;
            return type;
        },
        // controllo se la comunicazione in atto è in AICC
        isAICC: function () {
            return this.type() == 'aicc';
        },
        // controllo se la comunicazione in atto è in SCORM
        isSCORM: function () {
            return this.type() == 'scorm';
        },
        // controllo se è la versione passata dello scorm
        isSCORMVersion: function (version) {
            return options.versionSCORM == version;
        },
        putParam: function (n) {
            var update = false;

            // effettuo l'update del valore AICC
            if (this.isAICC()) {
                AICC.update();
                update = true;
            }
            else {
                SCORM.update();
                update = true;
            };
            return update;
        },
        // preparo la scena per le interazioni future
        prepare: function () {
            // ottengo i parametri
            var params = this.getParam();
            if (params) {
                if (this.isAICC()) {
                    var stringa_visti = StringaVisti.getFromText(params);
                    Lezione.setStringaVisti(stringa_visti ? stringa_visti : StringaVisti.make());
                }
                else {
                    Lezione.setLocation(params.lesson_location);
                    Lezione.setStato(params.lesson_status);
                    //Settings.parse();
                }

                // se la lezione è completata la segno come completata
                if (!Lezione.isFinish()) {
                    debugMessage('isNotFinish');
                    Lezione.setStato(Lezione.incomplete());
                }
                return this.putParam();
            }
            return true;
        },
        getParam: function () {
            var params = false;
            if (this.isAICC()) {
                params = this.getAICCParam();
            }
            else {
                if (this.isSCORMVersion('1.2')) {
                    params = this.getSCORMParam();
                }
                else {
                    Lezione.setStato(this.getValue("cmi.completion_status"));
                }
            }
            return params;
        },
        // ottengo i parametri dell'AICC
        getAICCParam: function () {
            var data = AICC.getData();
            var segnalibroTest = false;
            // Prendo la core_lesson se sono in un test
            if (options.test) {
                var pos = data.indexOf('core_vendor');
                if (pos != -1) {
                    var nuovaStr = data.substring(pos);
                    var pos2 = nuovaStr.indexOf("%0D%0A");
                    if (pos2 != -1) {
                        if (nuovaStr.indexOf("reportcompleto%3Dtrue") != -1) {
                            reportCompleto = "true";
                        }
                        else {
                            reportCompleto = "false";
                        }
                        if (nuovaStr.indexOf("autocertificazione%3Dtrue") != -1) {
                            autocertificazione = "true"
                        }
                        else {
                            autocertificazione = "false"
                        }
                        if (nuovaStr.indexOf("segnalibrotest%3Dtrue") != -1) {
                            segnalibroTest = "true"
                        }
                        else {
                            segnalibroTest = "false"
                        }
                    }
                };
                if (segnalibroTest) {
                    pos = data.indexOf('core_lesson');
                    if (pos != -1) {
                        nuovaStr = data.substring(pos);
                        pos2 = nuovaStr.indexOf("%0D%0A");
                        if (pos2 != -1) {
                            nuovaStr = nuovaStr.substring(pos2 + 6)
                            num = nuovaStr.indexOf("%0D%0A")
                            coreLesson = nuovaStr.substring(0, num)
                            coreLesson = unescape(coreLesson)
                        }
                    }
                }
            }; // options.test
            return data;
        },
        getSCORMParam: function () {
            return SCORM.getParam();
        },
        logout: function () {
            var miaTop = this.trovaTop(window);
            if (miaTop.location == self.location) {
                self.top.close();
            }
            else {
                //self.location = "logout.htm";
            }
        },
        trovaTop: function (win2) {
            if (win2.location == win2.parent.location) {
                return win2;
            }
            else {
                var win2 = this.trovaTop(win2.parent);
                return win2;
            }
        },
        // gestisco l'uscita dell'utente nel caso
        // in cui chiuda la finestra con la x del browser
        manageBrowserExit: function (ev) {
            if (this.type() != "") {
                if (!ev) {
                    ev = event;
                }
                if (!this.isExit()) {
                    debugMessage('Browser Exit')
                    return this.exitAu();
                }
            }
        },
        exitAu: function () {
            this.setCorrectExit();
            if (this.isAICC()) {
                if (AICC.logout()) {
                    return this.logout();
                }
            }
            else {
                if (this.isSCORMVersion('1.2')) {
                    // invio il tempo
                    SCORM.setValue("cmi.core.session_time", Time.timer());
                    // SCORM.setValue("cmi.core.lesson", Time.timer());
                }
                else {
                    var timer_value1 = "";
                    // console.log('Time.timer(): ' + Time.timer());
                    var appo = Time.timer().split(":");
                    if (parseInt(appo[0], 10) > 0) {
                        timer_value1 = parseInt(appo[0], 10) + "H"
                    }
                    if (parseInt(appo[1], 10) > 0) {
                        timer_value1 = timer_value1 + parseInt(appo[1], 10) + "M"
                    }
                    if (parseInt(appo[2], 10) > 0) {
                        timer_value1 = timer_value1 + parseInt(appo[2], 10) + "S"
                    }
                    Time.set("PT" + timer_value1);
                    // console.log('Time.timer after set: ' + Time.timer());

                    // invio il tempo
                    SCORM.setValue("cmi.session_time", Time.timer());
                }

                if (this.isSCORMVersion('1.2')) {
                    SCORM.update();
                    this.finish();
                }
                else if (API_1484_11.Terminate("") != "true") {
                    debugMessage("Errore: LMSFinish non riuscito. \n" + result)
                }

                return this.logout();
            }
        },
        // segno che è avvenuta l'uscita correttamente
        setCorrectExit: function () {
            return this.settings.exit = true;
        },
        // segno che ci sono stati problemi nell'uscire
        setErrorExit: function () {
            return this.settings.exit = false;
        },
        // ritorno il risultato dell'exit se è avvenuto
        isExit: function () {
            return this.settings.exit;
        },
        finish: function () {
            if (API.get()) {
                var LMSFinish = API.get().LMSFinish("");
                if (LMSFinish != "true") {
                    debugMessage("Errore: LMSFinish non riuscito. \n" + LMSFinish)
                    return false;
                }
                else {
                    debugMessage('LMSFinish correttamente riuscito');
                    return this.logout();
                }
            }
        },
        // invio i dati alla piattaforma
        commit: function () {
            if (API.get()) {
                var LMSCommit = API.get().LMSCommit("");
                if (!LMSCommit) {
                    debugMessage("Errore: LMSCommit non riuscito. \n" + LMSCommit);
                    return false;
                }
                return true;
            }
            return false;
        },
        isTest: function () {
            return options.test;
        },
        update: function () {
            debugMessage('update');
            return this.putParam();
        },
        updateScore: function (score, status) {
            options.test = true;
            Test.setScore(score);
            // Lezione.setStato((status ? Lezione.passed() : Lezione.failed()));
            debugMessage('updateScore');
            return this.putParam();
        },
        getMasteryScore: function () {
            return Lezione.getMasteryScore();
        },
        getAutocertificazione: function () {
            return LMS.isAICC() ? AICC.getAutocertificazione() : SCORM.getAutocertificazione();
        },
        getReportCompleto: function () {
            return LMS.isAICC() ? AICC.getReportCompleto() : SCORM.getReportCompleto();
        },
        getLastPageView: function () {
            return Settings.get().lastViewed;
        },
        updatePages: function (numberPage) {
            Settings.get().lastViewed = numberPage - 1;
            Settings.updatePages(numberPage);
            return LMS.update();
        },
        /**
         * @description update lesson location
         * @param string
         * @return {*|boolean}
         */
        updateLessonLocation(string) {
            // console.log("updateLessonLocation", string);
            SCORM.setValue("cmi.core.lesson_location", string);
            return LMS.commit();
        },
        /**
         * @description get stored lesson_location
         * @return {*}
         */
        getLessonLocation() {
            return this.getParam().lesson_location;
        },
        /**
         * @description update suspend data
         * @param string
         * @return {*|boolean}
         */
        updateSuspendData(string) {
            SCORM.setValue("cmi.suspend_data", string);
            return LMS.commit();
        },
        /**
         * @description get stored suspend_data
         * @return {*}
         */
        getSuspendData() {
            return this.getParam().suspend_data;
        },
        /**
         * @description update lesson location and suspend data
         * @param strings
         */
        updateStrings(strings) {
            // console.log("strings.lessonLocation " + strings.lessonLocation)
            if (strings.lessonLocation) {
                LMS.isSCORMVersion('1.2') ?
                    SCORM.setValue("cmi.core.lesson_location", strings.lessonLocation) :
                    SCORM.setValue("cmi.location", strings.lessonLocation);
                // SCORM.setValue("cmi.lesson_location", strings.lessonLocation);
            }

            if (strings.suspendData)
                SCORM.setValue("cmi.suspend_data", strings.suspendData);

            LMS.commit();
            return this;
        },
        string: function () {
            return Settings.stringify();
        },
        reset: function () {
            Settings.reset();
            Lezione.setStato(Lezione.incomplete());
            return LMS.update();
        },
        setCompleted: function () {
            debugMessage('completed');
            Lezione.setStato(Lezione.completed());
            SCORM.setValue("cmi.session_time", Time.timer());
            return this.update();
        },
        getLastPageOfString: function () {
            return Settings.stringify().split('//')[1].lastIndexOf("1");
        },
        getPagesString: function () {
            return Settings.pagesString();
        },
        setValue: function (attr, value) {
            return SCORM.setValue(attr, value);
        },
        getScore: function () {
            return SCORM.getScore();
        }
    };

    LMS.start(options);
    // Settings.parse();
    return LMS;
}






app.controller('AsideController', function(){});

(function () {

    'use strict';

    var ConclusionTestController = function ($scope, $filter, App, Tracking, Interaction) {
        
        $scope.feedback = false;
        $scope.scoreFeedback = false;
        $scope.ispassed = false;

        // console.log("$scope.calcPerc()", $scope.caslcPerc());

        $scope.totPerc = (100 * $scope.collection.count('isCorrect')) / $scope.collection.count();
        $scope.totPerc = Math.round($scope.totPerc);
        // console.log($scope.totPerc);
        if ($scope.totPerc >= 70) {
            $scope.testFeedback = 
                $filter('translate')('exerciseTemplate.feedbacks.scoreMessageYes');
            $scope.scoreFeedback = $filter('translate')('exerciseTemplate.feedbacks.scoreMessage1') + 
                $scope.totPerc + 
                $filter('translate')('exerciseTemplate.feedbacks.scoreMessage2');
                $scope.ispassed = true;
        } else {
            $scope.testFeedback = 
                $filter('translate')('exerciseTemplate.feedbacks.scoreMessageNo');
            $scope.scoreFeedback = $filter('translate')('exerciseTemplate.feedbacks.scoreMessage1') + 
                $scope.totPerc + 
                $filter('translate')('exerciseTemplate.feedbacks.scoreMessage3');
        }

        $scope.isPassed = function() {
            return $scope.ispassed;
        }

        /*
        if ($scope.isPassed()) {
            Tracking.save({
                score: $scope.totPerc,
                status: $scope.isPassed() ? 'passed' : 'failed'
            });
        }
        */

        // if ($scope.totPerc >= 70) {
            $scope.page().viewed();
        // }
        // Tracking.save({
        //     score: $scope.totPerc,
        //     status: $scope.isPassed() ? 'passed' : 'failed'
        // });
    };

    ConclusionTestController.$inject = ['$scope', '$filter', 'App', 'Tracking','Interaction'];

    angular.module('Application')
        .controller('ConclusionTestController', ConclusionTestController);
})();

app.controller('CoppieCardController', ['$scope', '$timeout', '$interval', 'GameService','AudioService', function ($scope, $timeout, $interval, GameService, AudioService) {

    var confirmedCouplesCount = 0;

    $scope.currentStepCount = 0;
    $scope.currentStepCards = $scope.exercise.answers()[$scope.currentStepCount];

    //$scope.timerState.initialTimerMs = 90*1000;
    function playCorrect() { AudioService.playAudio('it/corretta'); }
    function playWrong()   { AudioService.playAudio('it/sbagliata'); }
    let score = GameService.getProgressById('G_MEM').score;
    //console.log("score",score)
    if (score >= 0) { //game già avviato
        //card.confirmed=false
        _.each($scope.currentStepCards.cards, function (card) {
            card.confirmed = false;
            card.isFlipped = false
            //if (card.isFlipped){
            //$scope.flipCard(card);
            //}
        })
        //$scope.completed = true;
        //$scope.feedback = "Game già completato";
    }

    $scope.timeoverHandler = function () {
        $scope.feedback = "Tempo scaduto!";
        AudioService.playAudio('it/sbagliata');
        GameService.addScore(0, 0, 0, 'G_MEM');
    };

    $scope.nextStep = function () {
        $scope.loading = true;
        _.each($scope.currentStepCards.cards, function (card) {
            if (card.isFlipped) {
                $scope.flipCard(card);
            }
        });

        $timeout(function () {
            confirmedCouplesCount = 0;
            $scope.currentStepCount++;
            $scope.currentStepCards = $scope.exercise.answers()[$scope.currentStepCount];
            $scope.loading = false;
        }, 1000);

        $scope.nextButtonVisible = false;
    };
    //$scope.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    $scope.cardSelection = [];

    $scope.addFlipAnimationToCards = function () {
        //console.log("addFlipAnimationToCards");
        // console.log("flip");
        TweenMax.set($(".card-wrap__card"), { rotationY: 0 });
        $.each($(".card-wrap__card"), function (i, element) {
            var frontCard = $(this).children(".card__front"),
                backCard = $(this).children(".card__back"),
                tl = new TimelineMax({ paused: true });

            tl
                .to(frontCard, 1, { rotationY: 180 })
                .to(backCard, 1, { rotationY: 0 }, 0)
                .to(element, .5, { z: 50 }, 0)
                .to(element, .5, { z: 0 }, .5);

            element.animation = tl;
        });
    };

    $scope.flipCard = function (card) {
        var idCard = '#card-' + $scope.exercise.getAttr('id') + '-' + _.indexOf($scope.currentStepCards.cards, card);
        if (card.isFlipped) {
            $(idCard)[0].animation.reverse();
        } else {
            $(idCard)[0].animation.play();
        }
        card.isFlipped = !card.isFlipped;

        //$scope.exercise.setAnswer(card);
        //$scope.exercise.confirm();
    };

    $timeout(function () {
        $scope.addFlipAnimationToCards();
        $scope.canFlip = true;
    }, 0);

    $scope.onSelectCard = function (card) {

        if ($scope.canFlip && !$scope.timeStarted) {
            $scope.timeStarted = true;
        }

        let score = GameService.getProgressById('G_MEM').score;
        if (score < 0) { //game già avviato
            GameService.initGameScore('G_MEM');
        }

        //console.log("card.confirmed",card.confirmed)
        //console.log("$scope.cardSelection.length",$scope.cardSelection.length)
        if (card.confirmed || card.isFlipped && $scope.cardSelection.length < 2) {
            //console.log("ci sonooo")
            return;
        }

        $scope.flipCard(card);
        $scope.cardSelection.push(card);
        //console.log("$scope.currentStepCount",$scope.currentStepCount)
        //console.log("$scope.cardSelection.length",$scope.cardSelection.length)

        if ($scope.cardSelection.length === 2) {
            $scope.canFlip = false;
            // right association
            if ($scope.cardSelection[0].match === $scope.cardSelection[1].match) {
                playCorrect();
                $scope.cardSelection[0].confirmed = $scope.cardSelection[1].confirmed = true;
                confirmedCouplesCount++;
                //console.log("confirmedCouplesCount",confirmedCouplesCount)
                if ((($scope.currentStepCount == 0) && confirmedCouplesCount >= 3) || ($scope.currentStepCount == 1 && confirmedCouplesCount >= 3)) {
                    console.log($scope.currentStepCount);

                    // if ($scope.currentStepCount < 1) {
                    //     if ($scope.currentStepCount < $scope.exercise.answers().length - 1) {
                    //         // next step
                    //         $scope.nextButtonVisible = true;
                    //     }
                    // }
                
                    // else {
                        $scope.exercise.confirm();
                        $scope.timeStarted = false;
                        //$interval.cancel(timerInterval);
                        $scope.page().viewed();
                        //var remainingTime = $scope.timerState.initialTimerMs-$scope.timerState.timeElapsed;
                        //if ((remainingTime - 1000) > 0){ // se non è scaduto il tempo
                        //var totScore = 150;
                        //var extraScore = Math.floor(remainingTime/1000/10)*10; // 10 punti ogni 10 secondi rimanenti
                        //$scope.feedback = "Complimenti! Hai completato il game. Il tuo punteggio è " + (Math.round(totScore)+extraScore);
                        //GameService.addScore(totScore, extraScore, remainingTime,'G_MEM');
                        //}
                        console.log("here");

                        $scope.continueFedbackVisible = true;
                        //console.log("quiiiiiiiiiiiii")
                    // }

                }
                $scope.cardSelection = [];
                $scope.canFlip = true;
            } 
       
            
            else { // wrong association
                var card1 = $scope.cardSelection[0];
                var card2 = $scope.cardSelection[1];
                playWrong();
                $timeout(function () {
                    $scope.flipCard(card1);
                    $scope.flipCard(card2);
                $scope.cardSelection = [];
                $scope.canFlip = true;
                }, 1500);
            }

        }
        // $scope.Page.next()
    };
}]);


app.controller('CruciverbaController', ['$scope', 'App', 'MenuButton', 'Overlay', function ($scope, App, MenuButton, Overlay) {
    var model = $scope.page().html() ? $scope.page().html() : $scope.page().video().currentTiming().getModule('Html')[0];
    $scope.propsComponent = model.getAttr('propsComponent');
    $scope.closeModuleHandler = function(){
        App.closeModule();
    }
    $scope.pageViewed = function(){
        $scope.page().viewed();
    }
}]);

(function () {

    'use strict';

    var ExerciseCardController = function ($scope, $timeout, Sound, Page, App, Video) {
        var audio;
        $scope.timeOver = false;
      
        function load() {
            // console.log($scope.exercise);
            // var audio;
            // if (audio){
            //     audio.pause()
            //     audio=null
            // }
            $timeout(function() {
                if ($scope.exercise.isConfirmed()) {
                    // console.log($scope.exercise.isAnswered());
                    $scope.flipCard($scope.exercise.isAnswered(), true);
                }
            }, 500);
              //$scope.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        $scope.selectedCard = false;

        $scope.slide = function (dir) {
            $('#carousel-example-generic').carousel(dir);
        };

        $scope.addFlipAnimationToCards = function(){
            // console.log("flip");
            TweenMax.set($(".card-wrap__card"), {rotationY:0});
            $.each($(".card-wrap__card"), function(i,element) {
                var frontCard = $(this).children(".card__front"),
                    backCard = $(this).children(".card__back"),
                    tl = new TimelineMax({paused:true});

                tl
                    .to(frontCard, 1, {rotationY:180})
                    .to(backCard, 1, {rotationY:0},0)
                    .to(element, .5, {z:50},0)
                    .to(element, .5, {z:0},.5);

                element.animation = tl;
            });
        }

        $timeout(function () {
            $scope.addFlipAnimationToCards();
        }, 0);

        $scope.cards = [
            {
                id: "mitaca",
                name: "Mitaca",
                imgUrlFront: "images/game/avatar/cards/mitaca_front.svg",
                imgUrlBack: "images/game/avatar/cards/mitaca_back.svg",
                color: "orange",
                personality: "Tenacious, brave and resourceful",
                meaningName: "Mitaca and Cosecha Principal are the main harvests in Colombia. They have flowers and ripening berries on the same branch"
            },
            {
                id: "kaffa",
                name: "Kaffa",
                imgUrlFront: "images/game/avatar/cards/kaffa_front.svg",
                imgUrlBack: "images/game/avatar/cards/kaffa_back.svg",
                color: "green",
                personality: "Ambitious, bold and competitive",
                meaningName: "Kaffa is a region of Ethiopia, the land where Coffea Arabica plants were first discovered in the 9th century AD"
            },
            {
                id: "honey",
                name: "Honey",
                imgUrlFront: "images/game/avatar/cards/honey_front.svg",
                imgUrlBack: "images/game/avatar/cards/honey_back.svg",
                color: "yellow",
                personality: "Determined and ambitious, she likes to stand out",
                meaningName: "'Honey processed' is the liquid process used to prepare coffee in Costa Rica: once the berries have been stripped, the remaining layer of mucilage is left, giving the coffee a particularly intense aroma"
            }
        ]

        $scope.flipCard = function (card, force = false) {
            // debugger;
            var index = _.indexOf($scope.exercise.answers(), card);
        
            if (index === -1 || !$scope.exercise.answers()[index]) {
                console.error('Card not found or invalid index');
                return;
            }
        
            var idCard = '#card-' + $scope.exercise.getAttr('id') + '-' + index;
            $scope.cards[index].clicked = true;
        
            if (card.isFlipped && !force) {
                $(idCard)[0].animation.reverse();
            } else {
                $(idCard)[0].animation.play();
            }
        
            $scope.exercise.setAnswer(card);
            $scope.exercise.confirm();
        
            var audioLocale = "it/sbagliata";
            if (!$scope.timeOver && Number(index) == $scope.exercise.getAttr("correct")[0] && !force) {
                $scope.timerState.timeStarted =false;
                $scope.exercise.setAttr('allCardClicked', true);
                $scope.corrected = true;
                audioLocale = "it/corretta";
            }
        
            if (audioLocale) {
                audio = Sound.create({
                    src: audioLocale
                });
                audio.play();
            }
        };

        $scope.timeOverHandler = function () {
            $scope.timeOver = true;
            angular.forEach($scope.exercise.answers(), function(card) {
                if (!card.isFlipped) {
                    $scope.flipCard(card, true); 
                    $scope.exercise.setAttr('allCardClicked', true);
                }
            });
        };

        $scope.onSelectAvatar = function(card){
            $scope.selectedCard = card.id;
            var avatarSelected = {
                id: card.id,
                name: card.name,
                avatarImgUrl: "images/game/avatar/dancy.svg",
                color: card.color
            }
            // $scope.Page.next()
        }

        $scope.areAllCardClicked = function () {
            return _.filter($scope.cards, function (card) {
                return !card.clicked;
            }).length === 0;
        };
        }

        // Page.events.on('change', function () {
        //     // debugger;
        //     stopAudio();
        //     // $scope.startTimerEx=false;
        //     // $scope.collection.next();
        //     // $scope.loadAudio();
        //     load();
        // });
        
        // App.events.on('module.close', function() {
        //     // debugger;
        //     stopAudio();
        // });

        // Video.events.on('play', function () {
        //     stopAudio();
        // });

        // function stopAudio() {
        //     console.log(audio);
        //     if (audio) {
        //         audio.pause();
        //         audio = false;
        //     }
        // };

        load();
    };

    ExerciseCardController.$inject = ['$scope', '$timeout','Sound', 'Page', 'App', 'Video'];

    angular.module('Application')
        .controller('ExerciseCardController', ExerciseCardController);
})();

(function() {

    'use strict';

    var ExerciseController = function($scope, $translate, Exercise, Page, Sound) {

        Exercise.promise().then(function()
        {
            var audio = false;
            var model = $scope.page().html() ? $scope.page().html() : $scope.page().video().currentTiming().getModule('Html')[0];
            $scope.collection =  model.exercises();
            $scope.exercises = $scope.collection.all();

            if(model.getAttr('audio')) {
                audio = Sound.create({
                    src: 'audio/'+model.getAttr('audio')
                });

                audio.play();
            }

            $scope.$watch(function()
            {
                return $scope.collection.isBlocked();
            },
                function(value) {

                    if(!value) {
                        // $scope.page().viewed();
                    }
            });

            Page.events.on('change', function() {
               $scope.collection.callEach('cancel');

                if(audio) audio.pause();
            });


        });

    };

    ExerciseController.$inject = ['$scope', '$translate', 'Exercise', 'Page', 'Sound'];

    angular.module('Application')
        .controller('ExerciseController', ExerciseController);
})();

(function () {
  "use strict";

  var ExerciseCrociateController = function ($scope, $timeout,$filter) {
    function load() {
      // console.log($scope.exercise);

      //console.log("$scope.exercise", $scope.exercise);
    }

    $scope.isShowedPopup=false;

    $scope.showPopup=function(text){
        $scope.textPopup=text;
        $scope.isShowedPopup=true;    
    }
    $scope.closePopup=function(){
        $scope.textPopup="";
        $scope.isShowedPopup=false;    
    }

    $scope.selectCell = function (row, column) {

    
       if($scope.exercise.solution===true){
        return;
       } 
      //console.log(row, column)
      $scope.exercise.selectCell(row, column);
      $scope.limitClick = $scope.exercise.checkLimitClick();
        if (!$scope.limitClick){
           let foundedWord= $scope.exercise.checkCorrect();
           if (foundedWord!==false){
                var textFound=$filter('translate')('exerciseTemplate.textFound1') + " " + foundedWord;
                if ($scope.exercise.isEnded())
                    textFound=textFound+"<br>"+$filter('translate')('exerciseTemplate.textFound2')
                $scope.showPopup(textFound)
           }
                
        }else{
            $scope.showPopup($filter('translate')('exerciseTemplate.limitClick'))
        }
    };

    $scope.solution=function(){
        $scope.exercise.solution();
    }   
    load();
  };

  ExerciseCrociateController.$inject = ["$scope", "$timeout","$filter"];

  angular
    .module("Application")
    .controller("ExerciseCrociateController", ExerciseCrociateController);
})();


(function () {

    'use strict';

    var ExerciseSelectController = function ($scope, $timeout, $translate) {

        // console.log("ExerciseSelectController");

        function load() {
            
            // console.log("exercise select: ", $scope.exercise);

            // console.log("content", $scope.exercise.getAttr('content'));
            // console.log("options", $scope.exercise.getAttr('options'));

            // console.log(">>>",$scope.exercise.getAttr('content').match(/\[\[(\d+)\]\]/g));
            // console.log(">>>",$scope.exercise.getAttr('content').replace(/\[\[(\d+)\]\]/g, '$1'));
        }

        $scope.getSelectNumber = function() {
            var content = $translate.instant($scope.exercise.getAttr('content'));
            let matches = content.match(/\[\[(\d+)\]\]/g);
            return matches === null ? 0 : matches.length;
        };

        $scope.replaceContentItems = function() {
            var i, content = $translate.instant($scope.exercise.getAttr('content'));
            // console.log("content", content);
            for (i = 0; i < $scope.getSelectNumber(); i++) { 
                content = content.replace('[['+i+']]', $scope.getOption(i));
            }
            return content;
        };

        $scope.options = $scope.exercise.getAttr('options');
        // console.log($scope.options);

        $scope.getOption = function(index) {
            // console.log("---",$scope.exercise.getAttr('options'));
            var option = $scope.exercise.getAttr('options')[index];
            // if (index == 0) console.log("replaced option", index, option);
            var html = '<div class="dropdown dropdown'+index+'" ng-init="opened'+index+'=false;" ng-click="opened'+index+' = !opened'+index+'" ' + 
                ' ng-class="{\'open\': opened'+index+', \'correct\': (exercise.isConfirmed() && isOptionCorrect('+index+') || isSolutionVisible()) , \'wrong\': (exercise.isConfirmed() && !isOptionCorrect('+index+')) && !isSolutionVisible() }"><button class="dropbtn" ng-bind-html="getAnswer('+index+')"><i class="glyphicon glyphicon-triangle-bottom"></i> {{\'exerciseTemplate.select\'|translate}}</button><div class="dropdown-content" ng-mouseup="checkClick()">';
            _.each(option.items, function(item, itemIndex) {
                var itemText = $translate.instant(item.text);
                //var itemIcon = $translate.instant(item.icon);
                html += '<a href="#" ng-click="setAnswer(\''+itemText+'\', '+index+', '+itemIndex+')" ' +
                    ' ng-class="{\'correct\': exercise.isConfirmed() && isOptionRealCorrect('+index+', '+itemIndex+'), \'wrong\': exercise.isConfirmed() && !isOptionRealCorrect('+index+', '+itemIndex+')}"' +
                    '>'+ itemText +'</a>';
            });
            html += '</div></div>';
            return html;

            // <div class="dropdown" ng-init="opened1=false;" ng-click="opened1 = !opened1"
            //     ng-class="{'open': opened1}"
            // >
            //     <button class="dropbtn">Dropdown</button>
            //     <div class="dropdown-content">
            //         <a href="#">Link 1</a>
            //         <a href="#">Link 2</a>
            //         <a href="#">Link 3</a>
            //     </div>
            // </div>
        };



        $scope.isOptionCorrect = function(index) {
            return $scope.exercise.getAttr('options')[index].answer === $scope.exercise.getAttr('options')[index].match;
        }

        $scope.isOptionRealCorrect = function(index, itemIndex) {
            // console.log("TEST", $scope.exercise.getAttr('options')[index].match, itemIndex);
            return $scope.exercise.getAttr('options')[index].match == itemIndex;
        }

        var solutionVisible = false;

        $scope.showSolution = function() {
            _.each($scope.exercise.getAttr('options'), function(option, index) {
                // $('.dropdown'+index+' > .dropbtn').text(option);
                // console.log(option, index)
                //console.log(option.items[option.match], $translate.instant(option.items[option.match]))
                var text = '' + $translate.instant(option.items[option.match].text);
                // console.log("test", text);
                $('.dropdown'+index+' > .dropbtn').html(text);
            });
            solutionVisible = true;
        };

        $scope.isSolutionVisible = function() {
            return solutionVisible;
        };

        $scope.areAllCorrect = function() {
            var result = true;
            _.each($scope.exercise.getAttr('options'), function(option, index) {
                // $('.dropdown'+index+' > .dropbtn').text(option);
                // console.log(option, index)
                if (option.match != option.answer)
                    result = false;
                    return;
            });
            return result;
        };

        $scope.setAnswer = function(option, index, itemIndex) {
            if ($scope.exercise.isConfirmed()) return;
            //console.log("Set answer!", option, index, itemIndex);
            $('.dropdown'+index+' > .dropbtn').html(option);
            $scope.exercise.getAttr('options')[index].answer = itemIndex;
            // console.log(">!>",$scope.exercise.isAnswered());

            // console.log("exercise.isCorrect()", $scope.exercise.isCorrect());
        };

        $scope.getAnswer = function(index) {
            if (!$scope.exercise.isConfirmed()) {
                return '<i class="glyphicon glyphicon-triangle-bottom"></i> ' + $translate.instant('exerciseTemplate.select');
            } else {
                var i = $scope.exercise.getAttr('options')[index].answer;
                var text = $scope.exercise.getAttr('options')[index].items[i].text;
                //var icon = $scope.exercise.getAttr('options')[index].items[i].icon;
                // console.log(text);
                return '' + $translate.instant(text);
            }
            // console.log("getAnswer", index);
            // console.log($scope.exercise.getAttr('options')[index]);
        };

        $(window).on('mouseup', function (e) {
            // var container = $(".dropdown");
            _.each($(".dropdown"), function (cont, index) {
                if (!$(cont).is(e.target) && $(cont).has(e.target).length === 0) {
                    $scope['opened'+index] = false;
                }
            });
            $scope.$apply();
        });

        $(window).on('click', function (e) {
            //console.log(e.target);
        });

        var calcBoundaries = function () {
            //console.log($("#page")[0]);
            var rect0 = $("#page")[0].getBoundingClientRect();
            var rect1 = $(".dropdown7 > .dropdown-content")[0].getBoundingClientRect();
            //console.log(rect0);
            //console.log(rect1);

            if (rect1.bottom > rect0.bottom) console.log("outside");
        }


        $timeout(function () {
            // var overlap = !(rect1.right < rect2.left || 
            //     rect1.left > rect2.right || 
            //     rect1.bottom < rect2.top || 
            //     rect1.top > rect2.bottom)

            calcBoundaries();
        }, 2500);

        $scope.$watch(function () {
            return $scope.opened7;
        }, function (result) {
            if (result) {
                $timeout(function () {
                    calcBoundaries();
                }, 1500);
            }
        });


        load();

    };

    ExerciseSelectController.$inject = ['$scope', '$timeout', '$translate'];

    angular.module('Application')
        .controller('ExerciseSelectController', ExerciseSelectController);
})();

(function () {

    'use strict';

    var ExerciseSelectControllerOLD = function ($scope, $timeout, $translate) {

        // console.log("ExerciseSelectController");

        function load() {
            
            // console.log("exercise select: ", $scope.exercise);

            // console.log("content", $scope.exercise.getAttr('content'));
            // console.log("options", $scope.exercise.getAttr('options'));

            // console.log(">>>",$scope.exercise.getAttr('content').match(/\[\[(\d+)\]\]/g));
            // console.log(">>>",$scope.exercise.getAttr('content').replace(/\[\[(\d+)\]\]/g, '$1'));
        }

        $scope.getSelectNumber = function() {
            var content = $translate.instant($scope.exercise.getAttr('content'));
            let matches = content.match(/\[\[(\d+)\]\]/g);
            return matches === null ? 0 : matches.length;
        };

        $scope.replaceContentItems = function() {
            var i, content = $translate.instant($scope.exercise.getAttr('content'));
            // console.log("content", content);
            for (i = 0; i < $scope.getSelectNumber(); i++) { 
                content = content.replace('[['+i+']]', $scope.getOption(i));
            }
            return content;
        };

        $scope.options = $scope.exercise.getAttr('options');
        // console.log($scope.options);

        $scope.getOption = function(index) {
            // console.log("---",$scope.exercise.getAttr('options'));
            var option = $scope.exercise.getAttr('options')[index];
            // if (index == 0) console.log("replaced option", index, option);
            var html = '<div class="dropdown dropdown'+index+'" ng-init="opened'+index+'=false;" ng-click="opened'+index+' = !opened'+index+'" ' + 
                ' ng-class="{\'open\': opened'+index+', \'correct\': (exercise.isConfirmed() && isOptionCorrect('+index+') || isSolutionVisible()) , \'wrong\': (exercise.isConfirmed() && !isOptionCorrect('+index+')) && !isSolutionVisible() }"><button class="dropbtn" ng-bind-html="getAnswer('+index+')"><i class="glyphicon glyphicon-triangle-bottom"></i> {{\'exerciseTemplate.select\'|translate}}</button><div class="dropdown-content" ng-mouseup="checkClick()">';
            _.each(option.items, function(item, itemIndex) {
                var itemText = $translate.instant(item.text);
                var itemIcon = $translate.instant(item.icon);
                html += '<a href="#" ng-click="setAnswer(\'<span class=\\\'icon\\\'>'+itemIcon+'</span>'+itemText+'\', '+index+', '+itemIndex+')" ' +
                    ' ng-class="{\'correct\': exercise.isConfirmed() && isOptionRealCorrect('+index+', '+itemIndex+'), \'wrong\': exercise.isConfirmed() && !isOptionRealCorrect('+index+', '+itemIndex+')}"' +
                    '><span class="icon">' + itemIcon + '</span>'+ itemText +'</a>';
            });
            html += '</div></div>';
            return html;

            // <div class="dropdown" ng-init="opened1=false;" ng-click="opened1 = !opened1"
            //     ng-class="{'open': opened1}"
            // >
            //     <button class="dropbtn">Dropdown</button>
            //     <div class="dropdown-content">
            //         <a href="#">Link 1</a>
            //         <a href="#">Link 2</a>
            //         <a href="#">Link 3</a>
            //     </div>
            // </div>
        };



        $scope.isOptionCorrect = function(index) {
            return $scope.exercise.getAttr('options')[index].answer === $scope.exercise.getAttr('options')[index].match;
        }

        $scope.isOptionRealCorrect = function(index, itemIndex) {
            // console.log("TEST", $scope.exercise.getAttr('options')[index].match, itemIndex);
            return $scope.exercise.getAttr('options')[index].match == itemIndex;
        }

        var solutionVisible = false;

        $scope.showSolution = function() {
            _.each($scope.exercise.getAttr('options'), function(option, index) {
                // $('.dropdown'+index+' > .dropbtn').text(option);
                // console.log(option, index)
                console.log(option.items[option.match], $translate.instant(option.items[option.match]))
                var text = '<span class="icon">' + $translate.instant(option.items[option.match].icon) + '</span>' + $translate.instant(option.items[option.match].text);
                // console.log("test", text);
                $('.dropdown'+index+' > .dropbtn').html(text);
            });
            solutionVisible = true;
        };

        $scope.isSolutionVisible = function() {
            return solutionVisible;
        };

        $scope.areAllCorrect = function() {
            var result = true;
            _.each($scope.exercise.getAttr('options'), function(option, index) {
                // $('.dropdown'+index+' > .dropbtn').text(option);
                // console.log(option, index)
                if (option.match != option.answer)
                    result = false;
                    return;
            });
            return result;
        };

        $scope.setAnswer = function(option, index, itemIndex) {
            if ($scope.exercise.isConfirmed()) return;
            //console.log("Set answer!", option, index, itemIndex);
            $('.dropdown'+index+' > .dropbtn').html(option);
            $scope.exercise.getAttr('options')[index].answer = itemIndex;
            // console.log(">!>",$scope.exercise.isAnswered());

            // console.log("exercise.isCorrect()", $scope.exercise.isCorrect());
        };

        $scope.getAnswer = function(index) {
            if (!$scope.exercise.isConfirmed()) {
                return '<i class="glyphicon glyphicon-triangle-bottom"></i> ' + $translate.instant('exerciseTemplate.select');
            } else {
                var i = $scope.exercise.getAttr('options')[index].answer;
                var text = $scope.exercise.getAttr('options')[index].items[i].text;
                var icon = $scope.exercise.getAttr('options')[index].items[i].icon;
                // console.log(text);
                return '<span class="icon">' + $translate.instant(icon) + '</span>' + $translate.instant(text);
            }
            // console.log("getAnswer", index);
            // console.log($scope.exercise.getAttr('options')[index]);
        };

        $(window).on('mouseup', function (e) {
            // var container = $(".dropdown");
            _.each($(".dropdown"), function (cont, index) {
                if (!$(cont).is(e.target) && $(cont).has(e.target).length === 0) {
                    $scope['opened'+index] = false;
                }
            });
            $scope.$apply();
        });

        $(window).on('click', function (e) {
            //console.log(e.target);
        });

        var calcBoundaries = function () {
            console.log($("#page")[0]);
            var rect0 = $("#page")[0].getBoundingClientRect();
            var rect1 = $(".dropdown7 > .dropdown-content")[0].getBoundingClientRect();
            console.log(rect0);
            console.log(rect1);

            if (rect1.bottom > rect0.bottom) console.log("outside");
        }


        $timeout(function () {
            // var overlap = !(rect1.right < rect2.left || 
            //     rect1.left > rect2.right || 
            //     rect1.bottom < rect2.top || 
            //     rect1.top > rect2.bottom)

            calcBoundaries();
        }, 2500);

        $scope.$watch(function () {
            return $scope.opened7;
        }, function (result) {
            if (result) {
                $timeout(function () {
                    calcBoundaries();
                }, 1500);
            }
        });


        load();

    };

    ExerciseSelectControllerOLD.$inject = ['$scope', '$timeout', '$translate'];

    angular.module('Application')
        .controller('ExerciseSelectControllerOLD', ExerciseSelectControllerOLD);
})();

(function () {

    'use strict';

    var ExerciseSingleAccordionController = function ($scope, $timeout) {

        function load() {
            
        }

        var __currentCollapse = 0;

        $scope.isCurrentCollapse = function (index) {
            return __currentCollapse === index;
        };

        $scope.setAnswer = function (answer) {
            // if (!$scope.hasDone()) _answer = answer;
            // $scope.showOption(answer);
            // $scope.page().viewed();
            // //$rootScope.$emit('page.unblock');
            // //$scope.LMS.updatePages($scope.getIndexPage());
        };

        $scope.hoverOut = function (index) {
            return;
            //console.log("HoverOut");
            if (index === __currentCollapse) return;
            $('#collapse_' + index).collapse('hide');
        };

        $scope.setOption = function (index) {
            // return;
            __currentCollapse = index;
        };

        $scope.showOption = function (index) {
            return;
            console.log(index);
            __currentCollapse = index;
            $('.panel-collapse').collapse('hide');
            $('#collapse_' + __currentCollapse).collapse('show');

            // for (var i = 0; i < 3; i++) {
            //     $('#collapse_' + i).collapse(i == __currentCollapse ? 'show' : 'hide');
            // }
            // $scope.$apply();
        };

        load();
    };

    ExerciseSingleAccordionController.$inject = ['$scope', '$timeout'];

    angular.module('Application')
        .controller('ExerciseSingleAccordionController', ExerciseSingleAccordionController);
})();

(function () {

    'use strict';

    var ExerciseYesNoCounterController = function ($scope, $timeout, $translate, Page, Sound) {

        var audioEnd = false;

        $scope.currentRange = 0;

        function load() {}

        if ($scope.exercise.getAttr('audioEnd')) {
            audioEnd = Sound.create({
                src: $translate.instant($scope.exercise.getAttr('audioEnd'))
            });
        }

        $scope.getCounterValues = function () {
            return _.countBy($scope.exercise.getAttr('items'), function (item) {
                return item.answer;
            });
        };

        $scope.isRangeCompleted = function (pageIndex) {
            return _.filter($scope.exercise.getAttr('items'), function (item, index) {
                return Math.floor(index / $scope.exercise.getAttr('itemsPerPage')) === pageIndex && item.answer === undefined;
            }).length === 0;
        };

        $scope.totRanges = function () {
            return Math.ceil($scope.exercise.getAttr('items').length / $scope.exercise.getAttr('itemsPerPage'));
        };

        $scope.isLastRange = function () {
            return $scope.totRanges() - 1 === $scope.currentRange;
        };

        $scope.nextRange = function () {
            $scope.currentRange++;
        };

        $scope.selectRange = function (index) {
            $scope.currentRange = index;
        };

        $scope.isInRange = function (index) {
            return Math.floor(index / $scope.exercise.getAttr('itemsPerPage')) === $scope.currentRange;
        };

        $scope.setAnswer = function (item, index) {
            if ($scope.exercise.isAnswered() || $scope.exercise.isConfirmed())
                return;

            $scope.exercise.setAnswer(item, index);

            if ($scope.exercise.isAnswered()) {
                //console.log("CONFIRM");
                $scope.exercise.confirm();
                if (audioEnd) audioEnd.play();
            }
        };

        Page.events.on('change', function() {
            if (audioEnd) audioEnd.pause();
        });

        load();
    };

    ExerciseYesNoCounterController.$inject = ['$scope', '$timeout', '$translate', 'Page', 'Sound'];

    angular.module('Application')
        .controller('ExerciseYesNoCounterController', ExerciseYesNoCounterController);
})();

app.controller('LinksController', ['$scope', '$window', '$translate', 'App', 'MenuButton', 'Tracking', function ($scope, $window, $translate, App, MenuButton, Tracking) {

    // console.log("TEST");

    $scope.page().viewed();

    Tracking.update();

}]);

(function () {

    'use strict';

    var MainController = function (
        $scope,
        App,
        Menu,
        MenuButton,
        Page,
        Dispatcher,
        Exercise,
        Overlay,
        Subtitles,
        Helper,
        Video,
        Glossary,
        Translation,
        $compile,
        $timeout,
        $rootScope,
        $window,
        $translate,
        Tracking,
        $http
    ) {

        // inizializzo tutte le variabili quando
        // i file di configurazioni sono stati caricati
        App.promise.then(function () {

            $scope.App = App;
            $scope.Page = Page;
            $scope.menu = Menu;
            $scope.MenuButton = MenuButton;
            $scope.module = App.module();
            $scope.Exercise = Exercise;
            $scope.Overlay = Overlay;
            $scope.Subtitles = Subtitles;
            $scope.Helper = Helper;
            $scope.Glossary = Glossary;
            $scope.Translation = Translation;
            $scope.Video = Video;

            // get current video
            $scope.video = function () {

                if (!$scope.page())
                    return false;

                return $scope.page().video();
            };

            // shortcut to get current page
            $scope.page = function () {
                if (!$scope.lesson())
                    return false;

                return $scope.lesson().page();
            };

            // shortcut to get current lesson
            $scope.lesson = function () {
                if (!$scope.module())
                    return false;

                return $scope.module().lesson();
            };

            // shortcut to get current module
            $scope.module = function () {
                if (!App.module())
                    return false;
                return App.module();
            };

            Video.events.on('fullscreen', function () {
                var videocontrols = $('#video-controls').clone(true, true);
                videocontrols.attr('id', 'video-controls-update');
                videocontrols.removeAttr('ng-if');
                $compile(videocontrols)($scope);
                $('.video-js').append(videocontrols);
                $timeout(function () { $scope.$apply(); }, 1000);
            });

            Video.events.on('fullscreenOut', function () {
                $('#video-controls-update').remove();
                $timeout(function () { $(window).scrollTop() }, 1000);
            });

            App.events.on('module.close', function () {
                // console.log("Are all modules viewed?", App.areAllModulesViewed());
                Tracking.update();
            });

            $scope.$watch(function () {
                return (screen.availHeight || screen.height - 30) <= window.innerHeight;
            },
                function (value) {
                    if (!value) {
                        $('#video-controls-update').remove();
                    }
                });

            Video.events.on('ended', function () {
                //App.openMenu(true);

                // If it's the end of the module and
                // there are no exercises or timings,
                // close the module and go back to 
                // the modules index
                // if (
                //     (App.isAtLastPage() || !App.hasNextPage()) &&
                //     (!$scope.page().hasExercise() && !$scope.video().hasObligatoryTiming()) 
                // ) {
                //     App.closeModule();
                // }
                // $rootScope.$apply()
            });

            $scope.openLink = function (path) {
                $window.open($translate.instant(path), "_blank");
                return path;
            };

            $scope.loaded = false;
            $scope.hasLoaded = function () {
                return $scope.loaded;
            };

            function load() {
                // console.log('loading...');
                var to = $timeout(function () {
                    // if (!$scope.amIOverControls) {
                    $scope.loaded = true;
                    // console.log('loaded...', $scope.loaded);
                    // }
                }, 1500);
            }

            // load();

            App.events.on('module.open', function () {
                $scope.loaded = false;
                // console.log("module open: show controls");
                load();

                resizedw();
            });

            $scope.isOS = function () {
                return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            }

            // FIXME
            $timeout(function () {
                if (App.modules().count() == 1)
                    // App.goToModule(0);
                    App.goWhereYouLeft();
            }, 500);

            function fixLayoutRatioOLD() {
                var vRatio = 1920 / 1080; // 1.777
                // console.log("VideoRatio:  ", vRatio);

                var wW = $(window).width();
                var wH = $(window).height();
                var wRatio = wW / wH;
                // console.log("WindowRatio: ", wRatio);
                // console.log("Resize based on " + (wRatio > vRatio ? "HEIGHT" : "WIDTH"));

                $timeout(function () {
                    // if (wRatio > vRatio) {
                    // console.log("hLessons", $('#lessons').height());
                    // console.log("hWindow", $(window).height());

                    if ($(window).width() > 1280) {
                        // console.log("WINDWOW > 1200", "height: "+(1200/vRatio) );
                        // console.log("Current height would be: ", (1200 / vRatio), "(" ,((1200 / vRatio)*1.2 + 70), ")",  ((1200 / vRatio)*1.2 + 70) > $(window).height() ? "but it would be to high" : "and it's fine" );

                        if (((1200 / vRatio) * 1.2 + 70) > $(window).height()) {
                            $('#lessons').height(($(window).height() * 0.8));
                            $('#lessons').width((($(window).height() * 0.8) - 70) * vRatio);

                            // console.log("New ",(($(window).height()*0.8)-70) * vRatio,"x",($(window).height()*0.8)-70);
                        } else {
                            $('#lessons').width(1200);
                            $('#lessons').height((1200 / vRatio) + 70);
                        }

                        // if (($(window).height()*0.8) < (1200/vRatio)) {
                        //     console.log("VideoH ("+(1200/vRatio)+") > WindowH ("+($(window).height()*0.8)+")");

                        //     $('#lessons').width( (( ($(window).height()*0.8))*vRatio) );
                        // } else {
                        //     console.log("VideoH ("+(1200/vRatio)+") < WindowH ("+($(window).height()*0.8)+")");
                        //     $('#lessons').height( ( ( ($(window).width()) /vRatio) ) * 0.8 );
                        // }
                    } else {
                        // var newH = ( $('#lessons').width() / vRatio );
                        var newH = (($(window).width() * 0.9) + 70) / vRatio;
                        // console.log("newH", newH);
                        var wH = $(window).height();
                        if (newH > (wH)) {
                            // console.log("HERE");
                            $('#lessons').width((wH * vRatio));
                        } else {
                            // console.log("THERE");
                            // $('#lessons').width('90%');
                            $('#lessons').width($(window).width() * 0.9);
                            $('#lessons').height((($(window).width() * 0.9) / vRatio) + 70);
                        }
                    }

                    // console.log("*****************************");

                }, 500);

                var wW = $(window).width();
                var hW = $(window).height();

            }

            function fixLayoutRatio() {
                var vRatio = 1280 / 720; // 1.777
                var HEADER_FOOTER_HEIGHT = 75; /*($(window).width() < 769) || ($(window).height() < 599) ? 65 : 10*/; //;

                //let PERC_MARGIN = ($(window).width() < 769) || ($(window).height() < 599) ? 0 : 0.2; //;
                var PERC_MARGIN = 0;

                $timeout(function () {
                    if ($(window).width() / vRatio * (1 + PERC_MARGIN) + HEADER_FOOTER_HEIGHT > $(window).height()) {
                        var newH = $(window).height() * (1 - PERC_MARGIN);
                        var newW = (newH - HEADER_FOOTER_HEIGHT) * vRatio;
                        $('#lessons').height(newH - 10);
                        $('#lessons').width(newW - 10);
                    } else {
                        $('#lessons').width($(window).width() - 10);
                        $('#lessons').height(($(window).width() / vRatio + HEADER_FOOTER_HEIGHT) - 10);
                    }
                }, 500);
            }

            function getWindowWidth() {
                return ($(window).innerWidth() > 0) ? $(window).innerWidth() : $(window).width();
                return (window.innerWidth > 0) ? window.innerWidth : screen.width;
            }

            function getWindowHeight() {
                return ($(window).innerHeight() > 0) ? $(window).innerHeight() : $(window).height();
                return (window.innerHeight > 0) ? window.innerHeight : screen.height;
            }

            function fixLayoutMobile() {
                var newWidth = 0, newHeight = 0;
                // console.log("$(window).width() x $(window).height()",$(window).width(), $(window).height(), getWindowHeight()+70);

                if (getWindowWidth() / (getWindowHeight() - 70) < 1.77) {
                    // console.log("ALTEZZA");
                    newWidth = '100vw';
                    newHeight = 'calc(56.497175vw + 70px)';
                } else {
                    // alert("LARGHEZZA");
                    // console.log("LARGHEZZA");
                    newWidth = 'calc((100vh - 70px) * 1.77)';
                    newHeight = '100%';
                }
                $timeout(function () {
                    $('#lessons').css({
                        // 'width': '100%',
                        // 'height': '100%',
                        // 'height': 'calc(56.497175vw + 70px)'
                        'width': newWidth,
                        'height': newHeight,
                    });
                }, 550);
            }

            function resizedw() {

                $timeout(function () {
                    // alert(">",getWindowHeight());
                    // alert("wx> " + $(window).width());
                    // alert("hx> " + $(window).height());
                    // // alert("y> " + $(window).innerHeight());
                    // alert("lessons> " + $('#lessons').innerHeight());
                    // alert("DPR "+window.devicePixelRatio);

                    // if (getWindowWidth() > 1024 && getWindowHeight() > 640) {
                    if ($(window).width() > 1024 && $(window).height() > 640) {
                        // console.log("resize");
                        fixLayoutRatio();
                    } else {
                        fixLayoutMobile();
                    }
                }, 1000);
            }

            var doit;
            $(window).resize(function () {
                clearTimeout(doit);
                doit = setTimeout(resizedw, 100);

                // if (getWindowWidth() > 1024 && getWindowHeight() > 640) {
                //     console.log("resize");
                //     fixLayoutRatio();
                // } else {
                //     $timeout(function() {
                //         $('#lessons').css({
                //             'width': '100%',
                //             'height': '100%',
                //         });
                //     }, 550);
                // }

                // var hIndex = $('#indice').width();
                // console.log("Indice",$('#indice').width());

                // var hVideoControls = $('#header .head-video-controls').width();
                // console.log("Width",$('#header .head-video-controls').width());

                // var hWindow = $(window).width();

                // $('#header .head-title > h2').width(hWindow - (hIndex + hVideoControls + 75));
                // console.log("newheadtitle", hWindow - (hIndex + hVideoControls));
            });

            $timeout(function () {
                if (getWindowWidth() > 1024) {
                    fixLayoutRatio();
                }
                resizedw();
            }, 1000);

            // fixLayoutRatio();
            resizedw();

            $scope.randomBgColor = false;
            $scope.getRandomBgColor = function () {
                if (!$scope.randomBgColor)
                    $scope.randomBgColor = 'bg-color-0' + ((Math.round(Math.random() * 10) % 4) + 1);
                return $scope.randomBgColor;
            };

            Page.events.on('change', function () {
                $scope.randomBgColor = false;
                reloadControllerVar();
            });

            $scope.reloadVar = true;
            function reloadControllerVar() {
                $scope.reloadVar = false;
                $timeout(() => { $scope.reloadVar = true; }, 100);
            }

            App.events.on('menu.change', () => {
                reloadControllerVar();
            });

            // $http.get('config/locales/locale-it.json').success(function (data) {
            //     const final = Object.values(data.modules).map(module => {
            //         return Object.values(module.lessons.all.pages).map(page => page.video);
            //     });
            //     console.log(final.flat(1)); // all video codes in locale-it
            // });
        });
    }

    MainController.$inject = [
        '$scope',
        'App',
        'Menu',
        'MenuButton',
        'Page',
        'Dispatcher',
        'Exercise',
        'Overlay',
        'Subtitles',
        'Helper',
        'Video',
        'Glossary',
        'Translation',
        '$compile',
        '$timeout',
        '$rootScope',
        '$window',
        '$translate',
        'Tracking',
        '$http'
    ];

    angular.module('Application')
        .controller('MainController', MainController);

})();

(function () {

    'use strict';

    var MappableController = function ($scope, $translate, $injector, $timeout, $window, App, Page, Subtitles, Tracking, Detailed, Overlay, Translation) {

        $scope.isDevelMode = App.config().getAttr('layout').debugDetailed;

        function load() {

            var model = $scope.page().html() ?
                $scope.page().html() :
                (
                    $scope.page().video().currentTiming() ?
                    $scope.page().video().currentTiming().getModule('Html')[0] :
                    null
                );

            if (!model) return model;

            $scope.isDevelMode = model.getAttr('develMode') || $scope.isDevelMode;

            $scope.image = model.getAttr('image');

            $scope.openOverlay = function (obj) {

                if ($scope.isDevelMode) return; // FIXME

                if (obj.getAttr('nextPage')) {
                    Page.next()
                    return obj;
                }

                if (obj.getAttr('pdf')) {
                    $window.open($translate.instant(obj.getAttr('pdf')), "_blank");
                    obj.open();
                    Overlay.close();
                    return obj;
                }

                if (obj.getAttr('link')) {
                    $window.open($translate.instant(obj.getAttr('link')), "_blank");
                    obj.open();
                    Overlay.close();
                    return obj;
                }

                if (obj.getAttr('href')) {
                    $window.open($translate.instant(obj.getAttr('href')), "_blank");
                    obj.open();
                    Overlay.close();
                    return obj;
                }

                obj.open();
            };

            $scope.areDetailsAllViewed = function () {
                return false;
                return !!!_.filter($scope.page().video().currentTiming().details(), function (detail) {
                    return !detail.viewed();
                }).length;
            };

        }

        Page.events.on('change', function () {
            load();
        });

        load();

        var resize = function (openSubtitle) {
            // $scope.parentContainerWidth = openSubtitle ? window.innerWidth * 70 / 100 : window.innerWidth
            // //$scope.parentContainerWidth = window.innerWidth
            // //console.log("$scope.parentContainerWidth", $scope.parentContainerWidth)
            // $scope.parentContainerHeight = window.innerHeight - 85;
            // //console.log("$scope.parentContainerHeight", $scope.parentContainerHeight)
            // /* spazi neri sopra/sotto video  */
            // //$scope.containerWidth = window.innerWidth;

            // $scope.containerWidth = openSubtitle ? window.innerWidth * 70 / 100 : window.innerWidth
            // //$scope.containerHeight = window.innerWidth * 0.5625;
            // $scope.containerHeight = $scope.containerWidth * 0.5625;
            // /* spazi neri sinistra/destra video  */
            // if ($scope.containerHeight > window.innerHeight - 85) {
            //     $scope.containerHeight = window.innerHeight - 85;
            //     $scope.containerWidth = (window.innerHeight - 85) * 1.777;  // 1.777 = 1920 / 1080 = 1280 / 720;

            // }

            // $scope.containerHeight = window.innerHeight - 85;
            // $scope.containerWidth = (window.innerHeight - 85) * 1.777;  // 1.777 = 1920 / 1080 = 1280 / 720;
        }

        window.onresize = function () {
            $timeout(function () {
                resize(Subtitles.panel.isOpened());
                $scope.$apply();
            }, 0);
        };
        resize(Subtitles.panel.isOpened());

        Subtitles.panel.on("open", function () {
            $timeout(function () {
                resize(true);
                $scope.$apply();
            }, 0);
        });
        Subtitles.panel.on("close", function () {
            $timeout(function () {
                resize();
                $scope.$apply();
            }, 0);
        });


        $(document).on('keydown', function (e) {
            if (e.keyCode === 27) { // ESC
                // console.log(Overlay.isOpened());
                Overlay.close();
                $scope.$apply();
            }
        });

        $scope.isDraggable = false;

        $timeout(function () {
            if ($scope.isDevelMode) {


                $scope.isDraggable = true;
                $scope.toggleDraggable = function () {
                    if ($scope.isDraggable) {
                        // $('.container__clickable-area').draggable({ disabled: true });
                        $('.container__clickable-area').draggable("disable");
                    } else {
                        $('.container__clickable-area').draggable("enable");
                    }
                    $scope.isDraggable = !$scope.isDraggable;
                };
                
                // $('.container__clickable-area').draggable({ disabled: true });
        
                // $('.container__clickable-area').draggable("enable");

                //console.log("Devel mode on!");
                $('.container__clickable-area').draggable({
                    drag: function () {
                        //console.log($(this).parent().width(), $(this).parent().height());

                        var offset = $(this).offset();
                        var xPos = offset.left;
                        var yPos = offset.top;


                        //console.log("w", $(this).outerWidth());
                        //console.log("h", $(this).outerHeight());

                        // console.log("xPos", xPos);
                        // console.log("yPos", yPos);
                        // console.log("xPos (-parent)", xPos - $(this).parent().offset().left);
                        // console.log("yPos (-parent)", yPos - $(this).parent().offset().top);
                        // console.log("PERC% W: ", (((xPos - $(this).parent().offset().left) * 100) / $(this).parent().width()));
                        // console.log("PERC% H: ", (((yPos - $(this).parent().offset().top) * 100) / $(this).parent().height()));

                        // console.log("coords",$('#coords-container', this).length);
                        if ($('body #coords-container').length == 0) {
                            jQuery('<div/>', {
                                id: 'coords-container'
                            }).appendTo('body');
                        }
                        $('#coords-container').html(
                            "<div><strong>\"top\"</strong>: \"" + Math.round((((yPos - $(this).parent().offset().top) * 100) / $(this).parent().height()) * 100) / 100 + "%\",</div>" +
                            "<div><strong>\"left\"</strong>: \"" + Math.round((((xPos - $(this).parent().offset().left) * 100) / $(this).parent().width()) * 100) / 100 + "%\",</div>"

                            +
                            "<div><strong>\"width\"</strong>: \"" + Math.round((($(this).outerWidth() * 100) / $(this).parent().width()) * 100) / 100 + "%\",</div>" +
                            "<div><strong>\"height\"</strong>: \"" + Math.round((($(this).outerHeight() * 100) / $(this).parent().height()) * 100) / 100 + "%\"</div>"
                        );
                    }
                });
            }

        }, 1500);
    };

    MappableController.$inject = ['$scope', '$translate', '$injector', '$timeout', '$window', 'App', 'Page', 'Subtitles', 'Tracking', 'Detailed', 'Overlay', 'Translation'];

    angular.module('Application')
        .controller('MappableController', MappableController);

})();

app.controller('MenuController', ['$scope', 'App', 'MenuButton', 'Overlay', function ($scope, App, MenuButton, Overlay) {
        $scope.App = App;
        $scope.MenuButton = MenuButton;
        $scope.Overlay = Overlay;
    }]);

(function () {

    'use strict';

    var ModulesController = function ($scope, $translate, $injector, $timeout, $window, App, Page, Subtitles, Tracking, Detailed, Overlay, Translation) {

        $scope.getModuleLine = function (index) {
            return Math.floor(  ((index + 1) / 3) + 1);
        };

        $scope.getModulePosition = function (index) {
            return ((index + 1) % 3) + (index > 1 ? 1 : 0);
        };

        $scope.getIconClassByModuleIndex = function(index){
            if (App.modules().get(index).isViewed()){
                return 'viewed';
            //}else if((index === 1) || (App.modules().get(index-1).isViewed())){
            }else if((index === 0) || (App.modules().get(index-1) && (App.modules().get(index-1).isViewed()))){
                return '';
            }
            return 'locked';
        }

        $scope.isDisabled = function (index) {

            // if (App.config().isFree()){
            //     return false;
            // }

            if (index >= 1) {
                return !App.modules().get(index-1).isViewed();
            }
            return false;
        };

        $scope.openPdf = function(doc){
            $window.open(doc, "_blank");
        }

        $scope.openModule = function (index) {
            
            if ($scope.isDisabled(index) && !App.config().isFree()){

                if (index>1 && index<6 && App.modules().get(1).isViewed()){
                    //console.log("index",index)
                }else{
                    return false;
                }
            }
            App.goToModule(index, true);
        };

        $scope.isCompleted=function(){
            //console.log("Tracking.isCompleted()",Tracking.isCompleted())
            if (Tracking.isCompleted()==="incomplete"){
                return false
            }else{
                return true
            }
            //return Tracking.isCompleted()
        }

        $scope.goToTop = function () {
            $("#modules").animate({ scrollTop: 0 }, 800);
            return false;
        };

        $scope.openExternalModule = function (module) {
            $window.open(module.getAttr('external'), "_blank");
            module.setViewed();
            App.setResumed(); // If not, resume panel is opened (!)
        };

        $timeout(function () {
            //setModulesSliceWidth();
            $scope.$apply();

            $('.modules-list').addClass('modules-collaped');

            $timeout(function () {
                $('#loader').addClass('hide');
            }, 50);

            $timeout(function () {
                $('.modules-list').addClass('modules-loaded');
            }, 2000);
        }, 1000);

        window.onresize = function () {
            $timeout(function () {
                //setModulesSliceWidth();
                $scope.$apply();
            }, 0);
        };
        //setModulesSliceWidth();

        $(document).on('keydown', function (e) {
            if (e.keyCode === 27) { // ESC
                // console.log(Overlay.isOpened());
                Overlay.close();
                $scope.$apply();
            }
        });
    };

    ModulesController.$inject = ['$scope', '$translate', '$injector', '$timeout', '$window', 'App', 'Page', 'Subtitles', 'Tracking', 'Detailed', 'Overlay', 'Translation'];

    angular.module('Application')
        .controller('ModulesController', ModulesController);

})();

(function(){

	'use strict';

	var ResourcesController = function($scope, $translate, App, Page, Exercise, Sound, Tracking, Translation, $window) {

        var audio = false;

        function load() {
            var model = $scope.page().html() ?
            $scope.page().html() : ($scope.page().video().currentTiming() ? $scope.page().video().currentTiming().getModule('Html')[0] : null);
    
            if(!model) return;

            if (model.getAttr('viewedOnLoad')) {
                $scope.page().viewed();
            }

            if (model.getAttr('audio')) {
                audio = Sound.create({
                    src: model.getAttr('audio')
                });
                
                audio.play();
            }

            Page.events.on('change', function() {
                if(audio) {
                    audio.pause();
                    audio = false;
                }
            });

            App.events.on('module.close', function() {
                if(audio) {
                    audio.pause();
                    audio = false;
                }
            });

        }

        $scope.downloadFile = function(obj) {
            $window.open(obj.target.attributes.href.value);
            $scope.page().viewed();
        };

        load();
	};

	ResourcesController.$inject = ['$scope', '$translate', 'App', 'Page', 'Exercise', 'Sound', 'Tracking', 'Translation', '$window'];

	angular.module('Application')
		.controller('ResourcesController', ResourcesController);

})();

app.controller('SynthesisController', ['$scope', '$window', '$translate', 'App', 'MenuButton', 'Overlay', function ($scope, $window, $translate, App, MenuButton, Overlay) {

    // console.log("TEST");

    $scope.openLink = function(path) {
        // console.log("Open Link");
        $window.open($translate.instant(path), "_blank");

        $scope.page().viewed();

        return path;
    };

}]);

(function () {

    'use strict';

    var TemplateController = function ($scope, $translate, $timeout, App, Page, Video, Exercise, Sound) {

        var __showReport = false;
        var __showRecap = false;
        var __answersGiven = false;
        var __showRecapMessage = false;
        var __canEdit = false;

        var closeModTimeout;
        
        var audio = false;

        function load() {

            // console.log("TemplateController.load()");

            Exercise.promise().then(function () {
                audio = false;

                var model = $scope.page().html() ?
                    $scope.page().html() : ($scope.page() && $scope.page().video() && $scope.page().video().currentTiming() ? $scope.page().video().currentTiming().getModule('Html')[0] : null);

                if (!model) return;
                var exerciseIndex = model.getAttr('Exercise');

                $scope.collection = Exercise.getById(exerciseIndex);
                $scope.collection = $scope.collection.limit(10);
                $scope.pages = App.lesson().pagesWithExercises();
                $scope.pageIndex = _.indexOf($scope.pages, $scope.page());

                //console.log("audio" + model.getAttr('audio'))

                // if (model.getAttr('audio')) {
                //     // console.log("audio" + model.getAttr('audio'))
                //     audio = Sound.create({
                //         src: $translate.instant(model.getAttr('audio'))
                //     });
                //     // console.log("audio", audio);
                //     audio.play();
                // }

                $scope.isBlocked = function () {
                    var _return = false;
                    _.each($scope.collection.all(), function (el) {
                        if (!el.isConfirmed()) {
                            _return = true;
                            return;
                        }
                    });
                    return _return;
                }

                $scope.$watch(function () {
                    return $scope.isBlocked();
                },
                    function (value) {
                        if (!value) {
                            // $scope.page().viewed();
                            //console.log("feedback qui")

                            if (!$scope.collection.current().getAttr('feedback')) {
                                if (!$scope.video().ended()) {
                                    $scope.page().video().play();
                                } else if (App.hasNextPage()) {
                                    Page.next();
                                } else {
                                    $scope.showReport();
                                }
                            }
                        }
                    });

                $scope.calcPerc = function () {
                    var number = $scope.collection.getCurrentNumber() - 1;
                    return ((number * 100) / $scope.collection.count());
                };
            });

        }

        // console.log("TemplateController");

        $scope.showReport = function () {
            __showReport = true;
            __showRecap = false;
            __showRecapMessage = false;
            $scope.passed = $scope.collection.count('isCorrect');
        };

        $scope.showRecap = function () {
            __showRecap = true;
            __showReport = false;
            __showRecapMessage = false;
        };

        $scope.retry = function () {
            _.each($scope.collection.all(), function (exercise) {
                exercise.cancel();
            });
            $scope.collection.atStart();
            $scope.collection = null;

            load();

            __showRecap = false;
            __showReport = false;
            __showRecapMessage = false;
            __canEdit = true;
        };

        $scope.showRecapMessage = function () {
            __showReport = false;
            __showRecap = false;
            __showRecapMessage = true;
        }

        $scope.isReportVisible = function () {
            return __showReport;
        };

        $scope.isRecapVisible = function () {
            return !$scope.isReportVisible() && __showRecap;
        };

        $scope.isRecapMessageVisible = function () {
            return !$scope.isReportVisible() && __showRecapMessage;
        };

        $scope.viewAnswersGiven = function () {
            __answersGiven = true;
            __showReport = false;
            $scope.collection.atStart();
        };

        $scope.hideAnswersGiven = function () {
            __answersGiven = false;
            __showReport = true;
            $scope.collection.atStart();
        };

        $scope.canViewAnswersGiven = function () {
            return __answersGiven;
        };

        // Page.events.on('change.pre', function () {
        //     if (!$scope.isBlocked()) $scope.page().viewed();
        // });

        Page.events.on('change', function () {
            load();
        });

        // App.events.on('menu.change', function () {
        //     load();
        // });

        App.events.on('module.close', function () {
            $timeout.cancel(closeModTimeout);
        });

        Video.events.on('play', function () {
            
        });

        load();

    };

    TemplateController.$inject = ['$scope', '$translate', '$timeout', 'App', 'Page', 'Video', 'Exercise', 'Sound'];

    angular.module('Application')
        .controller('TemplateController', TemplateController);
})();

(function () {
    "use strict";

    var TemplateQuestionController = function (
        $scope,
        $translate,
        App,
        Page,
        Video,
        Exercise,
        Sound,
        AudioService
    ) {
        var audio = null;

        $scope.startTimerEx = false;
        $scope.timeOver = false;
        $scope.solutionVisible = false;
        $scope.feedback = false;
        // console.log("CONTROLLER");

        $scope.loadAudio = function () {
            // console.trace();
            $scope.startTimerEx = false;
            var exercise = $scope.collection.current();
            stopAudio();
            // console.log("***",exercise.getAttr('audio'));
            var audioSrc = exercise.getAttr("audio");
            if (audioSrc) {
                stopAudio();
                playAudio($translate.instant(audioSrc));

                // audio.bind("ended", function () {
                AudioService.onAudioEnded(function () {
                    //console.log("Audio finished playing");
                    $scope.startTimerEx = true;
                    if (!$scope.$$phase) {
                        // If not in a digest cycle, use $apply
                        $scope.$apply(function () {
                            $scope.startTimerEx = true;
                        });
                    } else {
                        // Already in digest cycle, use $digest
                        $scope.startTimerEx = true;
                    }
                    // this.unbind("ended");
                    // console.log($scope.startTimerEx);
                });
            }
        };

        $scope.$watch(function () {
            return $scope.isSolutionVisible() && $scope.collection.isAtTheEnd();
        }, function (value) {
            if (value) {
                $scope.page().viewed();
            }
        });
      
        $scope.loadAudioNext = function () {
            // debugger;
            stopAudio();
            var exercise = $scope.collection.current();

            var audioSrc = exercise.getAttr("audio");
            if (audioSrc) {
                audio = Sound.create({
                    src: $translate.instant(audioSrc),
                });
                audio.play();
            }
        };
        function isRowGridVariant() {
            const ex = $scope.collection.current();
            return !!(ex && ex.getAttr && ex.getAttr('uiVariant') === 'row-grid');
          }
          
          // Seleziona tutte le corrette nei CHOICES, cercando di usare
          // gli stessi riferimenti delle opzioni; se non combaciano, match per id.
          function selectAllCorrectAnswers() {
            const ex = $scope.collection.current();
            if (!ex) return;
          
            const corrects = (ex.corrects && ex.corrects()) || [];
            const options = ex.getAttr('options') || [];
          
            const mapped = corrects.map(function(c){
              if (!c) return null;
          
              // Se corrects è una lista di id
              if (typeof c === 'string' || typeof c === 'number') {
                return options.find(function(o){ return o.id === c; }) || null;
              }
          
              // Se corrects è lista di oggetti: prova a matchare per id
              if (c.id != null) {
                return options.find(function(o){ return o.id === c.id; }) || c;
              }
          
              // Fallback: prova per riferimento
              return (options.indexOf(c) !== -1) ? c : null;
            }).filter(Boolean);
          
            ex.setAttr('choices', mapped);
          }
          
        $scope.timeOverHandler = function () {
            //console.log("here");
            $scope.timeOver = true;
            const exercise = $scope.collection.current();
            exercise.repeat();
            exercise.repeat();
            exercise.repeat();
            exercise.setAttr("confirm", true);
            playAudio("it/sbagliata");
          
        };
      
          
      
        $scope.timeOverHandlerMultiple = function () {
            debugger;
            $scope.timeOver = true;
            const exercise = $scope.collection.current();
            // exercise.repeat();
            // exercise.repeat();
            // exercise.repeat();
            exercise.setAttr("confirm", true);
            if ((exercise.getAttr("template") == "multiple-order")) {
                console.log("here");
                selectAllCorrectAnswers();
                $scope.solutionVisible = true;  // fa apparire subito la soluzione
                $scope.$evalAsync();            // forza digest per riflettere i changes in UI
              }
            playAudio("it/sbagliata");
           
        };

        $scope.timeOverHandlerYesNo = function () {
            //console.log("Time over - showing solution");
            // Confirm the answer and mark exercise as completed
            $scope.confirmed = true;

            // Mark the time over flag, which can be used in the template to show the correct solution
            $scope.timeOver = true;

            // Show the correct solution (if it's multiple choice, display the right options)
            const exercise = $scope.collection.current();
            exercise.setAttr("confirm", true);
            exercise.setAttr("solution", true);
            playAudio("it/sbagliata");
            // If needed, you can trigger solution logic here
            $scope.solution();
            // exercise.solution();
        };

        $scope.confirm = function () {
            //debugger;
            var exercise = $scope.collection.current();
            exercise.confirm();
            stopAudio();

            var audioLocale = exercise.isCorrect() ? "it/corretta" : "it/sbagliata";
            if ((exercise.getAttr("template") == "multiple-order") && !exercise.isCorrect() && !exercise.isRepeatable()) {
                selectAllCorrectAnswers();
                $scope.solutionVisible = true;
                $scope.$evalAsync();
              }

        
            playAudio(audioLocale);

            if (exercise.isCorrect()) {
                $scope.timerState.timeStarted = false;
            }
        };

        $scope.confirmAndNext = function () {
            var exercise = $scope.collection.current();
            exercise.confirm();
            if (App.hasNextPage()) {
                Page.next();
            }
        };

        $scope.answerAndNext = function (a) {
            const exercise = $scope.collection.current();
            exercise.setAnswer(a, $scope.isRecapVisible());

            if (!exercise.getAttr("feedback")) {
                if (!$scope.video().ended()) {
                    $scope.page().video().play();
                } else if (App.hasNextPage()) {
                    Page.next();
                } else {
                    $scope.showReport();
                }
            }
        };

        // Per clickonimage exercise (calculate image aspect ratio)
        $scope.getClickOnImageRatio = function () {
            const exercise = $scope.collection.current();
            const aspectRatio = exercise.getAttr('imageSizes') ? (exercise.getAttr('imageSizes').w / exercise.getAttr('imageSizes').h) : (1920 / 1080);
            return `aspect-ratio: ${aspectRatio};    background-color: rgba(0, 255, 255, 0.33)`;
        };

        // --------------------------------------------------------------------------------------
        // MULTIPLE -----------------------------------------------------------------------------

        $scope.checkOption = function (option) {
            const exercise = $scope.collection.current();
            if (exercise.isConfirmed()) return;

            var choices = exercise.getAttr("choices");
            if ($scope.isChecked(choices, option)) {
                choices.splice(choices.indexOf(option), 1);
                // console.log("REMOVE", $scope.collection.current().getAttr('choices'));

                // var filtered = _.filter($scope.collection.current().getAttr('choices'), function(item) {
                //     return item !== option
                // });
                // console.log(filtered);
            } else {
                // console.log("ADD", $scope.collection.current().getAttr('choices'));
                // console.log($scope.collection.current());
                if (choices === false) {
                    exercise.setAttr("choices", []);
                }
                exercise.getAttr("choices").push(option);
            }
        };

        $scope.isOptionCorrect = function (option) {
            return $scope.collection.current().corrects().indexOf(option) !== -1;
        };

        $scope.isChecked = function (choices, option) {
            if (choices === false) return false;
            return choices.indexOf(option) !== -1;
        };

        $scope.isAtLeastOneChecked = function () {
            const exercise = $scope.collection.current();
            return exercise.getAttr("choices").length >= 1;
        };

        $scope.nextExerciseHandler = function () {
            $scope.currentExercise = $scope.collection.current();
            $scope.collection.next();
        };

        // $scope.isRepeatable = function() {
        //     return $scope.collection.current().getAttr('repeat') > 0;
        //     var ex = $scope.collection.current();
        //     var repeat = ex.getAttr('repeat');
        //     ex.setAttr('repeat', repeat - 1);
        // };

        $scope.retry = function () {
            const exercise = $scope.collection.current();
            exercise.repeat();
        };

        $scope.checkAnswer = function () {
            var exercise = $scope.collection.current();
            var audioLocale = "it/sbagliata";

            // If there's already an audio instance, stop it before creating a new one
            stopAudio();

            // Check if the current answer is correct
            if (exercise.isCorrect() /*|| !exercise.isRepeatable()*/) {
                $scope.timerState.timeStarted = false;
                audioLocale = "it/corretta";
            }
            // Now create and play the new audio if `audioLocale` exists
            if (audioLocale) {
                // Create a new Sound instance
                playAudio(audioLocale);
                // Check if the audio was successfully created, then play it
                // if (audio) {
                //     audio.play();
                // } else {
                //     console.error("Audio creation failed!");
                // }
            }
        };

        $scope.gotoNextQuestion = function () {
            $scope.stopAudio();
            $scope.loadAudio();
        };

        // Assicura che choices sia un array all'uso
function ensureChoicesArray() {
    const ex = $scope.collection.current();
    if (!ex) return;
    if (!angular.isArray(ex.getAttr('choices'))) {
      ex.setAttr('choices', []);
    }
  }
  
  // È già selezionata?
  $scope.isOptionSelected = function(option) {
    const ex = $scope.collection.current();
    if (!ex) return false;
    const ch = ex.getAttr('choices') || [];
    return ch.indexOf(option) !== -1;
  };
  
  // Toggle dalla griglia in basso
  $scope.toggleOption = function(option) {
    const ex = $scope.collection.current();
    if (!ex || ex.isConfirmed()) return;
  
    ensureChoicesArray();
    const ch = ex.getAttr('choices');
  
    const idx = ch.indexOf(option);
    if (idx !== -1) {
      ch.splice(idx, 1);         // deseleziona
    } else {
      ch.push(option);           // aggiungi (nessun limite)
    }
  };
  
  // Rimuovi da riga superiore
  $scope.removeChoiceAt = function(idx) {
    const ex = $scope.collection.current();
    if (!ex || ex.isConfirmed()) return;
  
    const ch = ex.getAttr('choices') || [];
    if (idx >= 0 && idx < ch.length) ch.splice(idx, 1);
  };
        // fine MULTIPLE -----------------
        // -------------------------------

        $scope.resetTimer = function () {
            $scope.timerState.timeStarted = true;

            //$scope.timerState.timeElapsed=0;
            $scope.timerState.initialTimerMs = 0.5 * 60 * 1000;
            $scope.startTimerEx = false;
            $scope.$broadcast("RESTART_TIMER");
        };

        $scope.resetTimerStop = function () {
            $scope.timerState.timeStarted = true;
            $scope.timerState.timeElapsed = 0;
            $scope.timerState.initialTimerMs = 0.5 * 60 * 1000;
            $scope.startTimerEx = false;
            $scope.$broadcast("RESTART_TIMER");
        };

        $scope.solution = function () {
            var exercise = $scope.collection.current();
            // se l'esercizio è corretto o i tentativi sono finiti,
            // mostra la soluzione
            if (exercise.isCorrect() || !exercise.isRepeatable() || $scope.timeOver) {
                $scope.solutionVisible = true;
            }
        };

        $scope.isSolutionVisible = function () {
            const exercise = $scope.collection && $scope.collection.current();
            if (!exercise) return false;
            return (
                $scope.solutionVisible ||
                (exercise.isConfirmed() && exercise.isCorrect() && exercise.getAttr("template") != "card") ||
                (exercise.isConfirmed() && !exercise.isCorrect() && !exercise.isRepeatable() && exercise.getAttr("template") != "card") ||
                (exercise.getAttr("template") == "card" &&
                    !!exercise.getAttr("allCardClicked"))
            );
        };

        $scope.stopAudio = function () {
            stopAudio();
        };

        function stopAudio() {
            // if (audio) {
            //     audio.pause();
            //     audio.unbind("ended");
            //     audio = null;
            // }
            AudioService.stopAudio();
        }

        // Funzione per riprodurre l'audio in base alla locale
        function playAudio(audioLocale) {
            // if (audioLocale) {
            //     audio = Sound.create({ src: audioLocale });
            //     audio.play();
            // }
            AudioService.playAudio(audioLocale);
        }

        function load() {
            // debugger;
            // $scope.startTimerEx=false;

            const currentExercise = $scope.collection.current();
            const timerValue = currentExercise && currentExercise.getAttr('timerValue')
            const isMultipleOrder = currentExercise && currentExercise.getAttr && currentExercise.getAttr('template') === 'multiple-order';
            var defaultMs = 0.5 * 62 * 1000;
            $scope.timerState = {
                timeStarted: true,
                timeElapsed: 0,
                initialTimerMs: isMultipleOrder
                ? 1.5 * 60 * 1000                
                : (currentExercise.getAttr('timerValue') || defaultMs),
            };
            ensureChoicesArray();
            $scope.loadAudio();
            //console.log($scope.startTimerEx);

            Page.events.on("change", function () {
                stopAudio();
                $scope.startTimerEx = false;
                // $scope.loadAudio();
                // load();
            });

            App.events.on('menu.change', function () {
                // console.log("menuchange");
                // // stopAudio();
                $scope.startTimerEx = false;
                // load();
                // $scope.loadAudio();
            });

            App.events.on("module.close", function () {
                stopAudio();
            });

            Video.events.on("play", function () {
                stopAudio();
            });
        }

        // Carica gli esercizi una volta risolta la promessa
        Exercise.promise().then(function () {
            load();
            // $scope.loadAudio();
        });
    };

    TemplateQuestionController.$inject = [
        "$scope",
        "$translate",
        "App",
        "Page",
        "Video",
        "Exercise",
        "Sound",
        "AudioService"
    ];

    angular
        .module("Application")
        .controller("TemplateQuestionController", TemplateQuestionController)
        .service("AudioService", ["Sound", function (Sound) {
            var currentAudio = null;

            // Funzione per caricare e riprodurre un nuovo audio
            this.playAudio = function (audioSrc) {
                this.stopAudio();
                // console.log("AudioService.playAudio", audioSrc);
                if (audioSrc) {
                    currentAudio = Sound.create({ src: audioSrc });
                    currentAudio.play();
                }
            };

            // Funzione per interrompere l'audio corrente
            this.stopAudio = function () {
                // console.log("AudioService.stopAudio", currentAudio);
                if (currentAudio) {
                    currentAudio.pause();
                    currentAudio.unbind("ended");
                    currentAudio = null;
                }
            };

            // Funzione per legare eventi al termine dell'audio
            this.onAudioEnded = function (callback) {
                if (currentAudio) {
                    currentAudio.bind("ended", function () {
                        callback();
                        currentAudio.unbind("ended"); // Rimuove il listener dopo l'esecuzione
                    });
                }
            };
        }]);
})();


/* CONTROLLER ORIGINALE DI GIANLUCA */

(function () {
  "use strict";

  var TemplateQuestionControllerOriginale = function (
    $scope,
    $translate,
    App,
    Page,
    Video,
    Exercise,
    Sound
  ) {
    $scope.startTimerEx = false;

    // if (isInitialized) return;  // Prevent multiple initializations
    // isInitialized = true;
    var audio;

    var externalExerciseTimer;

    var timeOut = externalExerciseTimer * 1000;

    $scope.timeOver = false;

    var getTimeOut = () => {
      return timeOut;
    };
    // var isInitialized = false;
    $scope.loadAudio = function () {
      // debugger;
      $scope.startTimerEx = false;
      var exercise = $scope.collection.current();

      //console.log(exercise);
      // let exerciseTimer = exercise.getAttr('timer');
      // externalExerciseTimer = exerciseTimer;
      // getTimeOut();
      // $scope.stopAudio();
      if (audio) {
        audio.pause();
        audio.unbind("ended"); // Unbind previous event listener
        audio = null;
      }
      //console.log(exercise.getAttr('audio'));
      if (exercise.getAttr("audio")) {
        if (audio) {
          audio.pause();
          audio.unbind("ended"); // Unbind previous event listener
          audio = null;
        }
        audio = Sound.create({
          src: $translate.instant(exercise.getAttr("audio")),
        });

        audio.play();
        audio.bind("ended", function () {
          //console.log("Audio finished playing");
          $scope.startTimerEx = true;
          if (!$scope.$$phase) {
            // If not in a digest cycle, use $apply
            $scope.$apply(function () {
              $scope.startTimerEx = true;
            });
          } else {
            // Already in digest cycle, use $digest
            $scope.startTimerEx = true;
          }
          this.unbind("ended");
          //console.log($scope.startTimerEx);
        });
        //     setTimeout(
        //         function () {
        //             $scope.timerState.timeStarted = true;
        //         },
        //    exerciseTimer);
      }

      // isInitialized = true;
    };
    Exercise.promise().then(function () {
      $scope.loadAudio();
    });

    function load() {
      // debugger;
      // $scope.startTimerEx=false;
      // console.log(isInitialized);

      $scope.timerState = {
        timeStarted: true,
        timeElapsed: 0,
        //initialTimerMs: countdownSeconds*60*1000
        initialTimerMs: 0.5 * 62 * 1000,
      };

      //console.log($scope.startTimerEx);

      // if (isInitialized) return;  // Prevent re-initialization
      // isInitialized = true;
      $scope.loadAudioNext = function () {
        // debugger;
        //var audioQuestion = "it/sbagliata";

        // debugger;
        var exercise = $scope.collection.current();
        //console.log(exercise);
        if (audio) {
          audio.pause();
          audio = null;
        }
        //console.log(exercise.getAttr('audio'));
        if (exercise.getAttr("audio")) {
          audio = Sound.create({
            src: $translate.instant(exercise.getAttr("audio")),
          });
          audio.play();
        }
      };

      $scope.timeOverHandler = function () {
        //console.log("here");
        //console.log("$scope.exercise",var exercise = $scope.collection.current();)
        $scope.timeOver = true;
        var exercise = $scope.collection.current();
        exercise.repeat();
        exercise.repeat();
        exercise.repeat();
        exercise.setAttr("confirm", true);
        //$scope.confirmed = true;
        //$scope.exercise.repeat();
        //$scope.exercise.repeat();
        //$scope.exercise.repeat();
        //$scope.showSolution();
        var audioLocale = "it/sbagliata";

        if (audioLocale) {
          audio = Sound.create({
            src: audioLocale,
          });
          audio.play();
        }
      };

      $scope.timeOverHandlerMultiple = function () {
        //debugger;
        //console.log("here");
        //console.log("$scope.exercise",var exercise = $scope.collection.current();)
        $scope.timeOver = true;
        var exercise = $scope.collection.current();
        exercise.repeat();
        exercise.repeat();
        exercise.repeat();
        exercise.setAttr("confirm", true);
        var audioLocale = "it/sbagliata";

        if (audioLocale) {
          audio = Sound.create({
            src: audioLocale,
          });
          audio.play();
        }

        //$scope.confirmed = true;
        //$scope.exercise.repeat();
        //$scope.exercise.repeat();
        //$scope.exercise.repeat();
        //$scope.showSolution();
      };
      $scope.timeOverHandlerYesNo = function () {
        //console.log("Time over - showing solution");

        // Confirm the answer and mark exercise as completed
        $scope.confirmed = true;

        // Mark the time over flag, which can be used in the template to show the correct solution
        $scope.timeOver = true;

        // Show the correct solution (if it's multiple choice, display the right options)
        var exercise = $scope.collection.current();
        exercise.setAttr("confirm", true);
        exercise.setAttr("solution", true);
        var audioLocale = "it/sbagliata";

        if (audioLocale) {
          audio = Sound.create({
            src: audioLocale,
          });
          audio.play();
        }
        // If needed, you can trigger solution logic here
        $scope.solution();
      };
      // $scope.retry = function() {
      //     _.each($scope.collection.all(), function(exercise) {
      //         exercise.cancel();
      //     });
      //     $scope.collection.atStart();
      //     $scope.collection = null;

      //     load();
      // };

      // setInterval(function() {
      //     var d = $scope.collection.current().getAttr('choices');
      //     console.log(d);
      //     var e = $scope.collection.current().getAttr('options');
      //     console.log(e);
      // }, 2500);

      /*
            $scope.confirm = function() {
                var exercise = $scope.collection.current();
                exercise.confirm();
    
                if (exercise.getAttr('type') == 'single') {
                    var audioLocale = $translate.instant("exercises.m1_1.feedback." + exercise.getAnsweredIndex() + ".audio");
                    if (audioLocale) {
                        audio = Sound.create({
                            src: audioLocale
                        });
                        audio.play();
                    }
                }
            };*/

      $scope.stopAudio = function () {
        // debugger;
        if (audio) {
          audio.pause();
          audio = null;
        }
      };
      function stopAudio() {
        //console.log(audio);
        if (audio) {
          audio.pause();
          audio = false;
        }
      }

      $scope.confirmAndNext = function () {
        var exercise = $scope.collection.current();
        exercise.confirm();

        if (App.hasNextPage()) Page.next();
        return;
      };

      $scope.answerAndNext = function (a) {
        $scope.collection.current().setAnswer(a, $scope.isRecapVisible());

        if (!$scope.collection.current().getAttr("feedback"))
          return !$scope.video().ended()
            ? $scope.page().video().play()
            : App.hasNextPage()
            ? Page.next()
            : $scope.showReport();
      };

      $scope.confirm = function () {
        //debugger;
        var exercise = $scope.collection.current();
        exercise.confirm();
        //console.log(audio);
        if (audio) {
          audio.pause();
          audio = null;
        }

        //var audioLocale = $translate.instant("exercises.m1_1.feedback." + exercise.getAnsweredIndex() + ".audio");

        var audioLocale = "it/sbagliata";

        if (exercise.isCorrect()) {
          $scope.timerState.timeStarted = false;
          audioLocale = "it/corretta";
        }

        if (audioLocale) {
          audio = Sound.create({
            src: audioLocale,
          });
          audio.play();
        }
      };

      $scope.nextExerciseHandler = () => {
        $scope.currentExercise = $scope.collection.current();
        let audio = $scope.currentExercise.getAttr("audio");

        // if (audio){
        //     audio.pause()
        //     audio=null
        // }
        $scope.collection.next();
      };

      $scope.gotoNextQuestion = function () {
        $scope.stopAudio();
        $scope.loadAudio();
      };

      $scope.checkAnswer = function () {
        var exercise = $scope.collection.current();
        var audioLocale = "it/sbagliata";

        // If there's already an audio instance, stop it before creating a new one
        if (audio) {
          audio.pause();
          audio = null;
        }

        // Check if the current answer is correct
        if (exercise.isCorrect() || !exercise.isRepeatable()) {
          $scope.timerState.timeStarted = false;
          audioLocale = "it/corretta";
        }

        // Now create and play the new audio if `audioLocale` exists
        if (audioLocale) {
          // Create a new Sound instance
          audio = Sound.create({
            src: audioLocale,
          });

          // Check if the audio was successfully created, then play it
          if (audio) {
            audio.play();
          } else {
            console.error("Audio creation failed!");
          }
        }
      };

      $scope.resetTimer = function () {
        $scope.timerState.timeStarted = true;

        //$scope.timerState.timeElapsed=0;
        $scope.$broadcast("RESTART_TIMER");
        $scope.startTimerEx = false;
        $scope.timerState.initialTimerMs = 0.5 * 60 * 1000;
      };
      $scope.resetTimerStop = function () {
        $scope.timerState.timeStarted = true;
        $scope.timerState.timeElapsed = 0;
        $scope.startTimerEx = false;
        $scope.$broadcast("RESTART_TIMER");
        $scope.timerState.initialTimerMs = 0.5 * 60 * 1000;
      };

      $scope.solution = function () {
        var exercise = $scope.collection.current();
        // se l'esercizio è corretto o i tentativi sono finiti,
        // mostra la soluzione
        if (exercise.isCorrect() || !exercise.isRepeatable() || $scope.timeOver) {
          $scope.solutionVisible = true;
        }
      };

      $scope.solutionVisible = false;
      // $scope.isSolutionVisible = function() {
      //     return $scope.solutionVisible;
      // }

      // --------------------------------------------------------------------------------------
      // MULTIPLE -----------------------------------------------------------------------------

      $scope.checkOption = function (option) {
        var ex = $scope.collection.current();
        if (ex.isConfirmed()) {
          return;
        }

        if (
          $scope.isChecked(
            $scope.collection.current().getAttr("choices"),
            option
          )
        ) {
          $scope.collection
            .current()
            .getAttr("choices")
            .splice(
              $scope.collection.current().getAttr("choices").indexOf(option),
              1
            );
          // console.log("REMOVE", $scope.collection.current().getAttr('choices'));

          // var filtered = _.filter($scope.collection.current().getAttr('choices'), function(item) {
          //     return item !== option
          // });
          // console.log(filtered);
          return;
        } else {
          // console.log("ADD", $scope.collection.current().getAttr('choices'));
          // console.log($scope.collection.current());
          if ($scope.collection.current().getAttr("choices") === false) {
            $scope.collection.current().setAttr("choices", []);
          }
          $scope.collection.current().getAttr("choices").push(option);
        }
      };

      $scope.isOptionCorrect = function (option) {
        var index = $scope.collection.current().corrects().indexOf(option);
        return !(index === -1);
      };

      $scope.isChecked = function (choices, option) {
        if (choices === false) return false;

        var index = choices.indexOf(option);
        return !(index === -1);
      };

      $scope.isAtLeastOneChecked = function () {
        var exercise = $scope.collection.current();
        return exercise.getAttr("choices").length >= 1;
      };

      // $scope.isRepeatable = function() {
      //     return $scope.collection.current().getAttr('repeat') > 0;
      //     var ex = $scope.collection.current();
      //     var repeat = ex.getAttr('repeat');
      //     ex.setAttr('repeat', repeat - 1);
      // };

      $scope.retry = function () {
        var exercise = $scope.collection.current();
        exercise.repeat();
      };

      // $scope.solutionVisible = false;

      $scope.isSolutionVisible = function () {
        var exercise = $scope.collection.current();

        return (
          $scope.solutionVisible ||
          (exercise.isConfirmed() && exercise.isCorrect() && exercise.getAttr("template") != "card") ||
          (exercise.isConfirmed() && !exercise.isCorrect() && !exercise.isRepeatable() &&  exercise.getAttr("template") != "card") ||
          (exercise.getAttr("template") == "card" &&
            !!exercise.getAttr("allCardClicked"))
        );

        // return $scope.solutionVisible || ($scope.page().isViewed() && exercise.isConfirmed());
      };

      // fine MULTIPLE ------------------------------------------------------------------------
      // --------------------------------------------------------------------------------------

      $scope.$watch(
        function () {
          return $scope.isSolutionVisible() && $scope.collection.isAtTheEnd();
        },
        function (value) {
          if (value) {
            $scope.page().viewed();
          }
        }
      );
    }

    // $scope.timerState = {
    //     timeStarted: true,
    //     timeElapsed: 0,
    //     //initialTimerMs: countdownSeconds*60*1000
    //     initialTimerMs: 0.5*62*1000
    // };

    Page.events.on("change", function () {
      // debugger;
      stopAudio();
      $scope.startTimerEx = false;
      // isInitialized = false;
      // $scope.collection.next();
      // $scope.loadAudio();
      load();
    });

    App.events.on("module.close", function () {
      stopAudio();
    });

    Video.events.on("play", function () {
      stopAudio();
    });

    function stopAudio() {
      // debugger;
      if (audio) {
        audio.pause(); // Stop the audio
        audio.unbind("ended"); // Unbind the event listener
        audio = null; // Clear the audio object
      }
    }

    load();
  };

  TemplateQuestionControllerOriginale.$inject = [
    "$scope",
    "$translate",
    "App",
    "Page",
    "Video",
    "Exercise",
    "Sound",
  ];

  angular
    .module("Application")
    .controller("TemplateQuestionControllerOriginale", TemplateQuestionControllerOriginale);
})();


(function () {

    'use strict';

    var TemplateTestController = function ($scope, $translate, App, Page, Exercise, Collection, Sound) {

        var __showReport = false;
        var __showRecap = false;
        var __answersGiven = false;
        var __showRecapMessage = false;
        var __canEdit = false;

        var __showCover = false;

        function load() {

            Exercise.promise().then(function () {
                var audio = false;

                var model = $scope.page().html() ?
                    $scope.page().html() : (
                        $scope.page().video().currentTiming() ? 
                            $scope.page().video().currentTiming().getModule('Html')[0] : null
                        );
                //console.log(model);
                if(!model) return;
                var exerciseIndex = model.getAttr('Exercise');

                // return;
                $scope.collection = Exercise.getById(exerciseIndex);
                
                if (model.getAttr('random'))
                    $scope.collection.shuffle();
                if (model.getAttr('limit'))
                    $scope.collection = $scope.collection.limit(model.getAttr('limit'));

                $scope.collection.callEach('cancel');

                // console.log("Test collection", _.map($scope.collection.all(), function(i) { return i.getAttr('id'); }));
                _.each($scope.collection.all(), function(item) {
                    // console.log("item",item);
                    item.setAttr('finalTestItem', true);
                });
                // console.log($scope.collection);

                $scope.pages = App.lesson().pagesWithExercises();
                $scope.pageIndex = _.indexOf($scope.pages, $scope.page());

                if (model.getAttr('audio')) {
                    audio = Sound.create({
                        src: 'audio/' + model.getAttr('audio')
                    });

                    audio.play();
                }


                $scope.isBlocked=function(){
                    var _return = false;
                    _.each($scope.collection.all(), function (el) {
                        if (!el.isConfirmed()) {
                            _return = true;
                            return;
                        }
                    });
                    return _return;
                }

                $scope.$watch(function () {
                        // console.log("Test Finale", $scope.isBlocked());
                        return $scope.isBlocked();
                    },
                    function (value) {
                        if (!value) {
                            //$scope.page().viewed();
                        }
                    });

                $scope.calcPerc = function () {
                    var number = $scope.collection.getCurrentNumber() - 1;
                    return ((number * 100) / $scope.collection.count());
                };
            });

        }

        $scope.startTest = function() {
            __showCover = false;
        };

        $scope.showReport = function () {
            __showReport = true;
            __showRecap = false;
            __showRecapMessage = false;
            $scope.passed = $scope.collection.count('isCorrect');
        };

        $scope.showRecap = function () {
            __showRecap = true;
            __showReport = false;
            __showRecapMessage = false;
        };

        $scope.retry = function() {
            _.each($scope.collection.all(), function(exercise) {
                exercise.cancel();
            });
            $scope.collection.atStart();
            $scope.collection = null;

            load();

            __showRecap = false;
            __showReport = false;
            __showRecapMessage = false;
            __canEdit = true;
            __answersGiven = false;
        };

        $scope.showRecapMessage = function () {
            __showReport = false;
            __showRecap = false;
            __showRecapMessage = true;
        }

        $scope.isCoverVisible = function () {
            return __showCover;
        };

        $scope.isReportVisible = function () {
            return __showReport;
        };

        $scope.isRecapVisible = function () {
            return !$scope.isReportVisible() && __showRecap;
        };

        $scope.isRecapMessageVisible = function () {
            return !$scope.isReportVisible() && __showRecapMessage;
        };

        $scope.viewAnswersGiven = function () {
            __answersGiven = true;
            __showReport = false;
            $scope.collection.atStart();
        };

        $scope.hideAnswersGiven = function () {
            __answersGiven = false;
            __showReport = true;
            $scope.collection.atStart();
        };

        $scope.canViewAnswersGiven = function () {
            return __answersGiven;
        }

        Page.events.on('change', function () {
            load();
        });

        load();

    };

    TemplateTestController.$inject = ['$scope', '$translate', 'App', 'Page', 'Exercise', 'Collection', 'Sound'];

    angular.module('Application')
        .controller('TemplateTestController', TemplateTestController);
})();

(function(){

	'use strict';

	var TestController = function($scope, App, Page){

		var vm = this;
		var repeated = false;
		var registerDraggedItem = false;

		$scope.exercises = App.module().lesson().page().test().exercises();

		vm.test = function() {
			return App.module().lesson().page().test();
		};

		vm.exercises = function() {
			return $scope.exercises;
		};

		vm.current = function() {
			return vm.exercises().current();
		};

		vm.repeat = function(){
			repeated = true;
			vm.test().repeatOnlyIncorrect();
		};

		vm.next = function() {
			if(!vm.exercises().isAtTheEnd())
			{
				vm.exercises().next();
			
				if(repeated && vm.current().isCorrect())
				{
					vm.next();
				}
			}
			else {
				vm.test().end();
			}
		};

		vm.registerDraggedItem = function(item){
			registerDraggedItem = item;
		};

		vm.canBeDropped = function(evt, ui, match){
			return vm.current().canBeDropped(match);
		};

		vm.test().panels().intro.open();

		if(vm.test().audio())
			vm.test().audio().play();

		$scope.vm = vm;

		$scope.$watch(function(){
			return vm.exercises().isBlocked();
		}, 
		function(value){
			if(!value) {
				App.module().lesson().page().viewed();
			}
		});

		Page.events.on('change.pre', function(){             

			if(vm.test())
			{
				vm.test().repeat();
				vm.test().audio().stop();
			}

		});
	};

	TestController.$inject = ['$scope','App', 'Page'];

	angular.module('Application')
		.controller('TestController', TestController);

})();





app.directive('ngCloseButton', function () {
    return {
        restrict: 'A',
        template: '<a href="#" ng-click="App.panels.closer.open()" class="btn-control btn-logout"><div class="video-control fa fa-close"></div></a>',
        replace: true
    }
});

app.directive('ngHomeButton', function () {
  return {
    restrict: 'A',
    template: '<a href="#" ng-click="App.closeModule()" class="btn-control btn-home"><div class="video-control fa fa-home"></div></a>',
    replace: true
  }
});

app.directive('ngHelpButton', function () {
    return {
        restrict: 'A',
        template: '<a href="#" class="btn-help" ng-click="MenuButton.find(\'help\').toggle()"><span>?</span></a>',
        replace: true
    }
});

app.directive('ngTextButton', function(){
  return {
      restrict: 'A',
    //   template: '<a href="#" class="btn-subtitles" ng-click="Subtitles.panel.toggle()"><span>T</span></a>',
      template: '<a href="#" class="btn-subtitles btn-control" ng-click="Subtitles.panel.toggle()"><div class="video-control">T</div></a>',
      replace: true
  }
});

app.directive('ngMuteButton', function () {
    return {
        restrict: 'A',
        replace: true,
        template: '<a href="#" class="btn-control btn-audio" ng-click="App.toggleAudio()">' 
          + '<div class="btn-audio-off fa fa-volume-off" ng-if="!App.audioIsPlaying() || !page().video()" ng-class="{\'disabled\': !page().video()}"></div>'
          + '<div class="btn-audio-on fa fa-volume-up" ng-if="App.audioIsPlaying() && page().video()"></div>'
          + '</a>'
    }
});

/**
 * params:
 *  - timerDuration <-- in ms, indica la durata del timer
 *  - timeElapsedMs <-- in ms, indica quanti millisecondi sono trascorsi dall'avvio del timer
 *  - timeStarted <-- true/false, cambiando lo stato dal controller contenitore della direttiva, parte o viene interrotto il timer
 *  - onTimeOverFn <-- la direttiva esegue questa funzione quando scade il timer (gli viene passata dall'esterno)
 *
 *  nel controller contenitore si può inviare l'evento $scope.$broadcast("RESTART_TIMER"); per riavviare il timer
 */
(function(){

    'use strict';

    var CountdownTimer = function($scope, $interval) {

        return {
            restrict: "E",
            scope:{
                timerDuration: '=',
                timeElapsedMs: '=',
                timeStarted: '=',
                onTimeOverFn: '='
            },
            template: `<span class="countdown-timer" ng-class="{'blink': animationBlinkTimer}" ng-show="timeStarted || timeElapsedMs>0">{{countdown}}</span>`,
            controller: ['$scope','$interval', function TimerController($scope, $interval){
                /*<span className="countdown-timer" ng-class="{'blink': animationBlinkTimer}" ng-if="timeStarted && (timeElapsedMs < timer)">{{countdown}}</span>*/
            }],
            link: function($scope, $element, $attr, ctrl, transclude){
                var startTime = null;
                //$scope.timer = $scope.timerDuration || 3000;
                var timerInterval;
                $scope.animationBlinkTimer = false;
                const START_BLINKING_TIMER = 60000;
                /*const OVER_TIME_MESSAGE_AUDIO = new buzz.sound("audio/sfx/wrong_sound",{ formats: [ "mp3"], preload: true});*/

                if (!$scope.timeElapsedMs){
                    $scope.timeElapsedMs = 0;
                }

                var restartTimer = function(){
                    $scope.timeElapsedMs = 0;
                    startTimer();
                }

                

                var startTimer = function(){
                    $interval.cancel(timerInterval);
                    //$scope.timeElapsedMs = 0;
                    startTime = (new Date()).getTime();
                    if ($scope.timeElapsedMs){
                        startTime -= $scope.timeElapsedMs;
                    }
                    /*var overFn = function(){
                        TweenMax.to($(this), 0.3, {scaleX: 1.1,scaleY: 1.1});
                    }
                    var outFn = function(){
                        TweenMax.to($(this), 0.3, {scaleX: 1,scaleY: 1});
                    }

                    $(".choice").hover(overFn, outFn)*/

                    timerInterval = $interval(function(){
                        $scope.timeElapsedMs = (new Date()).getTime() - startTime;

                        var remainingTimeMs = ($scope.timeElapsedMs <= $scope.timerDuration) ? ($scope.timerDuration - $scope.timeElapsedMs) : 0;
                        // 1- Convert to seconds:
                        let seconds = Math.trunc(remainingTimeMs / 1000);
                        // 2- Extract hours:
                        /*
                                                const hours = Math.trunc(parseInt( seconds / 3600 )); // 3,600 seconds in 1 hour
                        */
                        seconds = seconds % 3600; // seconds remaining after extracting hours
                        // 3- Extract minutes:
                        let minutes = Math.trunc(parseInt( seconds / 60 )); // 60 seconds in 1 minute
                        // 4- Keep only seconds not extracted to minutes:
                        seconds = seconds % 60;


                        //var seconds = Math.max(0, Math.trunc(($scope.timerDuration - $scope.timeElapsedMs)/1000));
                        if (seconds < START_BLINKING_TIMER){
                            $scope.animationBlinkTimer = true;
                        }
                        if (seconds < 10){
                            seconds = "0"+seconds;
                        }
                        if (minutes < 10){
                            minutes = "0"+minutes;
                        }

                        /*var millis = Math.trunc((($scope.timerDuration - $scope.timeElapsedMs)%1000)/10);
                        if (millis < 10){
                            millis = "0"+millis;
                        }*/
                        $scope.countdown = minutes + ":" + seconds /*+ ":" + millis*/;

                        if ($scope.timeElapsedMs >= $scope.timerDuration){
                            stopTimer();
                            //OVER_TIME_MESSAGE_AUDIO.play();
                            if ($scope.onTimeOverFn && (typeof $scope.onTimeOverFn === 'function')){
                                $scope.onTimeOverFn();
                            }
                        }
                    }, 500);
                }
                $scope.$on('RESTART_TIMER', restartTimer);
                

                var stopTimer = function(){
                    $scope.timeStarted = false;
                    $interval.cancel(timerInterval);
                }

                $scope.$watch(
                    function(scope) { return scope.timeStarted },
                    function( newValue, oldValue ) {
                        // If enabled, listen for mouse events.
                        if ( newValue ) {
                            startTimer();
                        } else if ( oldValue ) {
                            stopTimer();
                        }
                    }
                );

                $scope.$on('$destroy', function() {
                    //console.log($element, $attr)
                    stopTimer();
                });
            }
        }
    };

    CountdownTimer.$inject = ['$compile','$interval'];

    app.directive('countdownTimer', CountdownTimer);

})();

app.directive('crossWordCell', function () {
    return {
        restrict: 'E',
        scope: {
            props: '='
        },
        template: `<div class='crosswordcell' ng-if="props.fillable" ng-class="{'fillable': props.fillable, 'filled': props.filled}">
            <div ng-if="props.value" class="cell-index" ng-class="{'left': props.horizontal, 'top': !props.horizontal}">{{props.value}}</div>
            <span>{{props.letter}}</span>
        </div>`,
        replace: true,
        link: function (scope, element, attributes) {
            //console.log("attributes crosswordcell", scope.props.value);
        }
    }
});

app.directive('crossWordInput', function () {
    return {
        restrict: 'E',
        scope: {
            props: '='
        },
        template: `<div class="crosswordinput">
            <input ng-repeat="cell in cells track by $index" type="text"
                                       maxlength="1"
                                       size="1"
                                       spellcheck="false"
                                       class="crosswordinput"
                                       ng-class="{'filled': confirmedLetters[$index]}"
                                       ng-focus="onFocusHandler($event,$index)"
                                       ng-model="letters[$index]"
                                       ng-disabled="props.readOnly || props.confirmed"
                                       ng-change="valueChangedHandler($event,$index)"
            />
        </div>`,
        link: function (scope, element, attributes) {
            scope.confirmedLetters = scope.props.letters ? scope.props.letters.slice('') : [];

            scope.letters = scope.props.letters ? scope.props.letters.slice('') : [];

            scope.cells = [...Array(scope.props.risposta.length)];

            scope.reset = function(){
                scope.letters = [...scope.confirmedLetters];
            }
            scope.valueChangedHandler = (e,i)=>{
                // se la cella non è vuota, o è già confermata, passo alla prossima
                if (scope.confirmedLetters[i]){
                    scope.lastFocuesdEl.nextElementSibling.focus();
                }else{
                    //scope.letters[i] = e.target.value;
                    if (scope.lastFocuesdEl.value && scope.lastFocuesdEl.nextElementSibling){
                        scope.lastFocuesdEl.nextElementSibling.focus();
                    }
                }

                if ((scope.letters.filter(el=>!!el).length >= scope.props.risposta.length)/* && (scope.letters.join('') === scope.props.risposta)*/){
                    scope.props.onWordFilled(scope.letters.join(''));
                }else{
                    scope.props.onWordFilled('');
                }
                /*setLetters(Array.from(e.target.value));*/
            }

            scope.onFocusHandler = (e,i)=>{
                scope.lastFocuesdEl = e.target;
                if (scope.confirmedLetters[i]){ // se la cella è già confermata passo alla prossima
                    scope.valueChangedHandler(e,i);
                }else{ // altrimenti autoselect del value
                    e.target.value && e.target.select();
                }
            }

            scope.$watch('props.letters', function(value){
                scope.letters = value && value.slice('') || [];
            })

            scope.$watch('props.confirmed', function(newValue, oldValue) {
                if ( (oldValue !== newValue) && !newValue) {
                    scope.letters = [...scope.confirmedLetters];
                }
            });
        },
        controller: function( $scope, $element, $attrs, $transclude ) {
            console.log("NEW CONTROLLER EXEC")
        }
    }
});

/**
 * Logica:
 * - se scade il timer viene mostrato un pulsante per mostrare la soluzione
 * - se sbaglio 3 volte una parola, viene compilata con quella corretta
 */
app.directive('cruciverba', function () {
    return {
        restrict: 'E',
        scope: {
            'props': '=',
            'onClose': '=',
            'onEnded': '='
        },
        template: `<div class="cruciverba">
                <div>
                    <div ng-if="stepGame !== STEPS.SCORE_VIEW">
                        <header-generic hide-timer="(stepGame === STEPS.NOT_STARTED) || (stepGame === STEPS.SCORE_VIEW)" timer-state="timerState" title="Cruciverba" on-finish-game="finishGameHandler" 
                        on-timer-over="setAllCorrect"
                        on-ended="onEnded"
                        >
                           <div ng-if="(stepGame === STEPS.NOT_STARTED)">
                               
                               
                                <p>Riempire le caselle vuote per completare le parole.</p>
                                <p class="text-left">Istruzioni:</p>
                                <ul class="text-left">
                                    <li>Fare click sulla <strong>definizione</strong> per completare la parola</li>
                                    <li>Clicca su <strong>Conferma</strong></li>
                                </ul>
                                <p class="text-left">Con <strong>Torna alla definizione</strong> si torna allo schema generale.</p>
                                <p>Pronti? Cominciamo!</p>
                            </div>
                        </header-generic>
                        <instructions-start ng-if="(stepGame === STEPS.NOT_STARTED)" on-start-click="startGameHandler" ></instructions-start>
                        <table ng-if="detailViewDefinitionIndex === -1">
                            <tbody>
                                <tr ng-repeat="row in crosswordMatrix track by $index">
                                <td ng-repeat="col in row track by $index">
                                    <cross-word-cell props="{'fillable': col.fillable, 'value': col.value, 'filled': !!col.letter, 'letter': col.letter, 'horizontal': col.horizontal}"/>
                                </td>
                                <!--<cross-word-cell ng-repeat="col in row track by $index" props="{'fillable': col?.fillable, 'value': col?.value, 'filled': !!col?.letter, 'letter': col?.letter, 'horizontal': col?.horizontal}"/>-->
                                    <!--<cross-word-cell ng-repeat="col in row" props="{'fillable': col?.fillable, 'value': col?.value, 'filled': !!col?.letter, 'letter': col?.letter, 'horizontal': col?.horizontal}"/>-->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- vista preview -->
                    <div ng-if="((stepGame === STEPS.STARTED) || (stepGame === STEPS.COMPLETED)) && (detailViewDefinitionIndex === -1)" class="definitions-list">
                        <definition-row ng-repeat="definition in definitions" props="{'preview': true, 'definition': definition, 'index': $index, 'onOpenDetail': openDetailHandler}" />)
                    </div>
    
                    <!-- vista dettaglio -->
                    <div ng-if="((stepGame === STEPS.STARTED) || (stepGame === STEPS.COMPLETED)) && (detailViewDefinitionIndex >= 0)" class="detail-view">
                        <definition-row props="{'definition': definitions[detailViewDefinitionIndex], 'state': (definitions[detailViewDefinitionIndex].completed ? DEFINITION_STATE.COMPLETED : DEFINITION_STATE.EMPTY), onDetailViewCorrect: onDetailViewCorrectHandler, onBackToDefinitions: backToDefinitionsHandler}"/>
                    </div>
                </div>
                <div ng-if="(stepGame === STEPS.COMPLETED) && (detailViewDefinitionIndex < 0)" style="text-align:center;margin:10px;"><button class="button-game fixed-width" ng-click="showScoreViewHandler()">MOSTRA IL RISULTATO</button></div>
                
                <div ng-if="(stepGame === STEPS.COMPLETED) && solutionButtonVisible && !areAllCorrect()" style="text-align:center;margin:10px;"><button class="button-game fixed-width" ng-click="setAllCorrect()">SOLUZIONE</button></div>
                <score-view ng-if="(stepGame === STEPS.SCORE_VIEW)" title="Feedback" text="feedbackText" correct="areAllCorrect() && !forcedSolution" on-retry="startGameHandler" on-close="onClose"/>
        </div>`,
        replace: true,
        link: function (scope, element, attributes) {
            scope.solutionButtonVisible = false;
            scope.STEPS = {
                "NOT_STARTED": "NOT_STARTED",
                "STARTED": "STARTED",
                "COMPLETED": "COMPLETED",
                "SCORE_VIEW": "SCORE_VIEW"
            }
            scope.COUNTDOWN_TIMER_QUESTION_SECONDS = 1000*60;
            scope.detailViewDefinitionIndex = -1;

            scope.finishGameHandler = function(){
                scope.timerState.timeStarted = false;
                scope.solutionButtonVisible = true;
                scope.stepGame = scope.STEPS.COMPLETED;
                scope.detailViewDefinitionIndex = -1;
                // scope.setAllCorrect();
                // scope.page().viewed(true);
                // scope.$apply();

                scope.onEnded();
            }

            scope.setAllCorrect = function(){
                scope.forcedSolution = true;
                scope.definitions.forEach((def,i) => {
                    scope.setWordCorrect(def, i);
                })
                scope.solutionButtonVisible = false;
            }
            scope.showScoreViewHandler = function(){
                scope.stepGame = scope.STEPS.SCORE_VIEW;

                if (scope.areAllCorrect() && !scope.forcedSolution){
                    scope.feedbackText = 'Congratulazioni! Hai completato l\'esercitazione.';
                }else{
                    scope.feedbackText = 'Errato! Hai completato il gioco! ';
                }
            }

            scope.startGameHandler = function(){
                scope.emptyAll();
                scope.timerState = {
                    timeStarted: true,
                    timeElapsed: 0
                }
                scope.stepGame = scope.STEPS.STARTED;
            }

            scope.definitions = scope.props.definizioni;

            scope.openDetailHandler = (definition, index)=>{
                if (!definition.completed && (scope.stepGame !== scope.STEPS.COMPLETED)){
                    scope.detailViewDefinitionIndex = index;
                }
            }

            scope.stepGame = scope.STEPS.NOT_STARTED;
            console.log("attributes cruciverba", scope.props);
        },
        controller: function($scope){
            $scope.crosswordMatrix = [];
            $scope.backToDefinitionsHandler = function(){
                $scope.detailViewDefinitionIndex = -1;
            }

            const getIntersectedDefinitions = (definition)=>{
                const hasSameRowOrCol = (compiledDef, currentRowCol)=>{
                    if (compiledDef.orizzontale){
                        return (currentRowCol.x >= compiledDef.x) && (currentRowCol.x <= compiledDef.x+compiledDef.risposta.length) &&// escludo le definizioni che hanno colonne diverse da quella compilata
                            (compiledDef.y >= currentRowCol.y) && (compiledDef.y<=currentRowCol.risposta.length+currentRowCol.y)// prendo le definizioni la cui lunghezza arriva alla parola completata
                    }else{
                        return (currentRowCol.y >= compiledDef.y) && (currentRowCol.y <= compiledDef.y+compiledDef.risposta.length) &&// escludo le definizioni che hanno righe diverse da quella compilata
                            (compiledDef.x >= currentRowCol.x) && (compiledDef.x<=currentRowCol.risposta.length+currentRowCol.x)
                    }
                }
                const filteredDefs = $scope.definitions.filter(def => {
                    const isPerpendicular = (definition.orizzontale !== def.orizzontale) // escludo tutte le definizioni con lo stesso orientamento di quella compilata (non possono intersecarsi)
                    return isPerpendicular &&
                        hasSameRowOrCol(definition, def) // escludo le definizioni che hanno righe/colonne diverse da quella compilata
                })
                return filteredDefs;
            }

            const setFilledLetters = function(definition){
                let defs = [...$scope.definitions];
                let filteredDefs = getIntersectedDefinitions(definition); // prendo le definizioni che hanno una lettera in comune con la parola appena compilata
                for (const d of defs){
                    if (d.index === definition.index){
                        d.filledLetters = definition.risposta.split('');
                        d.completed = (definition.risposta.length === d.filledLetters.length);
                    }
                    for (const f of filteredDefs){
                        if (d.index === f.index) { // se trovo la definzione tra quelle che intersecano la parola
                            if (!(d.filledLetters && d.filledLetters.length)){
                                d.filledLetters = [...Array(d.risposta.length)];
                            }
                            let intersectionPosition = definition.orizzontale ? definition.y-d.y : definition.x-d.x
                            d.filledLetters[intersectionPosition] = d.risposta[intersectionPosition];
                        }
                    }
                }
                $scope.definitions = defs;
            }

            const emptyAll = function () {
                $scope.definitions.forEach(def => {
                    delete def.filledLetters;
                    delete def.completed;
                });
                $scope.crosswordMatrix.forEach((m) => {
                    m.forEach((n) => { if (n) delete n.letter; })
                });
                $scope.$apply();
            }
            $scope.emptyAll = emptyAll;

            const setWordCorrect = (def, index)=>{
                let matrix = [...$scope.crosswordMatrix];
                if (def.orizzontale){
                    matrix[def.y].splice(def.x,def.risposta.length, ...[ ...Array(def.risposta.length).keys() ].map( i => {
                        return {
                            fillable: true,
                            value: i === 0 ? def.index : null, // label solo nella prima cella della riga
                            letter: def.risposta[i],
                            horizontal: true
                        }
                    }))
                }else{
                    for (let wIndex = 0; wIndex<def.risposta.length; wIndex++){
                        const rowIndex = wIndex+def.y;
                        let labelIndex = null;
                        let orientationHorizontal = false;
                        if (matrix[rowIndex][def.x] && matrix[rowIndex][def.x].value) { // se ho già una labelIndex (numerino accanto alla cella) non la sovrascrivo con null, ma riprendo quella esistente
                            labelIndex = matrix[rowIndex][def.x].value;
                            orientationHorizontal = matrix[rowIndex][def.x].horizontal;
                        }else{
                            labelIndex = (rowIndex === def.y) ? def.index : null;
                            orientationHorizontal = false;
                        }
                            matrix[rowIndex][def.x] = {
                                fillable: true,
                                value: labelIndex, // label solo nella prima cella della colonna
                                letter: def.risposta[wIndex],
                                horizontal: orientationHorizontal
                            }

                    }
                }
                $scope.crosswordMatrix = matrix;
                setFilledLetters(def);
            }

            $scope.setWordCorrect = setWordCorrect;

            $scope.onDetailViewCorrectHandler = ()=>{
                let definition = $scope.definitions[$scope.detailViewDefinitionIndex];
                setWordCorrect(definition, $scope.detailViewDefinitionIndex);
                $scope.detailViewDefinitionIndex = -1;
            }

            const buildMatrix = () => {
                const matrix = [...Array($scope.props.rows)];
                for (let y = 0; y < matrix.length; y++){
                    matrix[y] = [...Array($scope.props.cols)];
                }
                return matrix;
            }

            const fillMatrixRow = (arr, rowIndex, def) => {
                arr[rowIndex].splice(def.x,def.risposta.length, ...[ ...Array(def.risposta.length).keys() ].map( i => {
                    var labelIndex =  i === 0 ? def.index : null;
                    return {
                        fillable: true,
                        value: labelIndex, // label solo nella prima cella della riga
                        //letter: def.risposta[i],
                        horizontal: true
                    }
                }))
            }
            const fillMatrixColumn = (arr, colIndex, def)=>{
                for (let wIndex = 0; wIndex<def.risposta.length; wIndex++){
                    const rowIndex = wIndex+def.y;
                    if (!(arr[rowIndex][colIndex] && arr[rowIndex][colIndex].value)){ // se ho già una labelIndex (numerino accanto alla cella) non la sovrascrivo con null
                        arr[rowIndex][colIndex] = {
                            fillable: true,
                            value: rowIndex === def.y ? def.index : null, // label solo nella prima cella della colonna
                            //letter: def.risposta[wIndex],
                            horizontal: false
                        }
                    }
                }
            }

            /*$scope.init = function(){*/
                let tmpCrosswordMatrix = buildMatrix();
                for (let y = 0; y<tmpCrosswordMatrix.length; y++){
                    $scope.props.definizioni.forEach(def => {
                        if (def.orizzontale){
                            if (def.y === y){
                                fillMatrixRow(tmpCrosswordMatrix, y, def);
                            }
                        }
                    })
                    $scope.props.definizioni.forEach(def => {
                        if (!def.orizzontale){
                            fillMatrixColumn(tmpCrosswordMatrix,def.x,def);
                        }
                    })
                }

                $scope.crosswordMatrix = tmpCrosswordMatrix;
                $scope.$apply();
                console.log("$scope.crosswordMatrix",$scope.crosswordMatrix)
            /*}*/

            const getCorrectCount = ()=>{
                return $scope.definitions.filter(def => def.completed).length;
            }

            $scope.areAllCorrect = ()=>{
                return getCorrectCount() === $scope.definitions.length;
            }

            $scope.$watch('definitions', function(newValue, oldValue) {
                if (newValue !== oldValue){
                    const allCorrect = $scope.areAllCorrect();
                    console.log("correctCount ", getCorrectCount())
                    if (allCorrect){
                        $scope.finishGameHandler(true);
                    }
                }
            })
        }
    }
});

/**
 * Logica:
 * - se scade il timer viene mostrato un pulsante per mostrare la soluzione
 * - se sbaglio 3 volte una parola, viene compilata con quella corretta
 */
app.directive('cruciverbaOriginal', function () {
    return {
        restrict: 'E',
        scope: {
            'props': '=',
            'onClose': '=',
            'onEnded': '='
        },
        template: `<div class="cruciverba">
                <div>
                    <div ng-if="stepGame !== STEPS.SCORE_VIEW">
                        <header-generic hide-timer="(stepGame === STEPS.NOT_STARTED) || (stepGame === STEPS.SCORE_VIEW)" timer-state="timerState" title="Cruciverba" on-finish-game="finishGameHandler" 
                        on-timer-over="setAllCorrect"
                        on-ended="onEnded"
                        >
                           <div ng-if="(stepGame === STEPS.NOT_STARTED)">
                               
                               
                                <p>Riempire le caselle vuote per completare le parole.</p>
                                <p class="text-left">Istruzioni:</p>
                                <ul class="text-left">
                                    <li>Fare click sulla <strong>definizione</strong> per completare la parola</li>
                                    <li>Clicca su <strong>Conferma</strong></li>
                                </ul>
                                <p class="text-left">Con <strong>Torna alla definizione</strong> si torna allo schema generale.</p>
                                <p>Pronti? Cominciamo!</p>
                            </div>
                        </header-generic>
                        <instructions-start ng-if="(stepGame === STEPS.NOT_STARTED)" on-start-click="startGameHandler" ></instructions-start>
                        <table ng-if="detailViewDefinitionIndex === -1">
                            <tbody>
                                <tr ng-repeat="row in crosswordMatrix track by $index">
                                <td ng-repeat="col in row track by $index">
                                    <cross-word-cell props="{'fillable': col.fillable, 'value': col.value, 'filled': !!col.letter, 'letter': col.letter, 'horizontal': col.horizontal}"/>
                                </td>
                                <!--<cross-word-cell ng-repeat="col in row track by $index" props="{'fillable': col?.fillable, 'value': col?.value, 'filled': !!col?.letter, 'letter': col?.letter, 'horizontal': col?.horizontal}"/>-->
                                    <!--<cross-word-cell ng-repeat="col in row" props="{'fillable': col?.fillable, 'value': col?.value, 'filled': !!col?.letter, 'letter': col?.letter, 'horizontal': col?.horizontal}"/>-->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- vista preview -->
                    <div ng-if="((stepGame === STEPS.STARTED) || (stepGame === STEPS.COMPLETED)) && (detailViewDefinitionIndex === -1)" class="definitions-list">
                        <definition-row ng-repeat="definition in definitions" props="{'preview': true, 'definition': definition, 'index': $index, 'onOpenDetail': openDetailHandler}" />)
                    </div>
    
                    <!-- vista dettaglio -->
                    <div ng-if="((stepGame === STEPS.STARTED) || (stepGame === STEPS.COMPLETED)) && (detailViewDefinitionIndex >= 0)" class="detail-view">
                        <definition-row props="{'definition': definitions[detailViewDefinitionIndex], 'state': (definitions[detailViewDefinitionIndex].completed ? DEFINITION_STATE.COMPLETED : DEFINITION_STATE.EMPTY), onDetailViewCorrect: onDetailViewCorrectHandler, onBackToDefinitions: backToDefinitionsHandler}"/>
                    </div>
                </div>
                <div ng-if="(stepGame === STEPS.COMPLETED) && (detailViewDefinitionIndex < 0)" style="text-align:center;margin:10px;"><button class="button-game fixed-width" ng-click="showScoreViewHandler()">MOSTRA IL RISULTATO</button></div>
                
                <div ng-if="(stepGame === STEPS.COMPLETED) && solutionButtonVisible && !areAllCorrect()" style="text-align:center;margin:10px;"><button class="button-game fixed-width" ng-click="setAllCorrect()">SOLUZIONE</button></div>
                <score-view ng-if="(stepGame === STEPS.SCORE_VIEW)" title="Feedback" text="feedbackText" correct="areAllCorrect() && !forcedSolution" on-retry="startGameHandler" on-close="onClose"/>
        </div>`,
        replace: true,
        link: function (scope, element, attributes) {
            scope.solutionButtonVisible = false;
            scope.STEPS = {
                "NOT_STARTED": "NOT_STARTED",
                "STARTED": "STARTED",
                "COMPLETED": "COMPLETED",
                "SCORE_VIEW": "SCORE_VIEW"
            }
            scope.COUNTDOWN_TIMER_QUESTION_SECONDS = 1000*60;
            scope.detailViewDefinitionIndex = -1;

            scope.finishGameHandler = function(){
                scope.timerState.timeStarted = false;
                scope.solutionButtonVisible = true;
                scope.stepGame = scope.STEPS.COMPLETED;
                scope.detailViewDefinitionIndex = -1;
                // scope.setAllCorrect();
                // scope.page().viewed(true);
                // scope.$apply();

                scope.onEnded();
            }

            scope.setAllCorrect = function(){
                scope.forcedSolution = true;
                scope.definitions.forEach((def,i) => {
                    scope.setWordCorrect(def, i);
                })
                scope.solutionButtonVisible = false;
            }
            scope.showScoreViewHandler = function(){
                scope.stepGame = scope.STEPS.SCORE_VIEW;

                if (scope.areAllCorrect() && !scope.forcedSolution){
                    scope.feedbackText = 'Congratulazioni! Hai completato l\'esercitazione.';
                }else{
                    scope.feedbackText = 'Errato! Hai completato il gioco! ';
                }
            }

            scope.startGameHandler = function(){
                scope.emptyAll();
                scope.timerState = {
                    timeStarted: true,
                    timeElapsed: 0
                }
                scope.stepGame = scope.STEPS.STARTED;
            }

            scope.definitions = scope.props.definizioni;

            scope.openDetailHandler = (definition, index)=>{
                if (!definition.completed && (scope.stepGame !== scope.STEPS.COMPLETED)){
                    scope.detailViewDefinitionIndex = index;
                }
            }

            scope.stepGame = scope.STEPS.NOT_STARTED;
            console.log("attributes cruciverba", scope.props);
        },
        controller: function($scope){
            $scope.crosswordMatrix = [];
            $scope.backToDefinitionsHandler = function(){
                $scope.detailViewDefinitionIndex = -1;
            }

            const getIntersectedDefinitions = (definition)=>{
                const hasSameRowOrCol = (compiledDef, currentRowCol)=>{
                    if (compiledDef.orizzontale){
                        return (currentRowCol.x >= compiledDef.x) && (currentRowCol.x <= compiledDef.x+compiledDef.risposta.length) &&// escludo le definizioni che hanno colonne diverse da quella compilata
                            (compiledDef.y >= currentRowCol.y) && (compiledDef.y<=currentRowCol.risposta.length+currentRowCol.y)// prendo le definizioni la cui lunghezza arriva alla parola completata
                    }else{
                        return (currentRowCol.y >= compiledDef.y) && (currentRowCol.y <= compiledDef.y+compiledDef.risposta.length) &&// escludo le definizioni che hanno righe diverse da quella compilata
                            (compiledDef.x >= currentRowCol.x) && (compiledDef.x<=currentRowCol.risposta.length+currentRowCol.x)
                    }
                }
                const filteredDefs = $scope.definitions.filter(def => {
                    const isPerpendicular = (definition.orizzontale !== def.orizzontale) // escludo tutte le definizioni con lo stesso orientamento di quella compilata (non possono intersecarsi)
                    return isPerpendicular &&
                        hasSameRowOrCol(definition, def) // escludo le definizioni che hanno righe/colonne diverse da quella compilata
                })
                return filteredDefs;
            }

            const setFilledLetters = function(definition){
                let defs = [...$scope.definitions];
                let filteredDefs = getIntersectedDefinitions(definition); // prendo le definizioni che hanno una lettera in comune con la parola appena compilata
                for (const d of defs){
                    if (d.index === definition.index){
                        d.filledLetters = definition.risposta.split('');
                        d.completed = (definition.risposta.length === d.filledLetters.length);
                    }
                    for (const f of filteredDefs){
                        if (d.index === f.index) { // se trovo la definzione tra quelle che intersecano la parola
                            if (!(d.filledLetters && d.filledLetters.length)){
                                d.filledLetters = [...Array(d.risposta.length)];
                            }
                            let intersectionPosition = definition.orizzontale ? definition.y-d.y : definition.x-d.x
                            d.filledLetters[intersectionPosition] = d.risposta[intersectionPosition];
                        }
                    }
                }
                $scope.definitions = defs;
            }

            const emptyAll = function () {
                $scope.definitions.forEach(def => {
                    delete def.filledLetters;
                    delete def.completed;
                });
                $scope.crosswordMatrix.forEach((m) => {
                    m.forEach((n) => { if (n) delete n.letter; })
                });
                $scope.$apply();
            }
            $scope.emptyAll = emptyAll;

            const setWordCorrect = (def, index)=>{
                let matrix = [...$scope.crosswordMatrix];
                if (def.orizzontale){
                    matrix[def.y].splice(def.x,def.risposta.length, ...[ ...Array(def.risposta.length).keys() ].map( i => {
                        return {
                            fillable: true,
                            value: i === 0 ? def.index : null, // label solo nella prima cella della riga
                            letter: def.risposta[i],
                            horizontal: true
                        }
                    }))
                }else{
                    for (let wIndex = 0; wIndex<def.risposta.length; wIndex++){
                        const rowIndex = wIndex+def.y;
                        let labelIndex = null;
                        let orientationHorizontal = false;
                        if (matrix[rowIndex][def.x] && matrix[rowIndex][def.x].value) { // se ho già una labelIndex (numerino accanto alla cella) non la sovrascrivo con null, ma riprendo quella esistente
                            labelIndex = matrix[rowIndex][def.x].value;
                            orientationHorizontal = matrix[rowIndex][def.x].horizontal;
                        }else{
                            labelIndex = (rowIndex === def.y) ? def.index : null;
                            orientationHorizontal = false;
                        }
                            matrix[rowIndex][def.x] = {
                                fillable: true,
                                value: labelIndex, // label solo nella prima cella della colonna
                                letter: def.risposta[wIndex],
                                horizontal: orientationHorizontal
                            }

                    }
                }
                $scope.crosswordMatrix = matrix;
                setFilledLetters(def);
            }

            $scope.setWordCorrect = setWordCorrect;

            $scope.onDetailViewCorrectHandler = ()=>{
                let definition = $scope.definitions[$scope.detailViewDefinitionIndex];
                setWordCorrect(definition, $scope.detailViewDefinitionIndex);
                $scope.detailViewDefinitionIndex = -1;
            }

            const buildMatrix = () => {
                const matrix = [...Array($scope.props.rows)];
                for (let y = 0; y < matrix.length; y++){
                    matrix[y] = [...Array($scope.props.cols)];
                }
                return matrix;
            }

            const fillMatrixRow = (arr, rowIndex, def) => {
                arr[rowIndex].splice(def.x,def.risposta.length, ...[ ...Array(def.risposta.length).keys() ].map( i => {
                    var labelIndex =  i === 0 ? def.index : null;
                    return {
                        fillable: true,
                        value: labelIndex, // label solo nella prima cella della riga
                        //letter: def.risposta[i],
                        horizontal: true
                    }
                }))
            }
            const fillMatrixColumn = (arr, colIndex, def)=>{
                for (let wIndex = 0; wIndex<def.risposta.length; wIndex++){
                    const rowIndex = wIndex+def.y;
                    if (!(arr[rowIndex][colIndex] && arr[rowIndex][colIndex].value)){ // se ho già una labelIndex (numerino accanto alla cella) non la sovrascrivo con null
                        arr[rowIndex][colIndex] = {
                            fillable: true,
                            value: rowIndex === def.y ? def.index : null, // label solo nella prima cella della colonna
                            //letter: def.risposta[wIndex],
                            horizontal: false
                        }
                    }
                }
            }

            /*$scope.init = function(){*/
                let tmpCrosswordMatrix = buildMatrix();
                for (let y = 0; y<tmpCrosswordMatrix.length; y++){
                    $scope.props.definizioni.forEach(def => {
                        if (def.orizzontale){
                            if (def.y === y){
                                fillMatrixRow(tmpCrosswordMatrix, y, def);
                            }
                        }
                    })
                    $scope.props.definizioni.forEach(def => {
                        if (!def.orizzontale){
                            fillMatrixColumn(tmpCrosswordMatrix,def.x,def);
                        }
                    })
                }

                $scope.crosswordMatrix = tmpCrosswordMatrix;
                $scope.$apply();
                console.log("$scope.crosswordMatrix",$scope.crosswordMatrix)
            /*}*/

            const getCorrectCount = ()=>{
                return $scope.definitions.filter(def => def.completed).length;
            }

            $scope.areAllCorrect = ()=>{
                return getCorrectCount() === $scope.definitions.length;
            }

            $scope.$watch('definitions', function(newValue, oldValue) {
                if (newValue !== oldValue){
                    const allCorrect = $scope.areAllCorrect();
                    console.log("correctCount ", getCorrectCount())
                    if (allCorrect){
                        $scope.finishGameHandler(true);
                    }
                }
            })
        }
    }
});

app.directive('definitionRow', function () {
    return {
        restrict: 'E',
        scope: {
            props: '='
        },
        template: `<div class="definition-row" ng-class="{'preview': props.preview, 'completed': isWordConfirmed && isFilledCorrect()}" ng-click="props.onOpenDetail(props.definition, props.index)">
            <div class="orientation-label"><span ng-class="{'confirmed': props.definition.completed || (isWordConfirmed && isFilledCorrect()), 'ko':(!props.definition.completed) && isWordConfirmed && (!isFilledCorrect())}">{{props.definition.index}} {{props.definition.orizzontale ? "orizzontale" : "verticale"}} {{iconLabel}}</span></div>
            <div class="definition">
                <p>{{props.definition.text}}</p>
                <img ng-if="props.preview" src="./assets/images/game/chevron-right.svg" alt=""/>
            </div>
            <div class="input-definition">
                <cross-word-input props="{'risposta':props.definition.risposta, 'letters': props.definition.filledLetters, 'onWordFilled': setFilledWord, 'confirmed': isWordConfirmed, 'readOnly': props.preview}"/>
            </div>

            <div ng-if="!props.preview" class="buttons-container">
                <div class="center-element" ng-if="feedbackVisible && isWordConfirmed">
                        <feedback-row ng-if="isFilledCorrect() && !forcedSolution" correct="true">
                            Corretto!
                        </feedback-row>
                        <feedback-row ng-if="!isFilledCorrect() && !forcedSolution" correct="false">
                            Sbagliato!
                        </feedback-row>
                        <feedback-row ng-if="forcedSolution" correct="false">
                            Soluzione: {{filledWord}}
                        </feedback-row>
                        <button class="button-game fixed-width" ng-if="!isFilledCorrect() && !isSolutionAvailable" ng-click="tryAgainHandler()">Riprova</button>
                        <button class="button-game fixed-width" ng-if="!isFilledCorrect() && isSolutionAvailable" ng-click="showSolution()">Soluzione</button>
                </div>
                <button class="button-game fixed-width" ng-if="!isWordConfirmed" ng-disabled="!filledWord" ng-class="{'disabled': !filledWord}" ng-click="confirmDefinitionHandler()">Conferma</button>
                <button class="text-button" ng-if="(!isWordConfirmed || !isFilledCorrect())" ng-click="props.onBackToDefinitions();">torna alle definizioni</button>
            </div>
        </div>`,
        replace: true,
        link: function (scope, element, attributes) {
        },
        controller: function( $scope, $element, $attrs, $transclude ) {
            console.log( $attrs.log + ' (controller)' );
            $scope.forcedSolution = false;

            $scope.tryAgainHandler = ()=>{
                $scope.isWordConfirmed = false;
                $scope.setFilledWord('');
            }

            $scope.showSolution = ()=>{
                $scope.setFilledWord($scope.props.definition.risposta);
                $scope.forcedSolution = true;
                $scope.confirmDefinitionHandler();
            }

            $scope.isFilledCorrect = function(){
                if (!$scope.filledWord){
                    return false;
                }
                return $scope.filledWord.toLowerCase() === $scope.props.definition.risposta.toLowerCase();
            }


            $scope.setFilledWord = function(word){
                $scope.filledWord = word;
            }

            $scope.confirmDefinitionHandler = ()=>{
                if (!$scope.props.definition.tentativi){
                    $scope.props.definition.tentativi = 0;
                }
                $scope.props.definition.tentativi++;
                if ($scope.props.definition.tentativi >= 3){
                    $scope.isSolutionAvailable = true;
                }


                if ($scope.filledWord) {
                    $scope.isWordConfirmed = true;

                    $scope.feedbackVisible = true;
                    if ($scope.isFilledCorrect()){ // risposta corretta
                        setTimeout(()=>{
                            $scope.props.onDetailViewCorrect();
                            $scope.$apply();
                        },2000)
                    }
                }
            }
        },
    }
});

app.directive('feedbackRow', function () {
    return {
        restrict: 'E',
        scope: {
            correct: '='
        },
        transclude: true,
        replace: true,
        template: `<div class="feedback-row" ng-class="{'ok': correct, 'ko': !correct}">
            <div ng-transclude></div>
        </div>`,
        link: function (scope, element, attributes) {
        },
        controller: function($scope){
            console.log("$scope", $scope)
        }
    }
});

(function () {
    'use strict';

    let GaugeDirective = function () {

        return {
            restrict: 'A',
            scope: {
                value: '='
            },
            link: function (scope, element, attributes) {


                let opts = {
                    angle: 0.15, // The span of the gauge arc
                    lineWidth: 0.06, // The line thickness
                    radiusScale: 0.95, // Relative radius
                    animationSpeed: 32,
                    limitMax: false,     // If false, max value increases automatically if value > maxValue
                    limitMin: false,     // If true, the min value of the gauge will be fixed
                    colorStart: '#ff0000',   // Colors
                    colorStop: "#55FA22",    // just experiment with them
                    strokeColor:'#eeeeef',
                    shadowColor: '#eeeeef',
                    generateGradient: true,
                    percentColors: [
                        [0.0, "#ff0000"],
                        [0.1, "#f56f16"],
                        [0.3, "#f1cb28"],
                        [0.5, "#ccff00"],
                        [0.7, "#04d216"]
                    ]
                };
                let gauge;

                setTimeout(()=>{
                    gauge = new Donut(document.getElementById(attributes.id)).setOptions(opts);
                    gauge.maxValue = 100; // set max gauge value
                    gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
                    gauge.set(scope.value); // set actual value
                    scope.$watch(()=>scope.value, (val)=>{
                        gauge.set(val);
                    });
                }, 1000);
            }
        }
    };

    angular.module('Application')
        .directive('ngGauge', GaugeDirective);

})();

app.directive('headerGeneric', function () {
    return {
        restrict: 'E',
        scope: {
            hideTimer: '=',
            title: '@',
            onFinishGame: '=',
            onTimerOver: '=',
            onEnded: '=',
            timerState: '='
        },
        transclude: true,
        replace: true,
        template: `<div class="header-generic" ng-style="{'marginBottom': scope.marginBottom ? '20px' : 'initial'}">
          <div class="question-title">
              {{title}}
          </div>
            
            <div ng-transclude></div>
        </div>`,

        // <div style="margin-bottom: 10px">
        //     <countdown-timer ng-if="!hideTimer" time-started="timerState.timeStarted" timer-duration="10000*60" on-time-over-fn="timeoverHandler" time-elapsed-ms="timerState.timeElapsed"/>
        // </div>
        link: function (scope, element, attributes) {
            scope.timeoverHandler = function(){
                scope.onFinishGame();
                scope.onTimerOver();
                scope.onEnded();
            }
            if (scope.timerState){
                scope.timerState.timeStarted = true;
            }
        }
    }
});

app.directive('instructionsStart', function () {
    return {
        restrict: 'E',
        scope: {
            title: '@',
            onStartClick: '='
        },
        transclude:true,
        template: `<div class="instructions-start">
            <div class="instructions">
                <div ng-transclude></div>
            </div>
            <div style="text-align: center; margin: 10px">
                <button class="button-game fixed-width" ng-click="onStartClick()">INIZIA</button>
            </div>
        </div>`,
        replace: true,
        link: function (scope, element, attributes) {

        }
    }
});

app.directive('scoreView', function () {
    return {
        restrict: 'E',
        scope: {
            title: '@',
            text: '=',
            correct: '=',
            onRetry: '=',
            onClose: '='
        },
        template: `<div class="score-view"><header-generic hide-timer="true" title="{{title}}"><div compile="text"></div>
                <div ng-if="correct" style="text-align:center;margin:10px;"><button class="button-game fixed-width" ng-click="onClose()">CHIUDI</button></div>
                <div ng-if="!correct" style="text-align:center;margin:10px;"><button class="button-game fixed-width" ng-click="onRetry()">RIPROVA</button></div>
                </header-generic>
        </div>`,
        replace: true,
        link: function (scope, element, attributes) {

        }
    }
});

app.directive('a', function () {
    return {
        restrict: 'E',
        link: function (scope, elem, attrs) {
            if (attrs.ngClick || attrs.href === '' || attrs.href === '#') {
                elem.on('click', function (e) {
                    e.preventDefault();
                });
            }
        }
    };
});

app.directive('compile', ['$compile', function ($compile) {
    return function (scope, element, attrs) {
        scope.$watch(
                function (scope) {
                    return scope.$eval(attrs.compile);
                },
                function (value) {
                    var result = element.html(value);
                    $compile(element.contents())(scope);
                }
        );
    };
}]);

app.directive('animate', ['$timeout', function($timeout){
    return {
        restrict: 'A',
        link: function(scope, el, attrs) {
            var el = $(el);
            var $class = attrs.animate;
            var timeout = attrs.animateTimeout;
            
            if(timeout)
            {
                $timeout(function(){
                    el.addClass('animated').addClass($class).removeClass('invisible-opacity'); 
                }, timeout*1000);
            }
            else 
                el.addClass('animated').addClass($class).removeClass('invisible-opacity');
        }
    };
}]);

app.directive('progressBar', ['App', function (App) {
    return {
        restrict: 'A',
        template: '<div id="slider-range-min"></div>',
        scope: {
            video: '=',
            blocked: '='
        },
        replace: true,
        transclude: true,
        link: function (scope, element, attributes) {

            App.promise.then(function () {

                function moveVideo() {
                    var value = _slider.slider('value');
                    var seconds = scope.video.player().duration();
                    var currentTime = (value * seconds) / 100;
                    scope.video.player().currentTime(currentTime);
                }

                var setup = {
                  range: "min",
                  min: 1,
                  max: 100
                }

                var _slider = element.slider(setup);

                attributes.$observe('video', function ()
                {
                    if (scope.video && scope.video.player())
                    {
                        var isDragging = false;

                        _slider.on('slidestart', function () {
                            if (!scope.video.player().paused())
                                scope.video.player().pause();
                            isDragging = true;
                            scope.$parent.$apply();
                        });

                        _slider.on('slidestop', function () {
                            moveVideo();
                            if (scope.video.player().paused())
                                scope.video.player().play();
                            isDragging = false;
                            scope.$parent.$apply();
                        });

                        scope.video.player().on('timeupdate', function () {
                            if (!isDragging)
                            {
                                var position = (100 * scope.video.player().currentTime()) / scope.video.player().duration();
                                _slider = element.slider(setup);
                                _slider.slider('value', position);
                            }
                        });
                    }
                });

                if(App.config().getAttr('restricted'))
                    _slider.slider('disable');

                scope.$watch('blocked', function(value)
                {
                    if(!value)
                        _slider.slider('enable');
                    else
                        _slider.slider('disable');
                });
            });
        }
    }
}]);


app.directive("ngMobileClick", [function () {
    return function (scope, elem, attrs) {
        elem.bind("touchstart click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            scope.$apply(attrs["ngMobileClick"]);
        });
    }
}]);



(function() {
    'use strict';

    var FirstLetterFilter = function () {
        return _.memoize(function(input, letter, label) {
            var input = input || [];
            var out = [];
            input.forEach(function (item) {
                if (item.getAttr(label).charAt(0).toLowerCase() == letter) {
                    out.push(item);
                }
            });
            return out;
        }, function(input, letter, label){
            return letter
        });
    };

    angular.module('Application').filter('firstLetter', FirstLetterFilter);
})();



app.factory('App', ['$http', 'Module', 'Model', 'Panel', 'Event', '$window', '$timeout', '$translate', '$rootScope','Sound',
    function ($http, Module, Model, Panel, Event, $window, $timeout, $translate, $rootScope,Sound) {

        var config = false;
        var loaded = false;

        var modules = [];
        var pages = [];
        var _openMenu = false;

        var audioEndedInstance = false;
        var audioEnded = "ended";

        var audioEndedPlayed = false;

        var eventer = Event.create('app');

        var panels = {
            resume: Panel.create('app.resume'),
            closer: Panel.create('app.closer'),
            logout: Panel.create('app.logout')
        };

        // modulo in cui mi trovo adesso
        var currentModule = false;

        // a little object of configurations
        function Config(data) {
            var model = Model.create({
                attrs: data,
                name: 'app.config'
            });

            // check if app navigation is free
            model.isFree = function () {
                return !model.getAttr('restricted');
            };

            /**
             * @description check if navigation is limited in lesson
             * @return {boolean}
             */
            model.isNavLimitedOnLesson = function() {
                return model.getAttr('layout').nav === 'limited';
            };

            return model;
        };

        var promise = $http.get('config/index.json').success(function (data) {
            config = new Config(data);
            loaded = true;
            modules = Module.collection(config.getAttr('structure').modules);
        });

        $($window).resize(function () {
            if($('slick').length) {
                var slick = $('slick')[0].slick;
                slick.slickSetOption('slidesToShow', service.getSlidesToShow(), true);
                slick.slickSetOption('slidesToScroll', 1, true);
                slick.reinit();
            }
        });

        var service = {
            promise: promise,
            loaded: function () {
                return loaded;
            },
            pages: function () {
                if (!pages.length) {
                    _.each(modules.all(), function (m) {
                        _.each(m.lessons().all(), function (l) {
                            pages = pages.concat(l.pages().all());
                        });
                    });
                }
                ;
                return pages;
            },
            course: function () {
                return this.config().getAttr('structure').course;
            },
            /**
             * @description get current page number
             * @return {*}
             */
            getCurrentPageNumber() {
                if (!this.module()) return;

                // if navigation is limited only in lesson
                if (this.config().isNavLimitedOnLesson())
                    return this.module().lesson().pages().getCurrentNumber();

                let page = this.module().lesson().page();
                return _.indexOf(this.pages(), page) + 1;
            },
            /**
             * @description get max page number
             * @return int
             */
            getMaxPageNumber() {
                if (this.config().getAttr('layout').nav === 'limited')
                    return this.module().lesson().pages().count();
                return this.pages().length
            },
            // ottengo la struttura dei moduli
            structure: function () {
                return modules;
            },
            layout: function () {
                return config.layout;
            },
            // ottengo la pagina corrente
            page: function () {
                return this.lesson().page();
            },
            // ottengo la lezione corrente
            lesson: function () {
                return this.module().lesson();
            },
            // ottengo il modulo corrente
            module: function () {
                if (currentModule === false) return;
                return this.structure().current();
            },
            modules: function () {
                return this.structure();
            },
            nextModule: function () {
                if (this.structure().isAtTheEnd())
                    return false;

                this.modules().next();
                this.module().setCurrentLesson(0);
                return this;
            },
            prevModule: function () {
                if (this.structure().isAtTheStart())
                    return false;

                if (currentModule > 0)
                    currentModule--;

                this.modules().setCurrent(currentModule);
                this.module().setCurrentLesson(0);
                return this;
            },

            openMenu:function(val){
                return _openMenu=val;
            },

            getOpenMenu:function(){
                // console.log("_openMenu "+ _openMenu)
                return _openMenu;
            },
            /**
             * @description open module
             * @param i
             * @return {*}
             */
            goToModule: function (i) {
                if(i>0 && !config.isFree() && !this.modules().get(i-1).isViewed())
                    return false;

                eventer.emit('module.open.pre');
                currentModule = i;
                this.modules().setCurrent(currentModule);
                this.module().setCurrentLesson(0);
                this.module().lesson().setCurrentPage(0);
                
                // if(!this.module().lesson().pages().isAtTheStart()) {
                //     panels.resume.open();
                // }
                // else {
                    // var currentPage = this.getCurrentPageNumber() - 1;
                    // this.module().lesson().setCurrentPage(currentPage);
                // }
                eventer.emit('module.open');

                return this;
            },
            goTo: function (iModule, iLesson, iPage) {
                var _this = this;

                if (!config.isFree()) {
                    if (iModule > 0 && !_this.modules().get(iModule - 1).isViewed()) {
                        return;
                    }
                    if (iLesson > 0 && !_this.modules().get(iModule).lessons().get(iLesson - 1).isViewed()) {
                        return;
                    }
                    if (iPage > 0 && !_this.modules().get(iModule).lessons().get(iLesson).pages().get(iPage - 1).isViewed()) {
                        return;
                    }
                }

                if (
                    iModule > 0 &&
                    iLesson > 0 &&
                    iPage > 0 &&
                    !_this.modules().get(iModule).lessons().get(iLesson).pages().get(iPage).isViewed() &&
                    !config.isFree()
                ) {
                    // console.log("RETURNNNNNNNN");
                    return;
                }

                _this.modules().setCurrent(iModule);
                currentModule = iModule;
                _this.module().setCurrentLesson(iLesson);
                _this.module().lesson().setCurrentPage(iPage);

                eventer.emit('menu.change');

                return _this;
            },
            closeModule: function () {
                eventer.emit('module.close');
                currentModule = false;
                // Sometimes slick is reinitialized and
                // not look good on page, goTo fix this
                // abruptely
                if($('slick').length) {
                    var slick = $('slick')[0].slick;
                    slick.goTo(slick.getCurrent());
                }
                
            },
            setFirstPageToView: function (i) {
                var page = this.pages()[i];
                var found = false;
                _.each(this.structure().all(), function (module, mKey) {
                    _.each(module.lessons().all(), function (lesson, lKey) {
                        _.each(lesson.pages().all(), function (p, pKey) {
                            if (page == p) {
                                currentModule = mKey;
                                module.setCurrentLesson(lKey);
                                lesson.setCurrentPage(pKey);
                                return;
                            }
                        });

                        if (found) return;
                    });

                    if (found) return;
                });

                return this;
            },
            /**
             * @description go to first page of lesson
             */
            goToFirstPageOfLesson: function() {
                this.module().lesson().pages().setCurrent(0);
                this.panels.resume.close();
                return this;
            },
            goToPageByIndex: function(i) {
                i = i - 1;
                // console.log(i);

                var found = false;
                var page = this.pages()[i];
                // console.log(page.getAttr('title'));
                _.each(this.structure().all(), function (module, mKey) {
                    _.each(module.lessons().all(), function (lesson, lKey) {
                        _.each(lesson.pages().all(), function (p, pKey) {
                            if (page == p) {
                                currentModule = mKey;
                                service.modules().setCurrent(currentModule);
                                module.setCurrentLesson(lKey);
                                lesson.setCurrentPage(pKey);
                                return;
                            }
                        });

                        if (found) return;
                    });

                    if (found) return;
                });

                this.panels.resume.close();
            },
            config: function () {
                return config;
            },
            panels: panels,
            logout: function () {
                panels.logout.open();
                eventer.emit('logout');
            },
            refresh: function () {
                eventer.emit('refresh');
                return false;
            },
            isAtLastPage: function () {
                return this.getCurrentPageNumber() == this.pages().length;
            },
            hasNextPage: function () {
                
                if (this.config().isNavLimitedOnLesson())
                    if (this.module().lesson().pages().isAtTheEnd()) return false;

                if (!this.module().lesson().pages().isAtTheEnd())
                    return true;

                if (!this.module().lessons().isAtTheEnd())
                    return true;

                if (!this.modules().isAtTheEnd())
                    return true;

                return false;
            },
            hasPrevPage: function () {
                if(this.config().isNavLimitedOnLesson()) {
                    if (this.module().lesson().pages().isAtTheStart()) return false;
                    return true;
                }

                if (!this.modules().isAtTheStart())
                    return true;

                if (!this.module().lessons().isAtTheStart())
                    return true;

                if (!this.module().lesson().pages().isAtTheStart())
                    return true;

                return false;
            },
            events: eventer,
            exitFullscreen: function () {
                if (document.fullscreenElement && document.exitFullscreen) {
                    document.exitFullscreen();
                }
                else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                }
                else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
                else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                else if (document.msCancelFullScreen) {
                    document.msCancelFullScreen();
                }
            },
            getSlidesToShow: function () {
                var w = $(window).width();
                // return 1;

                switch (true) {
                    case (w <= 768):
                        return 4;
                        break;

                    case (w > 1200):
                        return 6;
                        break;

                    case (w <= 1200):
                        return 8;
                        break;
                }
            },
            /**
             * @description get score lesson
             * @return {number}
             */
            score() {
                let score = 0;
                this.modules().forEach((module) => score += module.score());
                // console.log("AppSCORE", score);
                return score;
            },

            /**
             * @description get score lesson (only lesson with exercises)
             * @return {number}
             */
            scoreEx() {
                let score = 0;
                this.modules().forEach((module, index) => {
                    if (index > 0 && index < 5) score += module.score()}
                );
                // console.log("AppSCORE", score);
                return score;
            },

            percScore() {
                return Math.round(this.score() * 100 / this.maxScore());
            },

            /**
             * @description get max score
             * @return {number}
             */
            maxScore() {
                let score = 0;
                this.modules().forEach(module => score += module.maxScore());
                return score;
            },
            /**
             * @description get max score (only lesson with exercises)
             * @return {number}
             */
            maxExScore() {
                let score = 0;
                this.modules().forEach((module, index) => {
                    if (index > 0 && index < 5) score += module.maxScore()
                });
                return score;
            },
            getLastViewedModuleID() {
                let id = 6;
                let mod = _.find(this.modules().all(), (module, index) => {
                    if (!module.isViewed()) { id = index; return true; };
                });
                return id;
            },
            getGaugeValue() {
                return Math.round(this.scoreEx() * 100 / this.maxExScore());
            },
            toggleAudio: function () {
                if(this.module().lesson().page().video()) {
                    var audioIsMuted = ! this.module().lesson().page().video().player().muted()
                    this.module().lesson().page().video().player().muted(audioIsMuted);
                }
            },
            audioIsPlaying: function () {
                return this.module().lesson().page().video() ? (! this.module().lesson().page().video().player().muted()) : false;
            },
            isCurrentModule: function (module) {
                return (this.module() == module);
            },
            areAllModulesViewed: function() {
                var allViewed = true;
                this.modules().forEach((module) => {
                    if (!module.isViewed()) allViewed = false;
                });
                return allViewed;
            },
            goToPageByAbsIndex: function(pageIndex) {

                var _this = this;
                var moduleIndex = _.indexOf(_this.modules().all(), _this.module());
                var lessonIndex = _.indexOf(_this.module().lessons().all(), _this.lesson());

                if (
                    pageIndex > 0 &&
                    !_this.module().lessons().get(lessonIndex).pages().get(pageIndex-1).isViewed()
                    && !config.isFree()
                ) {
                    return;
                }

                _this.modules().setCurrent(moduleIndex);
                _this.module().setCurrentLesson(lessonIndex);
                _this.module().lesson().setCurrentPage(pageIndex);
                
                eventer.emit('menu.change');

                return _this;
            },
            goWhereYouLeft: function() {
                // if (this.isThereAUnitPending()) {
                    
                    currentModule = this.getLastViewedModuleID();
                    if (!config.isFree() && (currentModule > 0 && !this.modules().get(currentModule-1).isViewed())) 
                        return false;

                    eventer.emit('module.open.pre');
                        
                    this.modules().setCurrent(currentModule);
                    // this.module().setCurrentLesson(0);

                    // if(!this.module().lesson().pages().isAtTheStart()) {
                    //     console.log("OPEN");
                    //     panels.resume.open();
                    // }

                    eventer.emit('module.open');
                // }
                
                this.panels.resume.close();

                return this;

            },
            justCloseResumePanel: function() {
                // Reset bookmark for all units
                _.each(modules.all(), function (m) {
                    _.each(m.lessons().all(), function (l) {
                        l.setCurrentPage(0);
                    });
                });

                this.panels.resume.close();
            },
            isResumable: function() {
                var _return = true;

                this.isThereAUnitPending();

                if (isResumed) {
                    _return = false;
                    return _return;
                }

                if (this.areAllModulesViewed()) {
                    _return = false;
                    return _return;
                }

                if (
                    this.getLastViewedModuleID() == 0 &&
                    this.modules().get(0).lesson().pages().currentIndex() == 0
                ) {
                    _return = false;
                    return _return;   
                }

                panels.resume.open();

                return _return;
            },
            isThereAUnitPending: function() {
                var _return = false;
                _.each(modules.all(), function (m) {
                    _.each(m.lessons().all(), function (l) {
                        var pagesCompletions = _.countBy(_.invoke(l.pages().all(), 'isViewed'));
                        // console.log("IF", l.pages().isAtTheStart() && !! pagesCompletions.true && !! pagesCompletions.false);
                        // console.log(l.pages().isAtTheStart(), !! pagesCompletions.true, !! pagesCompletions.false);
                        if (
                            // l.pages().isAtTheStart() && 
                            !! pagesCompletions.true && !! pagesCompletions.false) {
                            _return = true;
                            return _return;
                        }
                        // console.log("---------------------------------------------");
                    });
                });
                // console.log("*** isThereAUnitPending?", _return);
                return _return;
            },
            hasFinalAudioBeenPlayed: function() {
                return audioEndedPlayed;
            },
            setFinalAudioAsPlayed: function() {
                audioEndedPlayed = true;
                return this;
            },
            finalTestModule: function() {
                return _.find(modules.all(), function (m) {
                    return m.isFinalTest();
                });
            },
            isFinalTestPassed: function() {
                // console.log(this.finalTestModule());
                if (!this.finalTestModule())
                    return false;
                return this.finalTestModule().finalTestPercentage() > this.config().getAttr('layout').masteryScore || this.finalTestModule().getAttr('passed');
            },
            isMobile: function() {
                return isMobile.any;
            },
            isPhone: function() {
                return isMobile.phone;
            },
            isPortrait: function() {
                return (window.innerHeight > window.innerWidth);
            },
            downloadGlossary: function () {
                $window.open($translate.instant('course.glossary'), "_blank");
                return;
            }
        };

        var isResumed = false;

        panels.closer.on('open', function () {
            // $timeout(function() {
            if (
                service.module() &&
                service.module().lesson() &&
                service.module().lesson().page() &&
                service.module().lesson().page().video()) {
                service.module().lesson().page().video().pause();
            }
            // }, 500);
        });

        panels.resume.on('close', function () {
            isResumed = true;

            // $timeout(function() { 
                // if (service.module().lesson().page().video())
                //     service.module().lesson().page().video().play();
            // }, 500);
        });

        eventer.on('module.open', function () {
            isResumed = true;
            if (audioEndedInstance) {
                audioEndedInstance.stop();
            }
        });

        return service;
    }]);


/*! =========================================================
 * bootstrap-slider.js
 *
 * Maintainers: 
 *      Kyle Kemp 
 *          - Twitter: @seiyria
 *          - Github:  seiyria
 *      Rohit Kalkur
 *          - Twitter: @Rovolutionary
 *          - Github:  rovolution
 *
 * =========================================================
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */


/**
 * Bridget makes jQuery widgets
 * v1.0.1
 * MIT license
 */
(function ($) {

    (function ($) {

        'use strict';

        // -------------------------- utils -------------------------- //

        if (typeof String.prototype.trim !== 'function') {
            String.prototype.trim = function () {
                return this.replace(/^\s+|\s+$/g, '');
            }
        }

        if (!Array.prototype.indexOf)
        {
            Array.prototype.indexOf = function (elt /*, from*/)
            {
                var len = this.length >>> 0;

                var from = Number(arguments[1]) || 0;
                from = (from < 0)
                        ? Math.ceil(from)
                        : Math.floor(from);
                if (from < 0)
                    from += len;

                for (; from < len; from++)
                {
                    if (from in this &&
                            this[from] === elt)
                        return from;
                }
                return -1;
            };
        }

        var slice = Array.prototype.slice;

        function noop() {
        }

        if (!Function.prototype.bind) {
            Function.prototype.bind = function (oThis) {
                if (typeof this !== "function") {
                    // closest thing possible to the ECMAScript 5
                    // internal IsCallable function
                    throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
                }

                var aArgs = Array.prototype.slice.call(arguments, 1),
                        fToBind = this,
                        fNOP = function () {
                        },
                        fBound = function () {
                            return fToBind.apply(this instanceof fNOP && oThis
                                    ? this
                                    : oThis,
                                    aArgs.concat(Array.prototype.slice.call(arguments)));
                        };

                fNOP.prototype = this.prototype;
                fBound.prototype = new fNOP();

                return fBound;
            };
        }

        // -------------------------- definition -------------------------- //

        function defineBridget($) {

            // bail if no jQuery
            if (!$) {
                return;
            }

            // -------------------------- addOptionMethod -------------------------- //

            /**
             * adds option method -> $().plugin('option', {...})
             * @param {Function} PluginClass - constructor class
             */
            function addOptionMethod(PluginClass) {
                // don't overwrite original option method
                if (PluginClass.prototype.option) {
                    return;
                }

                // option setter
                PluginClass.prototype.option = function (opts) {
                    // bail out if not an object
                    if (!$.isPlainObject(opts)) {
                        return;
                    }
                    this.options = $.extend(true, this.options, opts);
                };
            }


            // -------------------------- plugin bridge -------------------------- //

            // helper function for logging errors
            // $.error breaks jQuery chaining
            var logError = typeof console === 'undefined' ? noop :
                    function (message) {
                        console.error(message);
                    };

            /**
             * jQuery plugin bridge, access methods like $elem.plugin('method')
             * @param {String} namespace - plugin name
             * @param {Function} PluginClass - constructor class
             */
            function bridge(namespace, PluginClass) {
                // add to jQuery fn namespace
                $.fn[ namespace ] = function (options) {
                    if (typeof options === 'string') {
                        // call plugin method when first argument is a string
                        // get arguments for method
                        var args = slice.call(arguments, 1);

                        for (var i = 0, len = this.length; i < len; i++) {
                            var elem = this[i];
                            var instance = $.data(elem, namespace);
                            if (!instance) {
                                logError("cannot call methods on " + namespace + " prior to initialization; " +
                                        "attempted to call '" + options + "'");
                                continue;
                            }
                            if (!$.isFunction(instance[options]) || options.charAt(0) === '_') {
                                logError("no such method '" + options + "' for " + namespace + " instance");
                                continue;
                            }

                            // trigger method with arguments
                            var returnValue = instance[ options ].apply(instance, args);

                            // break look and return first value if provided
                            if (returnValue !== undefined && returnValue !== instance) {
                                return returnValue;
                            }
                        }
                        // return this if no return value
                        return this;
                    } else {
                        var objects = this.map(function () {
                            var instance = $.data(this, namespace);
                            if (instance) {
                                // apply options & init
                                instance.option(options);
                                instance._init();
                            } else {
                                // initialize new instance
                                instance = new PluginClass(this, options);
                                $.data(this, namespace, instance);
                            }
                            return $(this);
                        });

                        if (!objects || objects.length > 1) {
                            return objects;
                        } else {
                            return objects[0];
                        }
                    }
                };

            }

            // -------------------------- bridget -------------------------- //

            /**
             * converts a Prototypical class into a proper jQuery plugin
             *   the class must have a ._init method
             * @param {String} namespace - plugin name, used in $().pluginName
             * @param {Function} PluginClass - constructor class
             */
            $.bridget = function (namespace, PluginClass) {
                addOptionMethod(PluginClass);
                bridge(namespace, PluginClass);
            };

            return $.bridget;

        }

        // get jquery from browser global
        defineBridget($);

    })($);


    /*************************************************
     
     BOOTSTRAP-SLIDER SOURCE CODE
     
     **************************************************/

    (function ($) {

        var ErrorMsgs = {
            formatInvalidInputErrorMsg: function (input) {
                return "Invalid input value '" + input + "' passed in";
            },
            callingContextNotSliderInstance: "Calling context element does not have instance of Slider bound to it. Check your code to make sure the JQuery object returned from the call to the slider() initializer is calling the method"
        };



        /*************************************************
         
         CONSTRUCTOR
         
         **************************************************/
        var Slider = function (element, options) {
            createNewSlider.call(this, element, options);
            return this;
        };

        function createNewSlider(element, options) {
            /*************************************************
             
             Create Markup
             
             **************************************************/
            if (typeof element === "string") {
                this.element = document.querySelector(element);
            } else if (element.nodeType === 1) {
                this.element = element;
            }

            var origWidth = this.element.style.width;
            var updateSlider = false;
            var parent = this.element.parentNode;
            var sliderTrackSelection;
            var sliderMinHandle;
            var sliderMaxHandle;

            if (this.sliderElem) {
                updateSlider = true;
            } else {
                /* Create elements needed for slider */
                this.sliderElem = document.createElement("div");
                this.sliderElem.className = "slider";

                /* Create slider track elements */
                var sliderTrack = document.createElement("div");
                sliderTrack.className = "slider-track";

                sliderTrackSelection = document.createElement("div");
                sliderTrackSelection.className = "slider-selection";

                sliderMinHandle = document.createElement("div");
                sliderMinHandle.className = "slider-handle min-slider-handle";

                sliderMaxHandle = document.createElement("div");
                sliderMaxHandle.className = "slider-handle max-slider-handle";

                sliderTrack.appendChild(sliderTrackSelection);
                sliderTrack.appendChild(sliderMinHandle);
                sliderTrack.appendChild(sliderMaxHandle);

                var createAndAppendTooltipSubElements = function (tooltipElem) {
                    var arrow = document.createElement("div");
                    arrow.className = "tooltip-arrow";

                    var inner = document.createElement("div");
                    inner.className = "tooltip-inner";

                    tooltipElem.appendChild(arrow);
                    tooltipElem.appendChild(inner);
                };

                /* Create tooltip elements */
                var sliderTooltip = document.createElement("div");
                sliderTooltip.className = "tooltip tooltip-main";
                createAndAppendTooltipSubElements(sliderTooltip);

                var sliderTooltipMin = document.createElement("div");
                sliderTooltipMin.className = "tooltip tooltip-min";
                createAndAppendTooltipSubElements(sliderTooltipMin);

                var sliderTooltipMax = document.createElement("div");
                sliderTooltipMax.className = "tooltip tooltip-max";
                createAndAppendTooltipSubElements(sliderTooltipMax);


                /* Append components to sliderElem */
                this.sliderElem.appendChild(sliderTrack);
                this.sliderElem.appendChild(sliderTooltip);
                this.sliderElem.appendChild(sliderTooltipMin);
                this.sliderElem.appendChild(sliderTooltipMax);

                /* Append slider element to parent container, right before the original <input> element */
                parent.insertBefore(this.sliderElem, this.element);

                /* Hide original <input> element */
                this.element.style.display = "none";
            }
            /* If JQuery exists, cache JQ references */
            if ($) {
                this.$element = $(this.element);
                this.$sliderElem = $(this.sliderElem);
            }

            /*************************************************
             
             Process Options
             
             **************************************************/
            options = options ? options : {};
            // FIX IE8
            if (!Object.keys)
            {
                Object.keys = function (o) {
                    if (o !== Object(o))
                        throw new TypeError('Object.keys called on non-object');
                    var ret = [], p;
                    for (p in o)
                        if (Object.prototype.hasOwnProperty.call(o, p))
                            ret.push(p);
                    return ret;
                }
            }
            var optionTypes = Object.keys(this.defaultOptions);

            for (var i = 0; i < optionTypes.length; i++) {
                var optName = optionTypes[i];

                // First check if an option was passed in via the constructor
                var val = options[optName];
                // If no data attrib, then check data atrributes
                val = (typeof val !== 'undefined') ? val : getDataAttrib(this.element, optName);
                // Finally, if nothing was specified, use the defaults
                val = (val !== null) ? val : this.defaultOptions[optName];

                // Set all options on the instance of the Slider
                if (!this.options) {
                    this.options = {};
                }
                this.options[optName] = val;
            }

            function getDataAttrib(element, optName) {
                var dataName = "data-slider-" + optName;
                var dataValString = element.getAttribute(dataName);

                try {
                    return JSON.parse(dataValString);
                }
                catch (err) {
                    return dataValString;
                }
            }

            /*************************************************
             
             Setup
             
             **************************************************/
            this.eventToCallbackMap = {};
            this.sliderElem.id = this.options.id;

            this.touchCapable = 'ontouchstart' in window || (window.DocumentTouch && document instanceof window.DocumentTouch);

            this.tooltip = this.sliderElem.querySelector('.tooltip-main');
            this.tooltipInner = this.tooltip.querySelector('.tooltip-inner');

            this.tooltip_min = this.sliderElem.querySelector('.tooltip-min');
            this.tooltipInner_min = this.tooltip_min.querySelector('.tooltip-inner');

            this.tooltip_max = this.sliderElem.querySelector('.tooltip-max');
            this.tooltipInner_max = this.tooltip_max.querySelector('.tooltip-inner');

            if (updateSlider === true) {
                // Reset classes
                this._removeClass(this.sliderElem, 'slider-horizontal');
                this._removeClass(this.sliderElem, 'slider-vertical');
                this._removeClass(this.tooltip, 'hide');
                this._removeClass(this.tooltip_min, 'hide');
                this._removeClass(this.tooltip_max, 'hide');

                // Undo existing inline styles for track
                ["left", "top", "width", "height"].forEach(function (prop) {
                    this._removeProperty(this.trackSelection, prop);
                }, this);

                // Undo inline styles on handles
                [this.handle1, this.handle2].forEach(function (handle) {
                    this._removeProperty(handle, 'left');
                    this._removeProperty(handle, 'top');
                }, this);

                // Undo inline styles and classes on tooltips
                [this.tooltip, this.tooltip_min, this.tooltip_max].forEach(function (tooltip) {
                    this._removeProperty(tooltip, 'left');
                    this._removeProperty(tooltip, 'top');
                    this._removeProperty(tooltip, 'margin-left');
                    this._removeProperty(tooltip, 'margin-top');

                    this._removeClass(tooltip, 'right');
                    this._removeClass(tooltip, 'top');
                }, this);
            }

            if (this.options.orientation === 'vertical') {
                this._addClass(this.sliderElem, 'slider-vertical');

                this.stylePos = 'top';
                this.mousePos = 'pageY';
                this.sizePos = 'offsetHeight';

                this._addClass(this.tooltip, 'right');
                this.tooltip.style.left = '100%';

                this._addClass(this.tooltip_min, 'right');
                this.tooltip_min.style.left = '100%';

                this._addClass(this.tooltip_max, 'right');
                this.tooltip_max.style.left = '100%';
            } else {
                this._addClass(this.sliderElem, 'slider-horizontal');
                this.sliderElem.style.width = origWidth;

                this.options.orientation = 'horizontal';
                this.stylePos = 'left';
                this.mousePos = 'pageX';
                this.sizePos = 'offsetWidth';

                this._addClass(this.tooltip, 'top');
                this.tooltip.style.top = -$(this.tooltip).outerHeight() - 14 + 'px';

                this._addClass(this.tooltip_min, 'top');
                this.tooltip_min.style.top = -$(this.tooltip_min).outerHeight() - 14 + 'px';

                this._addClass(this.tooltip_max, 'top');
                this.tooltip_max.style.top = -$(this.tooltip_max).outerHeight() - 14 + 'px';
            }

            if (this.options.value instanceof Array) {
                this.options.range = true;
            } else if (this.options.range) {
                // User wants a range, but value is not an array
                this.options.value = [this.options.value, this.options.max];
            }

            this.trackSelection = sliderTrackSelection || this.trackSelection;
            if (this.options.selection === 'none') {
                this._addClass(this.trackSelection, 'hide');
            }

            this.handle1 = sliderMinHandle || this.handle1;
            this.handle2 = sliderMaxHandle || this.handle2;

            if (updateSlider === true) {
                // Reset classes
                this._removeClass(this.handle1, 'round triangle');
                this._removeClass(this.handle2, 'round triangle hide');
            }

            var availableHandleModifiers = ['round', 'triangle', 'custom'];
            var isValidHandleType = availableHandleModifiers.indexOf(this.options.handle) !== -1;
            if (isValidHandleType) {
                this._addClass(this.handle1, this.options.handle);
                this._addClass(this.handle2, this.options.handle);
            }

            this.offset = this._offset(this.sliderElem);
            this.size = this.sliderElem[this.sizePos];
            this.setValue(this.options.value);

            /******************************************
             
             Bind Event Listeners
             
             ******************************************/

            // Bind keyboard handlers
            this.handle1Keydown = this._keydown.bind(this, 0);
            function addEventListener(element, event, value) {
                if (element.addEventListener)
                {
                    return element.addEventListener(event, value, false);
                }
                else {
                    return element.attachEvent(event, value);
                }
            }
            addEventListener(this.handle1, "keydown", this.handle1Keydown);

            this.handle2Keydown = this._keydown.bind(this, 0);
            addEventListener(this.handle2, "keydown", this.handle2Keydown);

            if (this.touchCapable) {
                // Bind touch handlers
                this.mousedown = this._mousedown.bind(this);
                addEventListener(this.sliderElem, "touchstart", this.mousedown);
            } else {
                // Bind mouse handlers
                this.mousedown = this._mousedown.bind(this);
                addEventListener(this.sliderElem, "mousedown", this.mousedown);
            }

            // Bind tooltip-related handlers
            if (this.options.tooltip === 'hide') {
                this._addClass(this.tooltip, 'hide');
                this._addClass(this.tooltip_min, 'hide');
                this._addClass(this.tooltip_max, 'hide');
            } else if (this.options.tooltip === 'always') {
                this._showTooltip();
                this._alwaysShowTooltip = true;
            } else {
                this.showTooltip = this._showTooltip.bind(this);
                this.hideTooltip = this._hideTooltip.bind(this);

                this.sliderElem.addEventListener("mouseenter", this.showTooltip, false);
                this.sliderElem.addEventListener("mouseleave", this.hideTooltip, false);

                this.handle1.addEventListener("focus", this.showTooltip, false);
                this.handle1.addEventListener("blur", this.hideTooltip, false);

                this.handle2.addEventListener("focus", this.showTooltip, false);
                this.handle2.addEventListener("blur", this.hideTooltip, false);
            }

            if (this.options.enabled) {
                this.enable();
            } else {
                this.disable();
            }
        }

        /*************************************************
         
         INSTANCE PROPERTIES/METHODS
         
         - Any methods bound to the prototype are considered 
         part of the plugin's `public` interface
         
         **************************************************/
        Slider.prototype = {
            _init: function () {
            }, // NOTE: Must exist to support bridget

            constructor: Slider,
            defaultOptions: {
                id: "",
                min: 0,
                max: 10,
                step: 1,
                precision: 0,
                orientation: 'horizontal',
                value: 5,
                range: false,
                selection: 'before',
                tooltip: 'show',
                tooltip_split: false,
                handle: 'round',
                reversed: false,
                enabled: true,
                formatter: function (val) {
                    if (val instanceof Array) {
                        return val[0] + " : " + val[1];
                    } else {
                        return val;
                    }
                },
                natural_arrow_keys: false
            },
            over: false,
            inDrag: false,
            getValue: function () {
                if (this.options.range) {
                    return this.options.value;
                }
                return this.options.value[0];
            },
            setValue: function (val, triggerSlideEvent) {
                if (!val) {
                    val = 0;
                }
                this.options.value = this._validateInputValue(val);
                var applyPrecision = this._applyPrecision.bind(this);

                if (this.options.range) {
                    this.options.value[0] = applyPrecision(this.options.value[0]);
                    this.options.value[1] = applyPrecision(this.options.value[1]);

                    this.options.value[0] = Math.max(this.options.min, Math.min(this.options.max, this.options.value[0]));
                    this.options.value[1] = Math.max(this.options.min, Math.min(this.options.max, this.options.value[1]));
                } else {
                    this.options.value = applyPrecision(this.options.value);
                    this.options.value = [Math.max(this.options.min, Math.min(this.options.max, this.options.value))];
                    this._addClass(this.handle2, 'hide');
                    if (this.options.selection === 'after') {
                        this.options.value[1] = this.options.max;
                    } else {
                        this.options.value[1] = this.options.min;
                    }
                }

                this.diff = this.options.max - this.options.min;
                if (this.diff > 0) {
                    this.percentage = [
                        (this.options.value[0] - this.options.min) * 100 / this.diff,
                        (this.options.value[1] - this.options.min) * 100 / this.diff,
                        this.options.step * 100 / this.diff
                    ];
                } else {
                    this.percentage = [0, 0, 100];
                }

                this._layout();

                var sliderValue = this.options.range ? this.options.value : this.options.value[0];
                this._setDataVal(sliderValue);

                if (triggerSlideEvent === true) {
                    this._trigger('slide', sliderValue);
                }

                return this;
            },
            destroy: function () {
                // Remove event handlers on slider elements
                this._removeSliderEventHandlers();

                // Remove the slider from the DOM
                this.sliderElem.parentNode.removeChild(this.sliderElem);
                /* Show original <input> element */
                this.element.style.display = "";

                // Clear out custom event bindings
                this._cleanUpEventCallbacksMap();

                // Remove data values
                this.element.removeAttribute("data");

                // Remove JQuery handlers/data
                if ($) {
                    this._unbindJQueryEventHandlers();
                    this.$element.removeData('slider');
                }
            },
            disable: function () {
                this.options.enabled = false;
                this.handle1.removeAttribute("tabindex");
                this.handle2.removeAttribute("tabindex");
                this._addClass(this.sliderElem, 'slider-disabled');
                this._trigger('slideDisabled');

                return this;
            },
            enable: function () {
                this.options.enabled = true;
                this.handle1.setAttribute("tabindex", 0);
                this.handle2.setAttribute("tabindex", 0);
                this._removeClass(this.sliderElem, 'slider-disabled');
                this._trigger('slideEnabled');

                return this;
            },
            toggle: function () {
                if (this.options.enabled) {
                    this.disable();
                } else {
                    this.enable();
                }

                return this;
            },
            isEnabled: function () {
                return this.options.enabled;
            },
            on: function (evt, callback) {
                if ($) {
                    this.$element.on(evt, callback);
                    this.$sliderElem.on(evt, callback);
                } else {
                    this._bindNonQueryEventHandler(evt, callback);
                }
                return this;
            },
            getAttribute: function (attribute) {
                if (attribute) {
                    return this.options[attribute];
                } else {
                    return this.options;
                }
            },
            setAttribute: function (attribute, value) {
                this.options[attribute] = value;
                return this;
            },
            refresh: function () {
                this._removeSliderEventHandlers();
                createNewSlider.call(this, this.element, this.options);
                if ($) {
                    // Bind new instance of slider to the element
                    $.data(this.element, 'slider', this);
                }
                return this;
            },
            /******************************+
             
             HELPERS
             
             - Any method that is not part of the public interface.
             - Place it underneath this comment block and write its signature like so:
             
             _fnName : function() {...}
             
             ********************************/
            _removeSliderEventHandlers: function () {
                // Remove event listeners from handle1
                this.handle1.removeEventListener("keydown", this.handle1Keydown, false);
                this.handle1.removeEventListener("focus", this.showTooltip, false);
                this.handle1.removeEventListener("blur", this.hideTooltip, false);

                // Remove event listeners from handle2
                this.handle2.removeEventListener("keydown", this.handle2Keydown, false);
                this.handle2.removeEventListener("focus", this.handle2Keydown, false);
                this.handle2.removeEventListener("blur", this.handle2Keydown, false);

                // Remove event listeners from sliderElem
                this.sliderElem.removeEventListener("mouseenter", this.showTooltip, false);
                this.sliderElem.removeEventListener("mouseleave", this.hideTooltip, false);
                this.sliderElem.removeEventListener("touchstart", this.mousedown, false);
                this.sliderElem.removeEventListener("mousedown", this.mousedown, false);
            },
            _bindNonQueryEventHandler: function (evt, callback) {
                if (this.eventToCallbackMap[evt] === undefined) {
                    this.eventToCallbackMap[evt] = [];
                }
                this.eventToCallbackMap[evt].push(callback);
            },
            _cleanUpEventCallbacksMap: function () {
                var eventNames = Object.keys(this.eventToCallbackMap);
                for (var i = 0; i < eventNames.length; i++) {
                    var eventName = eventNames[i];
                    this.eventToCallbackMap[eventName] = null;
                }
            },
            _showTooltip: function () {
                if (this.options.tooltip_split === false) {
                    this._addClass(this.tooltip, 'in');
                } else {
                    this._addClass(this.tooltip_min, 'in');
                    this._addClass(this.tooltip_max, 'in');
                }
                this.over = true;
            },
            _hideTooltip: function () {
                if (this.inDrag === false && this.alwaysShowTooltip !== true) {
                    this._removeClass(this.tooltip, 'in');
                    this._removeClass(this.tooltip_min, 'in');
                    this._removeClass(this.tooltip_max, 'in');
                }
                this.over = false;
            },
            _layout: function () {
                var positionPercentages;

                if (this.options.reversed) {
                    positionPercentages = [100 - this.percentage[0], this.percentage[1]];
                } else {
                    positionPercentages = [this.percentage[0], this.percentage[1]];
                }

                this.handle1.style[this.stylePos] = positionPercentages[0] + '%';
                this.handle2.style[this.stylePos] = positionPercentages[1] + '%';

                if (this.options.orientation === 'vertical') {
                    this.trackSelection.style.top = Math.min(positionPercentages[0], positionPercentages[1]) + '%';
                    this.trackSelection.style.height = Math.abs(positionPercentages[0] - positionPercentages[1]) + '%';
                } else {
                    this.trackSelection.style.left = Math.min(positionPercentages[0], positionPercentages[1]) + '%';
                    this.trackSelection.style.width = Math.abs(positionPercentages[0] - positionPercentages[1]) + '%';

                    var offset_min = this.tooltip_min.getBoundingClientRect();
                    var offset_max = this.tooltip_max.getBoundingClientRect();

                    if (offset_min.right > offset_max.left) {
                        this._removeClass(this.tooltip_max, 'top');
                        this._addClass(this.tooltip_max, 'bottom');
                        this.tooltip_max.style.top = 18 + 'px';
                    } else {
                        this._removeClass(this.tooltip_max, 'bottom');
                        this._addClass(this.tooltip_max, 'top');
                        this.tooltip_max.style.top = -30 + 'px';
                    }
                }


                var formattedTooltipVal;

                if (this.options.range) {
                    formattedTooltipVal = this.options.formatter(this.options.value);
                    this._setText(this.tooltipInner, formattedTooltipVal);
                    this.tooltip.style[this.stylePos] = (positionPercentages[1] + positionPercentages[0]) / 2 + '%';

                    if (this.options.orientation === 'vertical') {
                        this._css(this.tooltip, 'margin-top', -this.tooltip.offsetHeight / 2 + 'px');
                    } else {
                        this._css(this.tooltip, 'margin-left', -this.tooltip.offsetWidth / 2 + 'px');
                    }

                    if (this.options.orientation === 'vertical') {
                        this._css(this.tooltip, 'margin-top', -this.tooltip.offsetHeight / 2 + 'px');
                    } else {
                        this._css(this.tooltip, 'margin-left', -this.tooltip.offsetWidth / 2 + 'px');
                    }

                    var innerTooltipMinText = this.options.formatter(this.options.value[0]);
                    this._setText(this.tooltipInner_min, innerTooltipMinText);

                    var innerTooltipMaxText = this.options.formatter(this.options.value[1]);
                    this._setText(this.tooltipInner_max, innerTooltipMaxText);

                    this.tooltip_min.style[this.stylePos] = positionPercentages[0] + '%';

                    if (this.options.orientation === 'vertical') {
                        this._css(this.tooltip_min, 'margin-top', -this.tooltip_min.offsetHeight / 2 + 'px');
                    } else {
                        this._css(this.tooltip_min, 'margin-left', -this.tooltip_min.offsetWidth / 2 + 'px');
                    }

                    this.tooltip_max.style[this.stylePos] = positionPercentages[1] + '%';

                    if (this.options.orientation === 'vertical') {
                        this._css(this.tooltip_max, 'margin-top', -this.tooltip_max.offsetHeight / 2 + 'px');
                    } else {
                        this._css(this.tooltip_max, 'margin-left', -this.tooltip_max.offsetWidth / 2 + 'px');
                    }
                } else {
                    formattedTooltipVal = this.options.formatter(this.options.value[0]);
                    this._setText(this.tooltipInner, formattedTooltipVal);

                    this.tooltip.style[this.stylePos] = positionPercentages[0] + '%';
                    if (this.options.orientation === 'vertical') {
                        this._css(this.tooltip, 'margin-top', -this.tooltip.offsetHeight / 2 + 'px');
                    } else {
                        this._css(this.tooltip, 'margin-left', -this.tooltip.offsetWidth / 2 + 'px');
                    }
                }
            },
            _removeProperty: function (element, prop) {
                if (element.style.removeProperty) {
                    element.style.removeProperty(prop);
                } else {
                    element.style.removeAttribute(prop);
                }
            },
            _mousedown: function (ev) {
                if (!this.options.enabled) {
                    return false;
                }

                this._triggerFocusOnHandle();

                this.offset = this._offset(this.sliderElem);
                this.size = this.sliderElem[this.sizePos];

                var percentage = this._getPercentage(ev);

                if (this.options.range) {
                    var diff1 = Math.abs(this.percentage[0] - percentage);
                    var diff2 = Math.abs(this.percentage[1] - percentage);
                    this.dragged = (diff1 < diff2) ? 0 : 1;
                } else {
                    this.dragged = 0;
                }

                this.percentage[this.dragged] = this.options.reversed ? 100 - percentage : percentage;
                this._layout();

                this.mousemove = this._mousemove.bind(this);
                this.mouseup = this._mouseup.bind(this);

                if (this.touchCapable) {
                    // Touch: Bind touch events:
                    document.addEventListener("touchmove", this.mousemove, false);
                    document.addEventListener("touchend", this.mouseup, false);
                } else {
                    // Bind mouse events:
                    document.addEventListener("mousemove", this.mousemove, false);
                    document.addEventListener("mouseup", this.mouseup, false);
                }

                this.inDrag = true;

                var val = this._calculateValue();
                this._trigger('slideStart', val);
                this._setDataVal(val);
                this.setValue(val);

                this._pauseEvent(ev);

                return true;
            },
            _triggerFocusOnHandle: function (handleIdx) {
                if (handleIdx === 0) {
                    this.handle1.focus();
                }
                if (handleIdx === 1) {
                    this.handle2.focus();
                }
            },
            _keydown: function (handleIdx, ev) {
                if (!this.options.enabled) {
                    return false;
                }

                var dir;
                switch (ev.keyCode) {
                    case 37: // left
                    case 40: // down
                        dir = -1;
                        break;
                    case 39: // right
                    case 38: // up
                        dir = 1;
                        break;
                }
                if (!dir) {
                    return;
                }

                // use natural arrow keys instead of from min to max
                if (this.options.natural_arrow_keys) {
                    var ifVerticalAndNotReversed = (this.options.orientation === 'vertical' && !this.options.reversed);
                    var ifHorizontalAndReversed = (this.options.orientation === 'horizontal' && this.options.reversed);

                    if (ifVerticalAndNotReversed || ifHorizontalAndReversed) {
                        dir = dir * -1;
                    }
                }

                var oneStepValuePercentageChange = dir * this.percentage[2];
                var percentage = this.percentage[handleIdx] + oneStepValuePercentageChange;

                if (percentage > 100) {
                    percentage = 100;
                } else if (percentage < 0) {
                    percentage = 0;
                }

                this.dragged = handleIdx;
                this._adjustPercentageForRangeSliders(percentage);
                this.percentage[this.dragged] = percentage;
                this._layout();

                var val = this._calculateValue();

                this._trigger('slideStart', val);
                this._setDataVal(val);
                this.setValue(val, true);

                this._trigger('slideStop', val);
                this._setDataVal(val);

                this._pauseEvent(ev);

                return false;
            },
            _pauseEvent: function (ev) {
                if (ev.stopPropagation) {
                    ev.stopPropagation();
                }
                if (ev.preventDefault) {
                    ev.preventDefault();
                }
                ev.cancelBubble = true;
                ev.returnValue = false;
            },
            _mousemove: function (ev) {
                if (!this.options.enabled) {
                    return false;
                }

                var percentage = this._getPercentage(ev);
                this._adjustPercentageForRangeSliders(percentage);
                this.percentage[this.dragged] = this.options.reversed ? 100 - percentage : percentage;
                this._layout();

                var val = this._calculateValue();
                this.setValue(val, true);

                return false;
            },
            _adjustPercentageForRangeSliders: function (percentage) {
                if (this.options.range) {
                    if (this.dragged === 0 && this.percentage[1] < percentage) {
                        this.percentage[0] = this.percentage[1];
                        this.dragged = 1;
                    } else if (this.dragged === 1 && this.percentage[0] > percentage) {
                        this.percentage[1] = this.percentage[0];
                        this.dragged = 0;
                    }
                }
            },
            _mouseup: function () {
                if (!this.options.enabled) {
                    return false;
                }
                if (this.touchCapable) {
                    // Touch: Unbind touch event handlers:
                    document.removeEventListener("touchmove", this.mousemove, false);
                    document.removeEventListener("touchend", this.mouseup, false);
                } else {
                    // Unbind mouse event handlers:
                    document.removeEventListener("mousemove", this.mousemove, false);
                    document.removeEventListener("mouseup", this.mouseup, false);
                }

                this.inDrag = false;
                if (this.over === false) {
                    this._hideTooltip();
                }
                var val = this._calculateValue();

                this._layout();
                this._setDataVal(val);
                this._trigger('slideStop', val);

                return false;
            },
            _calculateValue: function () {
                var val;
                if (this.options.range) {
                    val = [this.options.min, this.options.max];
                    if (this.percentage[0] !== 0) {
                        val[0] = (Math.max(this.options.min, this.options.min + Math.round((this.diff * this.percentage[0] / 100) / this.options.step) * this.options.step));
                        val[0] = this._applyPrecision(val[0]);
                    }
                    if (this.percentage[1] !== 100) {
                        val[1] = (Math.min(this.options.max, this.options.min + Math.round((this.diff * this.percentage[1] / 100) / this.options.step) * this.options.step));
                        val[1] = this._applyPrecision(val[1]);
                    }
                    this.options.value = val;
                } else {
                    val = (this.options.min + Math.round((this.diff * this.percentage[0] / 100) / this.options.step) * this.options.step);
                    if (val < this.options.min) {
                        val = this.options.min;
                    }
                    else if (val > this.options.max) {
                        val = this.options.max;
                    }
                    val = parseFloat(val);
                    val = this._applyPrecision(val);
                    this.options.value = [val, this.options.value[1]];
                }
                return val;
            },
            _applyPrecision: function (val) {
                var precision = this.options.precision || this._getNumDigitsAfterDecimalPlace(this.step);
                return this._applyToFixedAndParseFloat(val, precision);
            },
            _getNumDigitsAfterDecimalPlace: function (num) {
                var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                if (!match) {
                    return 0;
                }
                return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
            },
            _applyToFixedAndParseFloat: function (num, toFixedInput) {
                var truncatedNum = num.toFixed(toFixedInput);
                return parseFloat(truncatedNum);
            },
            /*
             Credits to Mike Samuel for the following method!
             Source: http://stackoverflow.com/questions/10454518/javascript-how-to-retrieve-the-number-of-decimals-of-a-string-number
             */
            _getPercentage: function (ev) {
                if (this.touchCapable && (ev.type === 'touchstart' || ev.type === 'touchmove')) {
                    ev = ev.touches[0];
                }
                var percentage = (ev[this.mousePos] - this.offset[this.stylePos]) * 100 / this.size;
                percentage = Math.round(percentage / this.percentage[2]) * this.percentage[2];
                return Math.max(0, Math.min(100, percentage));
            },
            _validateInputValue: function (val) {
                if (typeof val === 'number') {
                    return val;
                } else if (val instanceof Array) {
                    this._validateArray(val);
                    return val;
                } else {
                    throw new Error(ErrorMsgs.formatInvalidInputErrorMsg(val));
                }
            },
            _validateArray: function (val) {
                for (var i = 0; i < val.length; i++) {
                    var input = val[i];
                    if (typeof input !== 'number') {
                        throw new Error(ErrorMsgs.formatInvalidInputErrorMsg(input));
                    }
                }
            },
            _setDataVal: function (val) {
                var value = "value: '" + val + "'";
                this.element.setAttribute('data', value);
                this.element.setAttribute('value', val);
            },
            _trigger: function (evt, val) {
                val = val || undefined;

                var callbackFnArray = this.eventToCallbackMap[evt];
                if (callbackFnArray && callbackFnArray.length) {
                    for (var i = 0; i < callbackFnArray.length; i++) {
                        var callbackFn = callbackFnArray[i];
                        callbackFn(val);
                    }
                }

                /* If JQuery exists, trigger JQuery events */
                if ($) {
                    this._triggerJQueryEvent(evt, val);
                }
            },
            _triggerJQueryEvent: function (evt, val) {
                var eventData = {
                    type: evt,
                    value: val
                };
                this.$element.trigger(eventData);
                this.$sliderElem.trigger(eventData);
            },
            _unbindJQueryEventHandlers: function () {
                this.$element.off();
                this.$sliderElem.off();
            },
            _setText: function (element, text) {
                if (typeof element.innerText !== "undefined") {
                    element.innerText = text;
                } else if (typeof element.textContent !== "undefined") {
                    element.textContent = text;
                }
            },
            _removeClass: function (element, classString) {
                var classes = classString.split(" ");
                var newClasses = element.className;

                for (var i = 0; i < classes.length; i++) {
                    var classTag = classes[i];
                    var regex = new RegExp("(?:\\s|^)" + classTag + "(?:\\s|$)");
                    newClasses = newClasses.replace(regex, " ");
                }

                element.className = newClasses.trim();
            },
            _addClass: function (element, classString) {
                var classes = classString.split(" ");
                var newClasses = element.className;

                for (var i = 0; i < classes.length; i++) {
                    var classTag = classes[i];
                    var regex = new RegExp("(?:\\s|^)" + classTag + "(?:\\s|$)");
                    var ifClassExists = regex.test(newClasses);

                    if (!ifClassExists) {
                        newClasses += " " + classTag;
                    }
                }
                element.className = newClasses.trim();
            },
            _offset: function (obj) {
                var ol = 0;
                var ot = 0;
                if (obj.offsetParent) {
                    do {
                        ol += obj.offsetLeft;
                        ot += obj.offsetTop;
                    } while (obj = obj.offsetParent);
                }
                return {
                    left: ol,
                    top: ot
                };
            },
            _css: function (elementRef, styleName, value) {
                elementRef.style[styleName] = value;
            }
        };

        /*********************************
         
         Attach to global namespace
         
         *********************************/
        if ($) {
            var namespace = $.fn.slider ? 'bootstrapSlider' : 'slider';
            $.bridget(namespace, Slider);
        } else {
            window.Slider = Slider;
        }


    })($);

})(window.jQuery);

app.service('Collection', [function () {

    function Collection(elements) {

        var _this = this;
        var current = 0;

        _this.elements = elements;

        _this.all = function () {
            return _this.elements;
        };

        _this.get = function ($index) {
            return _this.all()[$index];
        };

        _this.isEmpty = function () {
            return _this.elements.length;
        };

        _this.isNotEmpty = function () {
            return _this.elements.length;
        };

        _this.add = function (el) {
            _this.elements.push(el);
            return _this;
        };

        _this.count = function (fn) {
            if(fn)
            {
                var count = 0;
                _.each(_this.all(), function(item){
                    if(item[fn]())
                        count++;
                })
                return count;
            }
            else
                return _this.elements.length;
        };

        _this.current = function () {
            return _this.get(current);
        };

        /**
         * @description get current index
         * @return {number}
         */
        _this.currentIndex = function () {
            return current;
        };

        _this.next = function () {
            if (!_this.isAtTheEnd())
                current++;

            return _this;
        };

        _this.prev = function () {
            if (!_this.isAtTheStart())
                current--;

            return _this;
        };

        _this.isCurrent = function ($index) {
            return current == $index;
        };

        _this.isAtTheEnd = function () {
            return current >= _this.count() - 1;
        };

        _this.isAtTheStart = function () {
            return current == 0;
        };

        _this.getCurrentNumber = function () {
            return current + 1;
        };

        _this.setCurrent = function (index) {
            current = index;
            return _this;
        };

        _this.shuffle = function () {
            _this.elements = _.shuffle(_this.elements);
            return _this;
        };

        _this.limit = function (n) {
            _this.elements = _.first(_this.elements, n);
            return _this;
        };

        /**
         * Set collection at start
         * @return {model}
         */
        _this.atStart = function () {
            current = 0;
            return _this;
        };

        _this.atEnd = function () {
            current = _this.count() - 1;
            return _this;
        };

        /**
         * Foreach element in array call a function
         * @param  {string} nameFunction
         * @return {model}
         */
        _this.callEach = function (nameFunction) {
            _.each(_this.elements, function (item) {
                item[nameFunction]();
            });

            return _this;
        };

        _this.isBlocked = function () {
            var _return = false;

            _.each(_this.all(), function (el) {
                if (el.isBlocked()) {
                    _return = true;
                    return;
                }
            });

            return _return;
        };

        _this.filter = function (callback) {
            var array = [];
            _.each(_this.all(), function (item) {
                if (callback(item)) {
                    array.push(item);
                }
            });
            return new Collection(array);
        };

        _this.checkElementsByFn = function(nameFn) {
            var _return = true;

            _.each(_this.all(), function(item){
                if(!item[nameFn]())
                    _return = false;
            });

            return _return;
        }

        /**
         * @description foreach bridge
         * @param callback
         */
        _this.forEach = (callback)=>{
            _this.elements.forEach((item, key)=>{
                return callback(item, key);
            });
            return _this;
        };

        return _this;
    };

    var service = {
        create: function (array) {
            if (!(array instanceof Array)) {
                array = [array];
            }
            return new Collection(array);
        }
    };

    return service;
}]);

(function(){
	
	'use strict';

	var DetailedFactory = function($http, Model, MenuButton, Overlay)
	{
		var all = [];

		function Detailed(attrs) {

			var html = false;
		    var pages = false;
		    var currentPage = 0;
		    var promiseHtml = false;
		    var _opened = false;

		    var model = Model.create({
		        attrs: attrs,
		        name: 'detailed'
		    });

		    model.filepath = function(){
		    	return model.getAttr('file') + '.' + model.getAttr('type');
		    };

		    model.getHtml = function() {
		    	if(!promiseHtml) {
		    		promiseHtml = $http.get(model.filepath()).then(function(data){
		    			html = data.data;
		    		});
		    	}

	    		return html;
		    };

		    model.open = function() {
		    	_opened = true;
				MenuButton.find('detailed').open();
				Overlay.open('detailed', model);
			};

		    model.viewed = function() {
		    	return _opened;
			};

		    model.modelLabel = function(){
				return false;
			};

			model.isVideo = function() {
				return model.getAttr('type') == 'video' || model.getAttr('type') == 'mp4';
			};

		    return model;
		}

		var service = {
			get: function(index) {
				return all[index];
			},
			create: function(attrs) {
				return new Detailed(attrs);
			},
			collection: function (array) {
	            if (!all.length) {
	                var tmp = [];
	                _.each(array, function (item) {
	                    tmp.push(new Detailed(item));
	                });
	                all = Model.collection(tmp);
	            }
	            return all;
	        },
	        all: function(){
	        	return all;
	        },
	        init: function() {
	        	$http.get('config/detailed.json').then(function(response){
					_.each(response.data.items, function(item)
			        {
			           all.push(new Detailed(item)); 
			        });
				});
	        },
	        SortModelLabel: function(model) {
	        	return model.getAttr('label');
	        }
		};

		return service;
	};

	DetailedFactory.$inject = ['$http', 'Model', 'MenuButton', 'Overlay'];
	
	angular.module('Application')
		.factory('Detailed', DetailedFactory)
		.run(['Detailed', function(Detailed) 
		{
			Detailed.init();
		}]);

})();

app.service('Dispatcher', ['Page', 'App', 'MenuButton', 'Menu', '$timeout', '$rootScope',
    function (Page, App, MenuButton, Menu, $timeout, $rootScope) {

        /**
         * al click della pagina successiva
         */
        Page.events.on('next', function () {

            if(!App.hasNextPage()) return;

            if(!App.config().isFree() && !App.module().lesson().page().isViewed()) return;

            if(App.module().lesson().page().video())
                App.module().lesson().page().video().pause();

            if (App.module().lesson().pages().isAtTheEnd()) {
                if (!App.module().lessons().isAtTheEnd()) {
                    App.module().nextLesson();
                    App.module().lesson().pages().atStart();
                }
                else {
                    App.nextModule();
                    App.module().lessons().atStart();
                    App.module().lesson().pages().atStart();
                }
            }
            else {
                App.module().lesson().nextPage();
            }

            Page.events.emit('change');
        });

        /**
         * al click della pagina precedente
         */
        Page.events.on('prev', function () {

            if(!App.hasPrevPage())
                return;

            if(App.module().lesson().page().video())
                App.module().lesson().page().video().pause();

            if (App.module().lesson().pages().isAtTheStart()) {
                if (!App.module().lessons().isAtTheStart()) {
                    App.module().prevLesson();
                    App.module().lesson().pages().atEnd();
                }
                else {
                    App.prevModule();
                    App.module().lessons().atEnd();
                    App.module().lesson().pages().atEnd();
                }
            }
            else {
                App.module().lesson().prevPage();
            }

            Page.events.emit('change');

        }, false);

        /**
         * Ogniqualvolta viene aperto il menu
         */
        Menu.panel.on('open', function () {

            // metto in pausa il video quando viene aperto
            // il menu
            if (App.module().lesson().page().video())
                App.module().lesson().page().video().pause();

        }, false);

    }]);

(function(){

	'use strict';

	var DoitFactory = function($http, $timeout, Model){

		var all = [];

		function Doit(attrs) 
		{
			var wrong = false;
			var help = false;

			var model = Model.create({
	            attrs: attrs,
	            name: 'doit'
	        });

	        model.wrong = function() {
	        	wrong = true;
	        	return model;
	        };

	        model.isWrong = function() {
	        	return wrong;
	        };

	        model.retry = function() {
	        	wrong = false;
	        	return model;
	        };

	        model.help = function(_callback) {
	        	help = true;
	        	
	        	$timeout(function()
	        	{
	        		if(_callback)
	        			_callback(model);
	        	}
	        	, 1500);

	        	return model;
	        };

	        model.refresh = function() {
	        	wrong = false;
	        	help = false;
	        };

	        model.isHelpOpened = function() {
	        	return help;
	        };

	        return model;
		};


		var service = {
			create: function(attrs) 
			{
				return new Doit(attrs);
			},
			get: function(index)
			{
				return all[index];
			},
			all: function() {
				return all;
			},
			load: function(_callback)
			{
				$http.get('config/doits.json').then(function(response)
				{
					_.each(response.data.items, function(item)
					{
						all.push(service.create(item));
					});
					return _callback.call(this, response);
				});
			}
		};

		return service;
	};

	DoitFactory.$inject = ['$http','$timeout', 'Model'];

	/**
	 * Controller
	 */
	var DoItController = function($scope, App)
	{
		$scope.isCoverVisible = true;

		$scope.startDoIt = function() {
			$scope.isCoverVisible = false;

			// launch audio on load if present
			if($scope.doit().audio())
				$scope.doit().audio().play();
		};

		// shortcut to current doit
		$scope.doit = function() {	
			return App.module().lesson().page().doits().current();
		};

		// help function called when user
		// click on help button
		$scope.help = function() 
		{
			$scope.doit().help(function()
			{
				$scope.page().doits().next();
			});
		};

		// get resource if node is a Exercise
		$scope.resource = function()
		{
			if($scope.page().doits().current().__is('exercise'))
				return $scope.page().doits().current();

			return false;
		};

		/**
		 * Watch when do it is completed
		 * page will be set viewed
		 */
		$scope.$watch(function(){
			return App.module().lesson().page().doits().isAtTheEnd();
		}, 
		function(value){
			if(value)
			{
				App.module().lesson().page().viewed();
			}
		});

		App.events.on('refresh', function()
		{
			$scope.page().doits().atStart();
			$scope.page().doits().callEach('refresh').atStart();
		});
	};

	DoItController.$inject = ['$scope', 'App'];

	angular.module('Application')
		.factory('Doit', DoitFactory)
		.controller('DoItController', DoItController);

})();

app.factory('Event', ['$rootScope', '$timeout', 
	function($rootScope, $timeout){
	
	function _Event(name) {
		var _this = this;
		_this.name = name;

		function __event(_event) {
			return _this.name+'.'+_event;
		};

		_this.emit = function(ev, params){
			$rootScope.$emit(__event(ev), params);
		};

		_this.on = function(ev, _function, delay){
			delay = angular.isUndefined(delay) ? false : delay;	

			// avvio l'evento dopo delay tempo se definito
			// altrimenti viene fired all'istante
			$timeout(function(){
				$rootScope.$on(__event(ev), function(event, data){
					return _function.call(this, event, data);
				}, delay);
			});
		};

		return _this;
	};

	var service = {
		create: function(name){
			return new _Event(name);
		}
	}; 

	return service;
}]);

app.factory('Eventer', ['$rootScope', function($rootScope){
	
	function _Event(name) {
		_this.name = name;

		function __event(_event) {
			return _this.name+'.'+_event;
		};

		_this.emit = function(ev, params){
			$rootScope.$emit(__event(ev), params);
		};

		_this.on = function(ev, _function){
			$rootScope.$on(__event(ev), function(event, data){
				return _function.call(this, event, data);
			});
		};

		return _this;
	};

	var service = {
		create: function(name){
			return new _Event(name);
		}
	}; 
}]);

(function(){

	'use strict';

	var ExampleFactory = function($http, Model, MenuButton, Overlay){

		var all = [];

		$http.get('config/examples.json').then(function(response){
			_.each(response.data.items, function(item)
            {
               all.push(new Example(item)); 
            });
		});

		function Example(attrs) {
			var model = Model.create({
	            attrs: attrs,
	            name: 'example'
	        });

			model.filepath = function(){
				return model.getAttr('file') + '.' + model.getAttr('type');
			};

			model.open = function() {
				MenuButton.find('examples').open();
				Overlay.open('examples', model) ;
			};

	        return model;
		};


		var service = {
			create: function(attrs){
				return new Example(attrs);
			},
			get: function(index){
				if(all[index])
					return all[index];

				return false;
			},
			all: function(){
				return all;
			}
		};

		return service;
	};


	ExampleFactory.$inject = ['$http','Model','MenuButton','Overlay'];

	angular.module('Application')
		.factory('Example', ExampleFactory);

})();

(function () {
    "use strict";

    var ExerciseFactory = function ($http, $q, Model, Collection, $translate) {
        var all = null;
        var promise = false;

        /**
         *    Get all Exercises
         */
        var promise = $http.get("config/exercises.json");

        var exercisesNamespace = {};
        /**
         * Exercise with only one single answer correct
         * @param {Obj} attrs
         */
        exercisesNamespace.SingleAnswer = function (attrs) {
            var answered = null;

            var model = Model.create({
                attrs: attrs,
                name: "exercise",
            });

            model.setAnswer = function (a, forceSetter) {
                if (!model.isConfirmed() || forceSetter) {
                    answered = a;
                }

                if (model.getAttr("confirmOnAnswer")) model.setAttr("confirm", true); //model.confirm();

                if (model.getAttr("solutionOnAnswer")) model.setAttr("solution", true);

                return model;
            };

            model.hasSelected = function (a) {
                return answered == a;
            };

            model.isAnswered = function () {
                return answered;
            };

            model.answered = function (a) {
                return a == answered;
            };

            model.isCorrect = function (answer) {
                var answer = answer ? answer : answered;
                return (
                    _.indexOf(model.getAttr("answers"), answer) ==
                    model.getAttr("correct")
                );
            };

            model.cancel = function () {
                answered = null;
                model.setAttr("confirm", false);
                return model;
            };

            model.reset = function () {
                model.cancel();
            };

            model.getAnsweredIndex = function () {
                return _.indexOf(model.getAttr("answers"), answered);
            };

            /**
             * Check if exercise is blocked
             * @return {boolean}
             */
            model.isBlocked = function () {
                return !model.isCorrect() && !model.isSolutionVisible();
            };

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.DragDrop = function (attrs) {
            var matches = [];
            var answered = [];
            var options = false;

            var draggedItem = false;

            var model = Model.create({
                attrs: attrs,
                name: "exercise.dragdrop",
            });

            model.middleware.attrs = {
                options: function (value) {
                    if (options == false) options = _.shuffle(value);
                    return options;
                },
            };

            /**
             * Get all matches for options
             * @return {array}
             */
            model.getAllMatches = function () {
                return model.getAttr("matches");
            };

            /**
             * Check if is given almost one answer
             * @return {boolean}
             */
            model.isGivenAlmostOneAnswer = function () {
                var _return = false;

                _.each(model.getAttr("droppables"), function (value) {
                    if (value.answered.length) {
                        _return = true;
                        return;
                    }
                });

                return _return;
            };

            /**
             * Check if one
             * @returns {boolean}
             */
            model.canBeDroppedMultipleInOne = function () {
                if (model.getAttr("matchesType") == "multiple") return true;

                return false;
            };

            model.dropOptions = function () {
                return {
                    multiple: function () {
                        return model.canBeDroppedMultipleInOne();
                    },
                };
            };

            /**
             * Check if option can be dropped
             * @return {Boolean}
             */
            model.canBeDropped = function (event, ui, param) {
                var defer = $q.defer();

                if (!param) return false;

                if (param.answered.length >= 1 && !model.canBeDroppedMultipleInOne()) {
                    defer.reject();
                } else {
                    defer.resolve();
                }

                return defer.promise;
            };

            /**
             * Save item dragged
             * @param  {Obj} item
             * @return {model}
             */
            model.registerDraggedItem = function (event, ui, item) {
                draggedItem = item;
                return model;
            };

            /**
             * Check if all answers are checked
             * @return {Boolean}
             */
            model.areAllAnswered = function () {
                var _return = true;

                if (model.getAttr("allMatchesMustBeDropped")) {
                    _.each(model.getAttr("draggables"), function (item) {
                        if (!angular.isUndefined(item) && !model.isDragged(item)) {
                            _return = false;
                            return;
                        }
                    });
                } else {
                    _.each(model.getAttr("droppables"), function (value) {
                        if (!value.answered.length) {
                            _return = false;
                            return;
                        }
                    });
                }

                return _return;
            };

            /**
             * Check if element is already dragged
             * @param  {obj}  option
             * @return {Boolean}
             */
            model.isDragged = function (option) {
                var _return = false;

                _.each(model.matches, function (item) {
                    if (item.answered == option) {
                        _return = true;
                        return;
                    }
                });

                return _return;
            };

            /**
             * Cancel given answers
             * @return {model}
             */
            model.cancel = function () {
                model.copyAttr("droppables", "matches");
                _.each(model.getAttr("droppables"), function (item) {
                    item.answered = [];
                });
                model.copyAttr("draggables", "options");

                model.setAttr("confirm", false);
                model.setAttr("solution", false);

                return model;
            };

            /**
             * Check if exercise answers are correct
             * @return {Boolean}
             */
            model.isCorrect = function () {
                var _return = true;

                _.each(model.getAttr("droppables"), function (item, key) {
                    _.each(item.answered, function (a) {
                        if (!angular.isUndefined(a) && _.indexOf(a.match, key) == -1) {
                            _return = false;
                            return;
                        }
                    });

                    if (!_return) return;
                });

                return _return;
            };

            model.isAssignmentCorrect = function (match, answer) {
                var _return = true;
                var indexMatch = _.indexOf(model.getAttr("droppables"), match);

                if (indexMatch == -1) console.warn("no match");

                if (answer.match[0] != indexMatch) {
                    _return = false;
                    return;
                }

                return _return;
            };

            /**
             * Set solution of exercise
             * @return {model}
             */
            model.solution = function () {
                model.setAttr("solution", true);

                _.each(model.getAttr("droppables"), function (item, key) {
                    var tmp = [];
                    _.each(model.getAttr("options"), function (option) {
                        if (_.indexOf(option.match, key) > -1) {
                            tmp.push(option);
                        }
                    });

                    item.answered = tmp;
                });
                return model;
            };

            // reset all values
            model.cancel();

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.SelectMultiple = function (attrs) {
            var matches = [];
            var options = false;

            var model = Model.create({
                attrs: attrs,
                name: "exercise.select",
            });

            model.middleware.attrs = {
                options: function (value) {
                    // if (options == false)
                    //     options = _.shuffle(value);
                    options = value;
                    return options;
                },
            };

            /**
             * Get all matches for options
             * @return {array}
             */
            model.getAllMatches = function () {
                if (matches.length == 0) {
                    matches = [];
                    _.each(model.getPlainAttr("options"), function (option) {
                        matches = matches.concat(option.match);
                    });

                    matches = _.shuffle(_.uniq(matches));
                }
                return matches;
            };

            /**
             * Check if is given almost one answer
             * @return {boolean}
             */
            model.isGivenAlmostOneAnswer = function () {
                var _return = false;

                _.each(model.getPlainAttr("options"), function (value) {
                    if (value.answer) {
                        _return = true;
                        return;
                    }
                });

                return _return;
            };

            /**
             * Check if every select has been answered
             * @return {boolean}
             */
            model.isAnswered = function () {
                var _return = true;
                // console.log("areAAnswered", model.getPlainAttr('options'));
                _.each(model.getPlainAttr("options"), function (value) {
                    // console.log("value", value);
                    if (!value.answer && value.answer !== 0) {
                        _return = false;
                        return;
                    }
                });
                // console.log("isC", model.isCorrect());
                return _return;
            };

            /**
             * Cancel given answers
             * @return {model}
             */
            model.cancel = function () {
                _.each(model.getPlainAttr("options"), function (value) {
                    value.answer = false;
                });

                model.attrs.confirm = false;

                return model;
            };

            // /**
            //  * Check if exercise answers are correct
            //  * @return {Boolean}
            //  */
            // model.isCorrect = function () {
            //     var _return = true;
            //     var corrects = 0;

            //     _.each(model.getAttr('options'), function (option) {
            //         if (_.indexOf(option.match, option.answer) > -1) {
            //             corrects++;
            //         }
            //         else {
            //             _return = false;
            //             return;
            //         }
            //     });

            //     return _return;
            // };

            /**
             * Check if every select has been correctly selected
             * @return {boolean}
             */
            model.isCorrect = function () {
                var _return = true;
                // console.log("isCorrect", model.getAttr('options'));
                _.each(model.getAttr("options"), function (value) {
                    // console.log("> ", value.answer, value.match);
                    if (value.answer != value.match) {
                        _return = false;
                        return;
                    }
                });

                return _return;
            };

            /**
             * Set solution of exercise
             * @return {model}
             */
            model.solution = function () {
                model.setAttr("solution", true);
                _.each(model.getAttr("options"), function (option) {
                    option.answer = option.match[0];
                });
                return model;
            };

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.Multiple = function (attrs) {
            var corrects = [];
            var options = false;

            var model = Model.create({
                attrs: attrs,
                name: "exercise.multiple",
            });

            model.attr.choices = [];
            var choices = [];

            model.middleware.attrs = {
                options: function (value) {
                    if (options == false)
                        //options = _.shuffle(value);
                        options = value;
                    return options;
                }
            };

            model.setAnswer = function (a) {

                if (model.isConfirmed()) {
                    return;
                }
                var returnIndex = _.indexOf(choices, a)
                if (returnIndex == -1) {
                    console.log("aggiunto");
                    choices.push(a);
                } else {
                    choices.splice(returnIndex, 1);
                }

                console.log("choices", choices)
                return model;
            };

            model.isAnswered = function () {
                //return choices.length >= model.corrects().length;
                return choices.length > 0;
            };

            model.hasSelected = function (option) {
                if (_.indexOf(choices, option) > -1)
                    return true;

                return false;
                // if (_.indexOf(model.getAttr("choices"), option) > -1) return true;

                // return false;
            };

            model.corrects = function () {
                if (!corrects.length) {
                    _.each(model.getAttr("options"), function (item) {
                        if (item.correct)
                            corrects.push(item);
                    });
                }
                return corrects;
            };

            model.getFeedback = function () {
                var feed = model.getAttr("feedback");

                if (model.isSolutionVisible()) return feed.solution;

                if (model.isCorrect()) return feed.success;
                else return feed.failed;
            };

            model.getFeedbackClass = function () {
                if (model.isSolutionVisible()) return "alert-info";

                return model.isCorrect() ? "alert-success" : "alert-danger";
            };

            model.isCorrect = function (option) {
                // console.log("CHECK IS CORRECT");

                if (option) {
                    // console.log("option", option)
                    var _return = false;
                    if (_.indexOf(model.corrects(), option) != -1) {
                        _return = true;
                        return _return;
                    }
                } else {
                    var _return = true;
                    var choices = model.getAttr('choices');
                    _.each(model.corrects(), function (item) {
                        // console.log("item", item)
                        // console.log("choices", choices)
                        if (_.indexOf(choices, item) == -1) {
                            _return = false;
                            return;
                        }
                    });
                }
                //console.log("model.corrects()",model.corrects().length)
                //console.log("choices",choices.length)
                if (model.corrects().length != choices.length) {
                    _return = false;
                }
                //console.log("option",option);
                //console.log("_return",_return);
                return _return;
            };

            model.isCorrectOLD = function () {
                var _return = true;
                if (model.getAttr("choices").length !== model.corrects().length) {
                    return false;
                }
                _.each(model.corrects(), function (item) {
                    if (_.indexOf(model.getAttr("choices"), item) == -1) {
                        _return = false;
                        return;
                    }
                });

                return _return;
            };

            model.checkOption = function (option) {
                if (model.isConfirmed()) return;

                var choices = model.getAttr("choices");
                if (model.isChecked(choices, option)) {
                    choices.splice(choices.indexOf(option), 1);
                    // console.log("REMOVE", $scope.collection.current().getAttr('choices'));

                    // var filtered = _.filter($scope.collection.current().getAttr('choices'), function(item) {
                    //     return item !== option
                    // });
                    // console.log(filtered);
                } else {
                    // console.log("ADD", $scope.collection.current().getAttr('choices'));
                    // console.log($scope.collection.current());
                    if (choices === false) {
                        model.setAttr("choices", []);
                    }
                    model.getAttr("choices").push(option);
                }
            };

            model.isOptionCorrect = function (option) {
                return model.corrects().indexOf(option) !== -1;
            };

            model.isChecked = function (choices, option) {
                if (choices === false) return false;
                return choices.indexOf(option) !== -1;
            };

            model.isAtLeastOneChecked = function () {
                return model.getAttr("choices").length >= 1;
            };

            model.cancel = function () {
                model.setAttr("choices", false);
                model.setAttr("confirm", false);
                return model;
            };

            model.solution = function () {
                model.setAttr("choices", model.corrects());
                model.setAttr("confirm", true);
                model.setAttr("solution", true);
                return model;
            };

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.Crociate = function (attrs) {
            var allAnswer;

            var model = Model.create({
                attrs: attrs,
                name: "exercise",
            });

            // model.middleware.attrs = {
            //     answers: function (value) {
            //         if (answers === false && model.getAttr('shuffle')) {
            //             answers = _.shuffle(value);
            //         }
            //         return answers;
            //     }
            // };

            // model.setAnswer = function (a, forceSetter) {
            //     if (!model.isConfirmed() || forceSetter) {
            //         answered = a;
            //     }

            //     if (model.getAttr('confirmOnAnswer'))
            //         model.setAttr('confirm', true); //model.confirm();

            //     if (model.getAttr('solutionOnAnswer'))
            //         model.setAttr('solution', true);

            //     return model;
            // };

            // model.getUserAnswerIndex = function (option) {
            //     var position = _.indexOf(items, option) + 1;
            //     return position > 0 ? position : false;
            // };

            // EDITED 2019-09-01
            // model.isAnswered = function () {
            //     var _isAnswered = false;
            //     // FIXED 2020-03-02 - quando si deseleziona un elemento, la posizione viene settata a option['position'] = 999;, quindi isAnswered continuava a ritornare true
            //     _isAnswered =_.every(model.answers(), function(a) { console.log("isAnswered item", a.position + !!a.position); return a.position && (a.position<= model.answers().length)});

            //     return _isAnswered;
            // };

            model.answersLang = function () {
                return model.getAttr("answers_" + $translate.use());
            };

            model.wordToFoundLang = function () {
                return model.getAttr("wordToFound_" + $translate.use());
            };

            //@index --> param to know which word disabled
            model.disabledCorrect = function (indexToDisabled) {
                _.each(model.answersLang(), function (row, i) {
                    _.each(row, function (column, l) {
                        if (column.group == indexToDisabled) {
                            column.disabled = true;
                        }
                    });
                });
            };

            model.checkLimitClick = function () {
                const allAnswer = [].concat(...model.answersLang());
                let answered = allAnswer.filter((letter) => {
                    return letter.answered;
                }).length;
                //const maxClick=[].concat(...model.getAttr('wordToFound'));
                const counterClick = 0;
                const maxClick = model.wordToFoundLang()
                    .reduce(
                        (accumulator, currentValue) =>
                            accumulator + currentValue.label.length,
                        counterClick
                    );
                return answered > maxClick ? true : false;
            };

            model.checkCorrect = function (answer) {
                var __return = false;
                //convert from matrix to array unique (to use filter when check group)
                const allAnswer = [].concat(...model.answersLang());
                /*
                I loop the array word (obtain index's word) and check the number of click
                that user have done with "group" prop that correspond to the index of word
                Example: 
                "wordToFound":[{"label":"lll"}],
                "answers": [
                    [{"l":"L","group":0},{"l":"E"},{"l":"A"}],
                    [{"l":"L","group":0},{"l":"E"},{"l":"A"}],
                    [{"l":"L","group":0},{"l":"E"},{"l":"A"}]
                ]
                
                if user clicked letters width "group":0, "answered":true prop will be added.
                if the letter with "group":0 have also prop "answered":true then user founded the word
                */

                //console.log("allAnswer",allAnswer)
                _.each(model.wordToFoundLang(), function (word, i) {
                    let founded = allAnswer.filter((letter) => {
                        //return letter.group == i && letter.answered;
                        if (letter.group) {
                            if (letter.group.indexOf(i) > -1 && letter.answered)
                                return true
                        }
                        return false
                        //return (letter.group && letter.group.indexOf(i)>-1) && letter.answered;
                    }).length;
                    if (founded == word.label.length && !word.correct) {
                        word.correct = true;
                        model.disabledCorrect(i);
                        __return = word.label;
                    }
                });
                return __return;
            };

            model.isEnded = function () {
                let founded = model.wordToFoundLang().filter((word) => {
                    return word.correct;
                }).length;
                return (founded >= model.wordToFoundLang().length) ? true : false
            }

            model.solution = function () {
                _.each(model.answersLang(), function (row, i) {
                    _.each(row, function (column, l) {

                        if (column.group >= 0)
                            column.answered = true;
                        else
                            column.answered = false

                    });
                });
                model.setAttr("solution", true);
            }

            model.selectCell = function (row, column) {
                if (!model.answersLang()[row][column].answered)
                    model.answersLang()[row][column].answered = true;
                else model.answersLang()[row][column].answered = false;
                //console.log("model.answers()",model.answers()[row][column])
                //model.answers()[row][column].answered=true
            };

            model.cancel = function () {
                items.length = 0;

                _.each(model.answersLang(), function (answer) {
                    delete answer.position;
                });
                model.setAttr("confirm", false);

                return model;
            };

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.OrderOption = function (attrs) {
            var answered = null;
            var answers = false;
            var items = [];

            var model = Model.create({
                attrs: attrs,
                name: "exercise",
            });

            model.middleware.attrs = {
                answers: function (value) {
                    // console.log(value);
                    // console.log(model.getAttr('shuffle'));
                    // return [];
                    // return value;
                    if (answers === false && model.getAttr("shuffle")) {
                        answers = _.shuffle(value);
                    }
                    return answers;
                },
            };

            // model.setAnswer = function (a, forceSetter) {
            //     if (!model.isConfirmed() || forceSetter) {
            //         answered = a;
            //     }

            //     if (model.getAttr('confirmOnAnswer'))
            //         model.setAttr('confirm', true); //model.confirm();

            //     if (model.getAttr('solutionOnAnswer'))
            //         model.setAttr('solution', true);

            //     return model;
            // };

            model.setUserAnswerOrder = function (option, forceSetter) {
                if (model.isConfirmed()) return;
                var position = model.getUserAnswerIndex(option);
                if (position === false) {
                    items.push(option);
                    option["position"] = model.getUserAnswerIndex(option);
                } else {
                    items.splice(position - 1, 1);
                    _.each(items, function (item, index) {
                        // console.log("item",item, index);
                        item["position"] = index + 1;
                        // console.log("item",item, index);
                        // console.log("item------------");
                    });
                    option["position"] = 999;
                }
                // console.log(option, items);
                return option;
            };

            model.getUserAnswerIndex = function (option) {
                var position = _.indexOf(items, option) + 1;
                // console.log("POS", position, option, model.answers());
                // console.log("> ", $scope.items);
                return position > 0 ? position : false;
            };

            // EDITED 2019-09-01
            model.isAnswered = function () {
                var _isAnswered = false;
                // FIXED 2020-03-02 - quando si deseleziona un elemento, la posizione viene settata a option['position'] = 999;, quindi isAnswered continuava a ritornare true
                _isAnswered = _.every(model.answers(), function (a) {
                    //console.log("isAnswered item", a.position + !!a.position);
                    return a.position && a.position <= model.answers().length;
                });

                return _isAnswered;
            };

            // model.hasSelected = function (a) {
            //     return answered == a;
            // };

            // model.answered = function (a) {
            //     return a === answered;
            // };

            // model.isAtLeastOneSelected = function () {
            //     return model.isAnswered();
            // };

            model.isCorrect = function (answer) {
                var __result = true;
                _.each(model.answers(), function (answer) {
                    if (answer.order != answer.position) __result = false;
                });
                return __result;
            };

            model.cancel = function () {
                items.length = 0;
                // console.log(">", model.answers());
                _.each(model.answers(), function (answer) {
                    delete answer.position;
                });
                model.setAttr("confirm", false);
                // answered = null;
                return model;
            };

            // model.reset = function () {
            //     model.cancel();
            // };

            // model.getAnsweredIndex = function () {
            //     return _.indexOf(model.getAttr('answers'), answered);
            // };

            // /**
            //  * Check if exercise is blocked
            //  * @return {boolean}
            //  */
            // model.isBlocked = function () {
            //     return !model.isCorrect() && !model.isSolutionVisible();
            // };

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.TableMultiple = function (attrs) {
            var corrects = [];
            var rows = [];

            var model = Model.create({
                attrs: attrs,
                name: "exercise.tablemultiple",
            });

            model.rows = function () {
                return model.getAttr("rows");
            };

            model.isAnswered = function () {
                var _return = true;
                _.each(model.rows(), function (item) {
                    if (!item.value) _return = false;
                });
                return _return;
            };

            model.score = function () {
                var score = 0;

                _.each(model.rows(), function (item) {
                    score += item.value;
                });

                return score;
            };

            return model;
        };

        /**
         * Exercise text input
         * @param {Obj} attrs
         */
        exercisesNamespace.Text = function (attrs) {
            var answered = "";

            var model = Model.create({
                attrs: attrs,
                name: "exercise.text",
            });

            model.setAnswer = function (value) {
                if (!value) value = null;
                answered = value;
                return model;
            };

            model.isAnswered = function () {
                return answered;
            };

            model.cancel = function () {
                answered = null;
                model.setAttr("confirm", false);
                return model;
            };

            model.isCorrect = function () {
                return (
                    answered != null &&
                    answered.toLowerCase().replace(".", "") ==
                    model.getAttr("correct").toLowerCase()
                );
            };

            /**
             * Check if exercise is blocked
             * @return {boolean}
             */
            model.isBlocked = function () {
                return !model.isCorrect() && !model.isSolutionVisible();
            };

            return model;
        };

        /**
         * Exercise text input
         * @param {Obj} attrs
         */
        exercisesNamespace.YesNo = function (attrs) {
            var answered = "";

            var model = Model.create({
                attrs: attrs,
                name: "exercise.yesno",
            });

            model.options = function () {
                return model.getAttr("options");
            };

            model.items = function () {
                return model.getAttr("items");
            };

            model.cancel = function () {
                answered = null;
                model.items().forEach(item => delete item.answer);
                model.setAttr("confirm", false);
                return model;
            };

            model.repeat = function () {
                model.cancel();
                model.setAttr("confirm", false);
                repeat++;
                console.log("increment repeat", repeat);
                return model;
            };

            model.setAnswer = function (item, optionIndex) {
                if (model.isConfirmed()) return;
                // console.log("item", item, optionIndex);
                item.answer = optionIndex;
                // console.log(item.answer);
                return model;
            };

            model.isItemAnswered = function (item) {
                // console.log(item.answer);
                return item.answer !== undefined;
            };

            model.itemAnswered = function (item) {
                // console.log(item.answer);
                return item.answer;
            };

            model.isOptionAnswered = function (item, optionIndex) {
                return item.answer == optionIndex;
            };

            model.isOptionCorrect = function (item, optionIndex) {
                return item.solution == optionIndex;
            };

            /**
             * Check if all items are answered
             * @return {Boolean}
             */
            model.isAnswered = function () {
                var _return = true;
                _.each(model.items(), function (item) {
                    if (angular.isUndefined(item.answer) && item.answer !== 0) {
                        _return = false;
                        return;
                    }
                });
                return _return;
            };

            model.isCorrect = function () {
                var _return = true;
                _.each(model.items(), function (item) {
                    if (
                        angular.isUndefined(item.answer) ||
                        item.answer !== item.solution
                    ) {
                        _return = false;
                        return;
                    }
                });
                return _return;
            };

            model.solution = function () {
                model.setAttr("solution", true);
                model.items().forEach(item => item.answer = item.solution);
                // model.items().forEach(item => console.log(item));
                return model;
            };

            // model.cancel = function () {
            //     answered = null;
            //     model.setAttr('confirm', false);
            //     return model;
            // };

            // model.isCorrect = function () {
            //     return answered != null
            //         && answered.toLowerCase().replace('.', '') == model.getAttr('correct').toLowerCase();
            // };

            return model;
        };

        /**
         **/
        function Feedback(attrs) {
            var model = Model.create({
                attrs: attrs,
                name: "feedback",
            });

            return model;
        }

        /**
         * Get exercise
         * @param {Obj} attrs
         */
        function Exercise(attrs, type) {
            var html = false;
            var pages = false;
            var feedback = false;
            var repeat = 0;
            var timingStarted = false;
            var timingStopped = false;

            switch (type) {
                default:
                case "single":
                    type = "SingleAnswer";
                    break;
                case "select":
                    type = "SelectMultiple";
                    break;
                case "drag":
                    type = "DragDrop";
                    break;
                case "multiple":
                    type = "Multiple";
                    break;
                case "tablemultiple":
                    type = "TableMultiple";
                    break;
                case "text":
                    type = "Text";
                    break;
                case "yesno":
                    type = "YesNo";
                    break;
                case "order":
                    type = "OrderOption";
                    break;
                case "crociate":
                    type = "Crociate";
                    break;
            }
            var model = new exercisesNamespace[type](attrs);

            model.setAttr("confirm", false);

            /**
             * Get Answer array related
             * @return {array}
             */
            model.answers = function () {
                //console.log("answers normale")
                return model.getAttr("answers");
            };

            /**
             * Confirm answers
             * @return {model}
             */
            model.confirm = function () {
                model.setAttr("confirm", true);

                if (model.getAttr("solutionOnAnswer")) model.setAttr("solution", true); //model.confirm();

                return model;
            };

            /**
             * Check if is confirmed
             * @return {Boolean}
             */
            model.isConfirmed = function () {
                return model.getAttr("confirm");
            };

            /**
             * Check if solution is visible
             * @return {Boolean}
             */
            model.isSolutionVisible = function () {
                return model.getAttr("solution");
            };

            /**
             * Check if exercise is blocked
             * @return {boolean}
             */
            model.isBlocked = function () {
                if (model.getAttr("feedbackOnDrop")) {
                    return !model.areAllAnswered();
                }

                return !model.isCorrect() && !model.isSolutionVisible();
            };

            model.repeat = function () {
                model.cancel();
                model.setAttr("confirm", false);
                repeat++;
                //console.log("increment repeat", repeat);
                return model;
            };

            model.getRepeatValue = function () {
                return repeat;
            };

            model.isRepeatable = function () {
                return model.getAttr("repeat") > repeat;
            };

            model.refresh = function () {
                model.repeat();
                model.setAttr("confirm", false);
            };

            model.getFeedback = function () {
                return feedback;
            };

            model.showFeedback = function () {
                if (!feedback) {
                    var attr = model.isCorrect()
                        ? model.getAttr("feedback")[0].correct
                        : model.getAttr("feedback")[0].incorrect;
                    feedback = new Feedback(attr);
                }
                return model;
            };

            model.isFeedbackVisible = function () {
                return feedback ? true : false;
            };

            model.closeFeedback = function () {
                feedback = false;
                return model;
            };

            model.countRepeat = function () {
                return repeat;
            };

            model.startTiming = function () {
                if (!timingStarted) timingStarted = moment();
            };

            model.stopTiming = function () {
                timingStopped = moment();
            };

            model.latency = function () {
                if (timingStopped) return timingStopped.diff(timingStarted, "seconds");
                return 0;
            };

            /**
             * @description return score
             * @return {number}
             */
            model.score = () => {
                var score = 0;
                if (!model.getAttr("score")) return score;

                return model.isCorrect()
                    ? score + model.getAttr("score")
                    : model.getAttr("scorePenalty") && model.isConfirmed()
                        ? score - model.getAttr("scorePenalty")
                        : 0;
            };

            // Many files
            model.manyFromFile("File");

            return model;
        }

        var service = {
            find: function (index) {
                return all[index];
            },
            create: function (attrs) {
                return new Exercise(attrs);
            },
            get: function (index) {
                return this.all()[index];
            },
            getById: function (id) {
                var tmp = [];

                _.each(all, function (item) {
                    if (_.indexOf(id, item.getAttr("id")) > -1) tmp.push(item);
                });

                return Collection.create(tmp);
            },
            all: function (callback) {
                if (all == null) {
                    all = [];
                    promise = promise.then(function (response) {
                        _.each(response.data.items, function (data) {
                            all.push(new Exercise(data, data.type));
                        });

                        if (callback) return callback(all);
                    });
                }

                return all;
            },
            promise: function () {
                return promise;
            },
        };

        return service;
    };

    ExerciseFactory.$inject = ["$http", "$q", "Model", "Collection", "$translate"];

    angular
        .module("Application")
        .factory("Exercise", ExerciseFactory)
        .run([
            "Exercise",
            function (Exercise) {
                Exercise.all();
            },
        ]);
})();


(function(){

	'use strict';

	var GlossaryFactory = function($http, Model, Panel, Collection, $filter)
	{

		var GlossaryPanel = Panel.create('glossary');

		function Term(attrs) {
			var model = Model.create({
				attrs: attrs,
				name: 'term'
			});

			model.startWith = function(letter) {
				var label = model.getAttr('label').toLowerCase();
				var letter = letter.toLowerCase();
				return label.startsWith(letter);
			};

			return model;
		}

		function Glossary(attrs) {

			var activeLetter = false;
			var activeTerm = false;
			var terms = [];

			var model = Model.create({
				attrs: attrs,
				name: 'glossary'
			});

			model.terms = function(array) {

				if(array) {
					_.each(array, function(item) { terms.push(new Term(item)); });
				}

				if(terms.length)
					return terms;
			};

			model.letters = function() {
				var a = [], i = 'a'.charCodeAt(0), j = 'z'.charCodeAt(0);
				for (; i <= j; ++i) {
					a.push(String.fromCharCode(i));
				}
				return a;
			};

			model.filterByActiveLetter = function() {
				if(!model.getActiveLetter())
					return false;
				return $filter('firstLetter')(model.terms(), model.getActiveLetter(), 'label');
			};

			model.filterByLetter = function(letter) {
				return $filter('firstLetter')(model.terms(), letter, 'label');
			};

			model.setActiveLetter = function(letter) {
				activeLetter = letter;
				activeTerm = false;
				return model;
			};

			model.getActiveLetter = function() {
				return activeLetter;
			};

			model.term = function(term) {
				if(term)
					activeTerm = term;
				return activeTerm;
			};

			return model;
		}

		var GlossaryInstance = new Glossary();

		var service = {
			panel: GlossaryPanel,
			init: function() {
				$http.get('config/glossary.json').then(function(response){
					GlossaryInstance.terms(response.data.items);
				});
			},
			instance: GlossaryInstance
		};

		return service;
	};

	GlossaryFactory.$inject = ['$http', 'Model', 'Panel', 'Collection', '$filter'];

	angular.module('Application')
		.factory('Glossary', GlossaryFactory)
		.run(['Glossary', 'App', function(Glossary, App)
		{
			Glossary.init();

			Glossary.panel.on('open', function() {
				App.module().lesson().page().video().pause();
			});
		}]);

})();

app.service('Helper', function () {

    var service = {
        toHHMMSS: function (string) {
            var sec_num = parseInt(string, 10); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);

            if (hours < 10) {
                hours = "0" + hours;
            }
            
            var time = hours + ':' + this.toMMSS(string);
            return time;
        },
        toMMSS: function(string){
            var sec_num = parseInt(string, 10); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            var time = minutes + ':' + seconds;
            return time;
        },
        getLetterMaiusc: function(i) {
            return String.fromCharCode(97 + i).toUpperCase();
        }
    };

    /**
     * Se non esiste definisco la funzione INDEXOF
     */
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function (searchElement /*, fromIndex */) {
            if (this == null) {
                throw new TypeError();
            }
            var n, k, t = Object(this),
                    len = t.length >>> 0;

            if (len === 0) {
                return -1;
            }
            n = 0;
            if (arguments.length > 1) {
                n = Number(arguments[1]);
                if (n != n) { // shortcut for verifying if it's NaN
                    n = 0;
                } else if (n != 0 && n != Infinity && n != -Infinity) {
                    n = (n > 0 || -1) * Math.floor(Math.abs(n));
                }
            }
            if (n >= len) {
                return -1;
            }
            for (k = n >= 0 ? n : Math.max(len - Math.abs(n), 0); k < len; k++) {
                if (k in t && t[k] === searchElement) {
                    return k;
                }
            }
            return -1;
        };
    }

    // attach the .equals method to Array's prototype to call it on any array
    Array.prototype.equals = function (array) {
        // if the other array is a falsy value, return
        if (!array)
            return false;

        // compare lengths - can save a lot of time 
        if (this.length != array.length)
            return false;

        for (var i = 0, l = this.length; i < l; i++) {
            // Check if we have nested arrays
            if (this[i] instanceof Array && array[i] instanceof Array) {
                // recurse into the nested arrays
                if (!this[i].equals(array[i]))
                    return false;
            }
            else if (this[i] != array[i]) {
                // Warning - two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
        }
        return true;
    }

    /**
     * Se non esiste definisco la funzione TRIM()
     */
    if (typeof String.prototype.trim !== 'function') {
        String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/gi, '');
        }
    }

    return service;
});

app.factory('Lesson', ['Model', 'Page', function (Model, Page) {

    var all = [];

    function Lesson(attrs) {

        var pages = false;
        // let _duration = null;

        var model = Model.create({
            attrs: attrs,
            name: 'lesson'
        });

        model.pages = function () {
            if (pages === false) {
                pages = Page.collection(attrs.pages)
            }
            return pages;
        };

        model.page = function () {
            return model.pages().current();
        };

        model.prevPage = function () {
            if (!model.pages().isAtTheStart()) {

                if (model.page().audio())
                    model.page().audio().stop();

                if (model.page().video())
                    model.page().video().pause();

                model.pages().prev();
            }
        };

        model.nextPage = function () {
            if (
                model.page().isViewed() &&
                !model.pages().isAtTheEnd()
            ) {
                if (model.page().audio())
                    model.page().audio().stop();

                if (model.page().video())
                    model.page().video().pause();

                model.pages().next();
            }
        };

        /**
         * Go to page if is already viewed
         * @param  {Int} i
         * @param {Boolean} unblock
         * @return {Model}
         */
        model.goToPage = function (i, unblock) {

            if (!model.pages().get(i).isViewed() && !unblock)
                return model;

            if (model.page() && model.page().video())
                model.page().video().pause();

            model.pages().setCurrent(i);
            Page.events.emit('change');
            return model;
        };

        /**
         * Check if page param is the current
         * page in view
         * @param {Page} page
         * @return {Boolean}]
         */
        model.isCurrent = function (page) {
            return model.page() == page;
        };

        /**
         * @description check if lesson is viewed
         * @return {Boolean}
         */
        model.isViewed = function() {
            var _return = true;
            model.pages().all().forEach(function(item) {
                if (!item.isViewed()) {
                    _return = false;
                    return;
                }
            });
            return _return;
        };

        // /**
        //  * @description get duration module
        //  * @return seconds
        //  */
        // model.duration = ()=>{
        //     if(_duration === null) {
        //         model.pages().forEach(page => _duration+=page.duration());
        //     }
        //     return _duration;
        // };
        
        model.setCurrentPage = function (i) {
            model.pages().setCurrent(i);
            return model;
        };

        model.pagesWithExercises = function () {
            return _.filter(pages.all(), function (p) {
                return p.hasExercises();
            });
        };

        model.pagesPassed = function () {
            var passed = 0;

            _.each(pages.all(), function (p) {
                if (p.hasExercises() && p.passed()) {
                    passed++;
                }
            });

            return passed;
        }

        /**
         * @description get score lesson
         * @return {number}
         */
        model.score = () => {
            let score = 0;
            model.pages().forEach(page => score += page.score());
            // console.log("LessonSCORE", score);
            return score;
        };

        /**
         * @description get score lesson
         * @return {number}
         */
        model.maxScore = () => {
            let score = 0;
            model.pages().forEach(page => score += page.maxScore());
            return score;
        };

        return model;
    };

    var service = {
        create: function (attrs) {
            return new Lesson(attrs);
        },
        collection: function (array) {
            if (!all.length) {
                var tmp = [];
                _.each(array, function (item) {
                    tmp.push(new Lesson(item));
                });
                all = Model.collection(tmp);
            }
            return all;
        }
    };

    return service;
}]);


app.factory('Menu', ['Panel', function(Panel){
        
    var panel = Panel.create('menu');
        
    var all = [];
        
    var service = {
        panel: panel
    };
    
    return service;
}]);

app.factory('MenuButton', ['Menu', 'Panel', 'Event', '$http',
    function(Menu, Panel, Event, $http){
  
        var buttons = [];
        var all = [];
        var allBottoms = [];
        var allTops = [];

        // get all buttons
        $http.get('config/buttons.json').then(function(response){
        
            buttons = response.data.buttons;

            _.each(buttons, function(item)
            {
               all.push(new Button(item)); 
            });
        });

        var panel = Panel.create('menu-in');
        var eventer = Event.create('menu-in');
        
        // l'ultimo pulsante cliccato
        var lastButtonNameOpened = false;
  
        panel.on('open', function(){
            Menu.panel.open();
        }, false);
        
        panel.on('close', function(){
            Menu.panel.close();
        }, false);
  
        function Button(attrs) {
            var _this = this;
            _this.attrs = attrs;
            
            _this.open = function(name){
                    
                lastButtonNameOpened = name;

                if(!_this.has('fn')) {
                    panel.open();
                    
                    eventer.emit('open', {
                        name: name
                    });
                }
                else {
                    _this.has('fn')['default'].call(this);
                }
                    
            };
            
            _this.hasPanel = function(){
                if(_this.attrs.link)
                    return false;
                
                if(_this.attrs.panel || angular.isUndefined(_this.attrs.panel))
                   return true;
                else
                   return false;
            };
            
            _this.has = function(attr){
                return _this.attrs[attr];
            };
            
            _this.hasExpandedView = function(){
                return _this.attrs.expand;
            };
            
            _this.close = function(){
                
                if(!_this.has('fn')) {
                    lastButtonNameOpened = false;
                    panel.close();
                    eventer.emit('close');
                }
                else {
                    _this.has('fn').reverse.call(this);
                }
            };
            
            _this.toggle = function(){
                if(_this.hasPanel())
                {
                    if(lastButtonNameOpened == _this.attrs.name)
                        return _this.close();
                    else 
                        return _this.open(_this.attrs.name);
                }
            };
            
            _this.isOpened = function(){
                return lastButtonNameOpened == _this.attrs.name;
            };
            
            _this.name = function(){
                return _this.attrs.name;
            };
            
            _this.icon = function(){
                if(_this.attrs.icon)
                    return 'glyphicon-'+_this.attrs.icon;
                return false;
            };
            
            _this.label = function() {
                return _this.attrs.label;   
            };
            
            _this.link = function() {
                return _this.attrs.link;
            };
            
            _this.goBottom = function(){
                return _this.attrs.bottom;
            };

            // get css of button state
            _this.getClasses = function(){
                var classes = '';

                if(_this.isOpened(_this.name()))
                    classes += 'active ';

                if(_this.attrs.disabled)
                    classes += 'disabled ';

                return classes;
            };  

            return _this;
        };
        
        var service = {
            create: function(attrs) {
                return new Button(attrs);
            },
            all: function(){
                return all;
            },
            events: eventer,
            isOpened: function(name){
                return lastButtonNameOpened == name;
            },
            lastOpened: function(){
                var i = false;
                _.each(this.all(), function(item, k){
                    if(item.name() == lastButtonNameOpened)
                    {
                        i = k;
                        return;
                    }
                });
                return this.all()[i];
            },
            allBottoms: function(){
                if(!allBottoms.length)
                {
                    _.each(this.all(), function(item){
                        if(item.goBottom())
                            allBottoms.push(item);
                    });
                }
                return allBottoms;
            },
            allTops: function(){
                if(!allTops.length)
                {
                    _.each(this.all(), function(item){
                        if(!item.goBottom())
                            allTops.push(item);
                    });
                }
                return allTops;
            },
            find: function(name){
                var founded = false;

                _.each(this.all(), function(item){
                    if(item.name() == name) {
                        founded = item;
                        return;
                    }
                });

                return founded;
            },
            isAPanelOpened: function(){
                return lastButtonNameOpened;
            }
        };
        
        return service;
}]);

app.factory('Model', ['Collection', '$injector', 'Sound', '$filter',
    function (Collection, $injector, Sound, $filter) {

        var utils = {
            /**
             * if object has items array, i'll return
             * them, if not i'll return the entire object
             * because it's items array
             * @param  {JSON} obj
             * @return {array}
             */
            getItems: function(obj) {
                return obj && obj.items ? obj.items : obj;
            },
            /**
             * Function applying the options of the object
             * to filter its items
             * es. limit, random, etc.
             * @param  {json} obj   json object
             * @param  {array} items json array of obj children
             * @return {array}
             */
            filterByOptions: function (obj, items) {
                var array = items;

                if(obj.random) {
                    array = _.shuffle(items);
                }

                if(obj.limit) {
                    array = _.initial(array, obj.limit);
                }

                return array;
            },
            /**
             * Check if a number is really integer and not float
             * @param  {Number}  value
             * @return {Boolean}
             */
            isInt: function(value) {
                return Number(value) === value && value % 1 === 0;
            }
        };

        function Model(setup) {
            var _this = this
            var _event = false;
            var audio = false;
            var properties = {};
            _this.attr = setup.attrs;

            _this.middleware = { attrs: {}};

            _this.getAttr = function (attr) {
                if(!angular.isUndefined(_this.middleware.attrs[attr]))
                {
                    return _this.middleware.attrs[attr](_this.getPlainAttr(attr));
                }
                return _this.getPlainAttr(attr);
            };

            _this.getTransAttr = function(attr) {
                return $filter('translate')(_this.getAttr(attr));
            };

            _this.getPlainAttr = function(attr){
                return _this.attr[attr];
            };

            _this.getAttrs = function(){
                return _this.attr;
            };

            _this.setAttr = function(attr, value) {
                _this.attr[attr] = value;
                return _this;
            }

            _this.copyAttr = function(destination, source) {
                _this.attr[destination] = angular.copy(_this.getAttr(source));
                return _this;
            };

            _this.title = function () {
                return _this.getAttr('title');
            };

            _this.name = function(){
                return _this.getAttr('name');
            };

            _this.img = function(){
                return _this.getAttr('img');
            };

            /**
             * Get audio of timing
             * @return {Sound}
             */
            _this.audio = function() {
                if(!audio)
                {
                    if(_this.getAttr('audio'))
                    {
                        audio = Sound.create(_this.getAttr('audio'));
                    }
                }
                return audio;
            };

            /**
             * Check if page has audio and is playing
             * @return {Boolean}
             */
            _this.hasAudioAndIsPlaying = function(){
                if(_this.audio())
                {
                    if(_this.audio().isPaused())
                    {
                        return false;
                    }
                    return true;
                }
            };

            /**
             * Find an obj in a list of fns joined with a '.'
             * in string format
             * @param  {Strin} path
             * @param  {Mix} index
             * @return {Mix}
             */
            _this.findIn = function(path, index) {

                var result = _this.chainFn(path);

                if(result)
                {
                    if(utils.isInt(index))
                    {
                        // index is really an index
                        return result[index];
                    }
                    else
                    {
                        // index in reality is a obj
                        var found = _.indexOf(result, index)
                        return found > -1 ? found : false;
                    }
                }

                return false;
            };

            _this.chainFn = function(path) {
                var methods = path.split('.');
                var result = _this[methods[0]]();
                methods.shift();

                _.each(methods, function(method){
                    result = result[method]();
                });

                return result;
            };

            /**
             * Check if element is of name
             * @param  {string} name
             * @return {boolean}
             */
            _this.__is = function(name) {
                return name == setup.name;
            };

            // add a many relationship
            _this.many = function(model, _callback) {
                // property name (model.questions)
                var propertyName = model.toLowerCase()+'s';
                // the model object to use (Question)
                var injector = $injector.get(model);

                // declare property
                properties[propertyName] = false;

                // create function to get the array of objects
                _this[propertyName] = function()
                {
                    if(!properties[propertyName])
                    {
                        var obj = _this.getAttr(propertyName);

                        if(obj)
                        {
                            var arrayJSONItems = utils.getItems(obj);
                            var array = Collection.create([]);

                            // apply the filter of the objects (limit, random, etc..)
                            arrayJSONItems = utils.filterByOptions(obj, arrayJSONItems);

                            injector.load(function(response)
                            {
                                _.each(arrayJSONItems, function(item)
                                {
                                    var itemToAdd;

                                    // check if is an external resource
                                    if(typeof item == 'string' && item.length > 1)
                                    {
                                        // get resource and position index Exercise:0
                                        var resource = item.split(':');
                                        if(resource.length)
                                        {
                                            var resourceInjector = $injector.get(resource[0]);
                                            itemToAdd = resourceInjector.get(resource[1]);
                                        }
                                    }
                                    else {
                                        itemToAdd = injector.get(item);
                                    }

                                    // add to Collection
                                    if(itemToAdd)
                                        array.add(itemToAdd);
                                });

                                properties[propertyName] = array;
                            });
                        }
                    };

                    return properties[propertyName];
                };

                _this[propertyName]();
            };

            // add a many relationship
            _this.manyFromFile = function(model, _callback) {
                // property name (model.questions)
                var propertyName = model.toLowerCase()+'s';
                // the model object to use (Question)
                var injector = $injector.get(model);

                // declare property
                properties[propertyName] =  Collection.create([]);

                // create function to get the array of objects
                _this[propertyName] = function()
                {
                    if(!properties[propertyName].isNotEmpty())
                    {
                        var obj = _this.getAttr(model);

                        if(obj)
                        {
                            injector.load(function(response)
                            {
                                _.each(obj, function(index)
                                {
                                    var itemToAdd = injector.create(response.data.items[index]);
                                    // add to Collection
                                    if(itemToAdd)
                                        properties[propertyName].add(itemToAdd);
                                });
                            });
                        }
                    };

                    return properties[propertyName];
                };

                _this[propertyName]();
            };

            // add a one relationship
            _this.one = function(model)
            {
                // property name (model.questions)
                var propertyName = model.toLowerCase();

                // the model object to use (Question)
                var injector = $injector.get(model);

                // declare property
                properties[propertyName] = false;

                _this[propertyName] = function()
                {
                    if(!properties[propertyName])
                    {
                        var obj = _this.getAttr(propertyName);

                        if(!obj)
                        {
                            obj = _this.getAttr(model);
                        }

                        if(obj !== false && obj !== null) properties[propertyName] = injector.get(obj);
                    };
                    return properties[propertyName];
                };
            };

            return _this;
        };

        var service = {
            create: function (setup) {
                return new Model(setup);
            },
            collection: function (array) {
                return Collection.create(array);
            }
        };

        return service;
    }]);

app.factory('Module', ['Model', 'Lesson', '$timeout', function (Model, Lesson, $timeout) {

    var all = [];

    function Module(attrs) {

        var lessons = false;
        var exercises = [];
        var _is_visible = false;

        var model = Model.create({
            attrs: attrs,
            name: 'module'
        });

        model.lessons = function () {
            if (lessons === false) {
                lessons = Lesson.collection(attrs.lessons);
            }
            return lessons;
        };

        model.lesson = function () {
            return model.lessons().current();
        };

        model.setCurrentLesson = function (i) {
            model.lessons().setCurrent(i);
            // model.lesson().pages().setCurrent(0);
            return model;
        };

        model.nextLesson = function () {
            if (!model.lessons().isAtTheEnd()) {

                if (model.lesson().page().video())
                    model.lesson().page().video().pause();

                model.lessons().next();
                model.lesson().pages().setCurrent(0);
            }
            return model;
        };

        model.isCurrent = function (lesson) {
            var i = _.indexOf(model.lessons().all(), lesson);
            if (i > -1)
                return model.lessons().isCurrent(i);
            return false;
        }

        model.prevLesson = function () {
            if (!model.lessons().isAtTheStart()) {

                if (model.lesson().page().video())
                    model.lesson().page().video().pause();

                model.lessons().prev();
                model.lesson().pages().setCurrent(0);
            }
            return model;
        };

        model.exercises = function () {
            if (!exercises.length) {
                _.each(model.lessons().all(), function (lesson) {
                    _.each(lesson.pages().all(), function (page) {
                        exercises = _.union(exercises, page.exercises());
                    });
                });
            }
            return exercises;
        };

        // This method gets exercises from pages (only one exercises per page)
        model.moduleExercises = function () {
            if (!exercises.length) {
                _.each(model.lessons().all(), function (lesson) {
                    _.each(lesson.pages().all(), function (page) {
                        // console.log( page.getAttr('title'), page.hasExercise(), page.hasTimingExercises(), page.exercises() );
                        if (page.hasExercise())
                            exercises = _.union(exercises, [page.hasExercise()]);
                    });
                });
            }
            return exercises;
        };
        
        model.improvedModuleExercises = function () {
            if (!exercises.length) {
                _.each(model.lessons().all(), function (lesson) {
                    _.each(lesson.pages().all(), function (page) {
                        // if (page.hasTimingExercises()) console.log( page.getAttr('title'), page.hasExercise(), page.hasTimingExercises() );
                        // console.log(">>>",page.hasTimingExercises());
                        if (page.hasTimingExercises())
                            exercises = _.union(exercises, page.hasTimingExercises());
                    });
                });
            }
            // console.log("TEST", exercises.length, exercises);
            // _.each(exercises, function (exercise) {
            //     if (exercise) {
            //         console.log(typeof exercise, exercise);
            //         console.log("ex", exercise.getAttr('label'));
            //         console.log(exercise.isCorrect(), exercise.isConfirmed());
            //     }
            // });
            return exercises;
        };

        model.testExercises = function () {
            var exercises = [];
            _.each(model.lessons().all(), function (lesson) {
                _.each(lesson.pages().all(), function (page) {
                    // if (page.hasTimingExercises()) console.log( page.getAttr('title'), page.hasExercise(), page.hasTimingExercises() );
                    // console.log(">>>",page.hasTimingExercises());
                    if (page.hasTimingExercises()) {
                        _.each(page.hasTimingExercises(), function(item) {
                            if (item && item.getAttr('finalTestItem')) exercises.push(item);
                        });
                    }
                });
            });
            // console.log(exercises);
            return exercises;
        };

        model.correctExercises = function () {
            var correct;
            if (this.moduleExercises().length) {
                correct = _.filter(this.moduleExercises(), function (exercise) {
                    return exercise.isCorrect();
                });
            }
            // console.log(correct);
            return correct;
        };
        
        model.isAtLeastOneExerciseConfirmed = function () {
            var confirmed;
            if (this.moduleExercises().length) {
                confirmed = _.find(this.moduleExercises(), function (exercise) {
                    return exercise && exercise.isConfirmed();
                });
            }
            // console.log(confirmed);
            return confirmed;
        };

        model.isViewed = function() {
            var _return = true;
            _.each(model.lessons().all(), function(l) {
                _.each(l.pages().all(), function(p) {
                    if(!p.isViewed()) {
                        _return = false;
                        return false;
                    }
                });
            });
            return _return;
        };

        /**
         * @description set visibility after x seconds
         * @param seconds
         */
        model.setVisibilityAfter = function(seconds) {
          $timeout(function() { model.setVisibility() }, seconds*1000);
        };

        /**
         * @description set visibility on
         */
        model.setVisibility = function() {
            _is_visible = true;
        };

        /**
         * @description check if module is visible
         * @return {boolean}
         */
        model.isVisible = function() {
            return _is_visible;
        };

        /**
         * @description get score lesson
         * @return {number}
         */
        model.score = () => {
            let score = 0;
            model.lessons().forEach(lesson => score += lesson.score());
            return score;
        };

        /**
         * @description get max score lesson
         * @return {number}
         */
        model.maxScore = () => {
            let score = 0;
            model.lessons().forEach(lesson => score += lesson.maxScore());
            return score;
        };

        model.isFinalTest = () => {
            return model.getAttr('finaltest');
        };

        model.isFinalTestAttempted = () => {
            var confEx = _.find(model.improvedModuleExercises(), function(exercise) {
                return exercise.isConfirmed();
            });
            // console.log(confEx);
            return !! confEx;
        };

        model.finalTestPercentage = () => {
            var countResults = _.countBy(model.testExercises(), function(exercise) {
                return exercise.isCorrect() && exercise.getAttr('finalTestItem') ? 'correct': 'wrong';
            });
            // console.log(countResults);
            var percentage = ((countResults.correct || 0) * 100) / model.testExercises().length;
            return Math.round(percentage);
        };

        return model;
    }

    var service = {
        create: function (attrs) {
            return new Module(attrs);
        },
        collection: function (array) {
            if (!all.length) {
                var tmp = [];
                _.each(array, function (item) {
                    tmp.push(new Module(item));
                });
                all = Model.collection(tmp);
            }
            return all;
        }
    };

    return service;
}]);

(function () {

    'use strict';

    var PageFactory = function (Model, Video, Subtitles, Event, Exercise, Test, Sound, Timing, Html) {
        var all = [];

        // creo il gestore di eventi
        var eventer = Event.create('page');

        function Page(attrs) {

            var subtitles = false;
            var video = false;
            var test = false;
            var audio = false;
            var exercises = [];

            var viewed = false;

            var model = Model.create({
                attrs: attrs,
                name: 'page'
            });

            model.video = function () {
                if (video === false) {
                    var setup = model.getAttr('video');
                    if (setup) {
                        video = Video.create(setup);
                    }
                    else
                        video = null;
                }
                return video;
            };

            model.disposeVideo = function () {
                model.video().dispose();
                video = false;
                return model;
            };

            model.audio = function () {
                if (!audio) {
                    if (model.getAttr('audio')) {
                        audio = Sound.create(model.getAttr('audio'));
                    }
                }
                return audio;
            };

            /**
             * Check if page has audio and is playing
             * @return {Boolean}
             */
            model.hasAudioAndIsPlaying = function () {
                if (model.audio()) {
                    if (model.audio().isPaused()) {
                        return false;
                    }
                    return true;
                }
            };

            model.subtitles = function () {
                if (!subtitles) {
                    subtitles = Subtitles.create({text: model.getAttr('subtitles')});
                }
                return subtitles;
            };

            /**
             * @description update video in page
             * @return Video|void
             */
            model.updateVideo = function () {
                if (!model.video()) return;

                model.video().pause();
                model.video().updateSrc(model.getAttr('video').src);
                model.video().play();
                return model.video();
            };

            model.hasExercises = function () {
                return model.getAttr('exercises') || (model.html() && model.html().getAttr('Exercise'));
            }

            model.exercises = function () {
                var jsonExercises = model.getAttr('exercises') ? model.getAttr('exercises') : model.html().getAttr('Exercise');

                if (!exercises.length) {
                    _.each(jsonExercises, function (e) {
                        exercises.push(Exercise.find(e));
                    });
                }
                return exercises;
            };

            model.passed = function () {
                if (!model.exercises()) return true;

                var minScore = model.getAttr('minScore') ? model.getAttr('minScore') : exercises.length;
                var corrects = 0;

                _.each(exercises, function (e) {
                    if (e.isCorrect()) {
                        corrects++;
                    }
                });


                return corrects >= minScore;
            }

            model.viewed = function () {
                // console.trace();
                viewed = true;
                eventer.emit('viewed', {model: model});
                return model;
            };

            model.setViewed = function (value) {
                viewed = value;
                return model;
            };

            model.isViewed = function () {
                return viewed;
            };

            /**
             * Get Test model chained with the page
             * @return {Test}
             */
            model.test = function () {
                if (!test) {
                    if (model.getAttr('Test'))
                        test = Test.create(model.getAttr('Test'));
                }
                return test;
            };

            model.htmlSource = function () {
                if (model.html())
                    return 'html/' + model.html().getAttr('src') + '.html';
                return false;
            };

            // /**
            //  * @description get duration page
            //  * @return seconds
            //  */
            // model.duration = () => {
            //     return model.video() ? model.video().duration() : 0;
            // };

            /**
             * @description check if page has exercise
             */
            model.hasExercise = function() {
                if(!model.getAttr('video')) return false;
                let videoTimings = model.getAttr('video').timing;
                if(!videoTimings) return false;

                let timingOptions = videoTimings[videoTimings.length-1];
                let lasttimingpage = model.getAttr('video') ? Timing.create(timingOptions) : false;
                if (lasttimingpage) {
                    let html = lasttimingpage.getModule('Html')[0];
                    if(html && html.getAttr('Exercise')) {
                        return html.exercises().get(0);
                    }
                }
                return false;
            };

            /**
             * @description check if page has exercise
             */
            model.hasTimingExercises = ()=>{
                let exercises = [];

                if (model.getAttr('video')) {
                    let videoTimings = model.getAttr('video').timing;

                    if (videoTimings){

                        videoTimings.forEach(videoTiming => {
                            let timingpage = model.getAttr('video') ? Timing.create(videoTiming) : false;
                            if (timingpage) {
                                let html = timingpage.getModule('Html')[0];
                                if(html && html.getAttr('Exercise')) {
                                    html.getAttr('Exercise').forEach(Ex => {
                                        exercises.push(Exercise.find(Ex));
                                    });
                                }
                            }
                        });
                    }
                }
                // console.log("111", exercises);
                if (!exercises.length && model.hasExercises()) {                   
                    var jsonExercises = model.getAttr('exercises') ? model.getAttr('exercises') : model.html().getAttr('Exercise');
                    
                    if (!exercises.length) {
                        _.each(jsonExercises, function (e) {
                            exercises.push(Exercise.find(e));
                        });
                    }
                }
                // console.log(exercises);
                return (exercises.length) ? exercises : false;

                // let timingOptions = videoTimings[videoTimings.length-1];
                // let lasttimingpage = model.getAttr('video') ? Timing.create(timingOptions) : false;
                // if(lasttimingpage) {
                //     let html = lasttimingpage.getModule('Html')[0];
                //     if(html && html.getAttr('Exercise')) {
                //         return html.exercises().get(0);
                //     }
                // }
                // return false;
            };

            /**
             * @description get score page
             * @return {integer}
             */
            model.score = function() {
                let scorePage = model.isViewed() && model.getAttr('score') ? model.getAttr('score') : 0;
                let ex = model.hasExercise();

                let exs = model.hasTimingExercises();
                if (exs) {
                    exs.forEach(ex => {
                        // if (ex.getAttr('label').includes('exercises.m4_')) {
                        //     console.log(ex.getAttr('label'), ex.score());
                        // }
                        if(ex.getAttr('score')) {
                            scorePage = ex.score() + scorePage;
                        }
                    });
                }
                return scorePage;
            };

            /**
             * @description get score page
             * @return {integer}
             */
            model.maxScore = function() {
                let scorePage = model.getAttr('score') ? model.getAttr('score') : 0;
                let ex = model.hasExercise();

                let exs = model.hasTimingExercises();
                if (exs) {
                    exs.forEach(ex => {
                        if(ex.getAttr('score')) {
                            scorePage = ex.getAttr('score') + scorePage;
                        }
                    });
                }
                return scorePage;
            };

            // many relation with doits
            model.many('Doit');
            model.one('Html');

            return model;
        };

        var service = {
            create: function (attrs) {
                return new Page(attrs);
            },
            collection: function (array) {
                if (!all.length) {
                    var tmp = [];
                    _.each(array, function (item) {
                        tmp.push(new Page(item));
                    });
                    all = Model.collection(tmp);
                }
                return all;
            },
            events: eventer,
            next: function () {
                this.events.emit('change.pre');
                this.events.emit('next');
                return false;
            },
            prev: function () {
                this.events.emit('change.pre');
                this.events.emit('prev');
                return false;
            }
        };

        return service;
    };


    PageFactory.$inject = ['Model', 'Video', 'Subtitles', 'Event', 'Exercise', 'Test', 'Sound', 'Timing', 'Html'];

    angular.module('Application')
        .factory('Page', PageFactory)
        .run(['App', 'Page', 'Subtitles', 'MenuButton', '$rootScope', '$timeout', function (App, Page, Subtitles, MenuButton, $rootScope, $timeout) {
            App.events.on('module.open', function() {
                // when pages load, i set page viewed if
                // navigation is not restricted
                if (App.config().isFree() && App.module()) {
                    App.module().lesson().page().viewed();
                }
            });

            /*
             *   Ogniqualvolta viene cambiata la pagina
             */
            Page.events.on('change', function() {

                // if the page has not subtitles
                // i'll close the panel
                if (!App.module().lesson().page().getAttr('subtitles'))
                    Subtitles.panel.close();

                // chiudo l'ultimo pulsante aperto
                // definito nel caso in cui venga premuto
                // un pulsante di "Vai alla pagina", chiude
                // il popup dell'indice
                if (MenuButton.lastOpened())
                    MenuButton.lastOpened().close();

                // se the page viewed if navigation is not restricted
                if (App.config().isFree()) {
                    App.module().lesson().page().viewed();
                }

                // aggiorno il src del video con quello della
                // pagina effettiva, NECESSARIO perchè il componente
                // Videojs NON gestisce il double-binding
                if (App.module().lesson().page().video()) {
                    let video = App.module().lesson().page().updateVideo();

                    if (!App.panels.resume.isOpened()) {
                        video.play();
                    }
                    else {
                        video.pause();
                    }
                }
                else
                    App.exitFullscreen();

                if (App.module().lesson().page().audio()) {
                    App.module().lesson().page().audio().play();
                }

            });

            App.events.on('menu.change', function() {
                if (App.module().lesson().page().video())
                    App.module().lesson().page().updateVideo();
            });
            
        }]);

})();


app.factory('Panel', ['Event', '$timeout', function (Event, $timeout) {

    function Panel(_event) {
        
        var events = Event.create(_event+'.panel');
        
        this.attrs = {
            opened: false,
            reduce: false
        };
        
        this.open = function(){
            // console.log("panel.open", this,_event,events);
            this.attrs.opened = true;
            events.emit('open');
            return this;
        };
        
        this.close = function(){
            // console.log("panel.close");
            this.attrs.opened = false;
            events.emit('close');
            return this;
        };
        
        this.isOpened = function(){
            return this.attrs.opened;
        };
        
        this.reduce = function(){
            this.attrs.reduce = true;
            events.emit('reduce');
            return this;
        };
        
        this.expand = function(){
            this.attrs.reduce = false;
            events.emit('expand');
            return this;
        };
        
        this.isReduced = function(){
            return this.attrs.reduce;
        };
        
        this.isClosed = function(){
            return !this.isOpened();
        };

        this.toggle = function(){
            // console.log("toggle");
            if(this.isOpened())
                this.close();
            else 
                this.open();
            events.emit('toggle');
            return this;
        };
        
        this.on = function(event, _function, time){
            events.on(event, _function, time);
        };
        
        return this;
    };

    return {
        create: function (_event) {
            return new Panel(_event);
        }
    }
}]);

(function(){

	'use strict';

	var RepeatFactory = function($http, Model, Overlay, MenuButton){

		var all = [];

		$http.get('config/repeats.json').then(function(response){
			_.each(response.data.items, function(item)
            {
               all.push(new Repeat(item)); 
            });
		});

		function Repeat(attrs) {
			var model = Model.create({
	            attrs: attrs,
	            name: 'repeat'
	        });

			model.filepath = function(){
				return model.getAttr('file') + '.' + model.getAttr('type');
			};

			model.open = function() {
				MenuButton.find('repeat').open();
				Overlay.open('repeat', model) ;
			};

	        return model;
		};


		var service = {
			create: function(attrs){
				return new Term(attrs);
			},
			get: function(index){
				if(all[index])
					return all[index];

				return false;
			},
			all: function(){
				return all;
			}
		};

		return service;
	};


	RepeatFactory.$inject = ['$http','Model', 'Overlay', 'MenuButton'];

	angular.module('Application')
		.factory('Repeat', RepeatFactory);

})();

(function(){

	'use strict';

	var SoundService = function(){

		function Sound(attrs) {

			var model = new buzz.sound('audio/'+attrs.src, {
				formats: ['mp3']
			});

      model.repeat = function() {
          model.stop();
        model.play();
        return model;
      };

			model.duration = function() {
				return model.getDuration();
			};

			return model;

		};

		var service = {
			create: function(attrs) {
				return new Sound(attrs);
			}
		};


		return service;
	};

	SoundService.$inject = [];

	angular.module('Application')
		.factory('Sound', SoundService);

})();

(function(){

    'use strict';

    var SubtitleFactory = function(Panel, Model)
    {
        var panel = Panel.create('subtitles');
    
        function Subtitles(attrs) 
        {            
            var model = Model.create({
                attrs: attrs,
                name: 'subtitle'
            });
            
            model.text = function(){
                return model.getAttr('text');
            };
                
            return model;
        };
      
        var service = {
            create: function(attrs){
                return new Subtitles(attrs);
            },
            panel: panel 
        };
        
        return service;
    };

    SubtitleFactory.$inject = ['Panel', 'Model'];


    angular.module('Application')
        .factory('Subtitles', SubtitleFactory);

})();

(function() {

	'use strict';

	var TestFactory = function(Model, Exercise, Collection, Panel, Event)
	{

		var eventer = Event.create('test');

		function Test(attrs) 
		{
			var _exercises = Collection.create([]);
			var _incorrectExercises = Collection.create([]);
			var ended = false;
			var audio = false;

		 	var model = Model.create({
		        attrs: attrs,
		        name: 'test'
		    });

		    var _panels = {
		    	intro: Panel.create('Test.intro'),
		    	report: Panel.create('test.report')
		    };

		 	/**
		 	 * Get Exercise collection
		 	 * @return {Collection}
		 	 */	
		 	model.exercises = function() {
		 		if(!_exercises.isEmpty())
		 		{	
		 			var limit = model.getAttr('limit');

	 				_.each(model.getAttr('exercises'), function(value, key)
	 				{
	 					_exercises.add(Exercise.all()[value]);
	 				});

	 				if(model.getAttr('random'))
	 					_exercises.shuffle();

	 				if(limit)
	 					_exercises.limit(limit);	 					
		 		}
		 		return _exercises;
		 	};

		 	/**
		 	 * Get Exercise collection of incorrect exercise
		 	 * @return {Collection}
		 	 */
		 	model.incorrectExercises = function() {
		 		var array = false;
				
				array = model.exercises().filter(function(item){
	 				return !item.isCorrect();
	 			}); 
		 		
		 		return array;
		 	};

		 	/**
		 	 * Set test ended state
		 	 * @return {model}
		 	 */
		 	model.end = function(){
		 		ended = true;
		 		eventer.emit('ended', {test: model});
		 		return model;
		 	};

		 	/**
		 	 * Is Test ended?
		 	 * @return {boolean}
		 	 */
		 	model.ended = function() {
		 		return ended;
		 	};

		 	/**
		 	 * Check if test is passed
		 	 * @return {Boolean}
		 	 */
		 	model.isPassed = function() 
		 	{
		 		return model.score() >= model.getMinScoreToPass();
		 	};

		 	/**
		 	 * Get score of test
		 	 * @return {int}
		 	 */
		 	model.score = function()
		 	{
		 		var score = 0;
		 		_.each(model.exercises().all(), function(e)
		 		{
		 			try {
		 				if(e.isCorrect()) 
		 				score++;
		 			}
		 			catch(e) {}
		 		});

		 		return score;
		 	};

		 	/**
		 	 * Get score in percentage
		 	 * @return {int} 
		 	 */
		 	model.getPercScore = function()
		 	{
		 		return model.score() * 10;
		 	};

		 	/**
		 	 * Count number of correct or incorrect answers
		 	 * @param  {string} type
		 	 * @return {int}
		 	 */
		 	model.countAnswers = function(type)
		 	{
		 		var count = 0;
		 		_.each(model.exercises().all(), function(e) 
		 		{
		 			if(type == 'correct' && e.isCorrect())
		 				count++;

		 			if(type == 'incorrect' && !e.isCorrect())
		 				count++;
		 		});

		 		return count;
		 	};

		 	/**
		 	 * Repeat Test
		 	 * @return {Model}
		 	 */
		 	model.repeat = function(){
		 		_.each(model.exercises().all(), function(e){ e.reset(); });
		 		ended = false;
		 		model.exercises().setCurrent(0);
		 		return model;
		 	};

		 	/**
		 	 * Repeat test getting only incorrect exercises
		 	 * @return {Model}
		 	 */
		 	model.repeatOnlyIncorrect = function() {
		 		var firstIncorrectExIndex = null;

		 		_.each(model.exercises().all(), function(e, key){ 
		 			if(!e.isCorrect())
		 			{
		 				e.reset();

		 				if(firstIncorrectExIndex === null)
		 					firstIncorrectExIndex = key;

		 			}
		 		});

		 		ended = false;
		 		model.exercises().setCurrent(firstIncorrectExIndex);
		 	};

		 	model.getMinScoreToPass = function(){
		 		return (model.exercises().count()*model.getAttr('masteryScore'))/10;
		 	};

		 	model.panels = function(){
		 		return _panels;
		 	};

		 	model.audio = function() {
		 		if(!audio && model.getAttr('audio'))
		 		{
		 			audio = new buzz.sound('audio/'+model.getAttr('audio').src, {
					    formats: ["mp3"]
					});
		 		}
		 		return audio;
		 	};

		 	/**
		 	 * Track score 
		 	 * @return {Boolean}
		 	 */
		 	model.isTrackingScore = function()
		 	{
		 		return model.getAttr('track') == 'score';
		 	};

		 	/**
		 	 * Get mastery score in percentage
		 	 * @return {int}
		 	 */
		 	model.getPercMasteryScore = function()
		 	{
		 		return model.getAttr('masteryScore') * 10;
		 	};

		 	/**
		 	 * Get html layout
		 	 * @return {string}
		 	 */
		 	model.layout = function(){
		 		var layout = model.getAttr('layout');
		 		return layout ? layout : 'test.html';
		 	};

		 	model.panels().intro.on('close', function()
		 	{
		 		if(model.audio())
		 			model.audio().pause();
		 	});

		    return model;
		};


		return {
			create: function(attrs){
				return new Test(attrs);
			},
			events: eventer
		};
	};

	TestFactory.$inject = ['Model','Exercise', 'Collection', 'Panel', 'Event'];

	angular.module('Application')
		.factory('Test', TestFactory);

})();

(function(){

    'use strict';

    var TimingFactory = function($rootScope, $timeout, $injector, Model, Event)
    {
        var all = [];
        var eventer = Event.create('timing');

        function Timing(attrs) {

            var _opened = false;
            var audio = false;
            var objects = [];
            var modules = [];

            var model = Model.create({
                attrs: attrs,
                name: 'timing'
            });

            model.canLaunch = function(time){
                if(!model.opened())
                {
                    if(time == 'ended')
                        return model.getAttr('seconds') == 'ended';
                    else
                        return model.getAttr('seconds') == parseInt(time);
                }
                return false;
            };

            model.opened = function(){
                return _opened;
            };

            model.hasModule = function(modelname) {
                return model.getModule(modelname).length ? true : false;
            };

            model.hasModuleExcept = function(modelname){
                var _return = false;

                _.each(model.getAttrs(), function(value, key){
                    if(key != 'seconds' && key != 'restricted' && key != modelname)
                    {
                        _return = true;
                        return;
                    }
                });

                return _return;
            };

            /**
             * Close Timing object
             * @return {this}
             */
            model.close = function(){
                if(model.opened())
                {
                    _opened = false;
                    objects = [];
                    modules = [];
                    eventer.emit('close');
                }
                return model;
            };

            /**
             * Check when timing has to be closed
             * @param  {Video}  video
             * @return {Boolean}
             */
            model.hasToClose = function(video){
                if(model.isRestricted())
                    return false;

                var timeWhenClose = parseInt(model.getAttr('seconds')) + model.getTimeoutVisible();
                return video.currentTime() > timeWhenClose || video.currentTime() < parseInt(model.getAttr('seconds'));
            };

            /**
             * Open Timing object
             * if model is not mandatory to continue video playing
             * i'll make it visible for n seconds
             * @return {this}
             */
            model.open = function(){
                _opened = true;

                eventer.emit('open');

                return model;
            }

            /**
             * If is set a timeout specific, i'll use it
             * otherwise i show timming for 5 seconds
             * @return {Number}
             */
            model.getTimeoutVisible = function(){
                var timeout = model.getAttr('timeout');
                return timeout ? timeout : 5;
            };

            /**
             * Get the Repeat object
             * @return {Repeat}
             */
            model.repeat = function(){
                return Repeat.get(model.getAttr('Repeat'));
            };

            model.repeats = function(){
                if(!repeats.length)
                {
                    _.each(model.getAttr('Repeat'), function(key){
                        repeats.push(Repeat.get(key));
                    });
                }
                return repeats;
            };

            /**
             * Get a module chained with Timing
             * @param  {string} modelname name of a injector
             * @return {Array}
             */
            model.getModule = function(modelname){
                var _module = modelname.toLowerCase()+'s';
                if(angular.isUndefined(modules[_module]))
                {
                    modules[_module] = [];
                    var injector = $injector.get(modelname);

                    _.each(model.getAttr(modelname), function(key){
                        modules[_module].push(injector.get(key));
                    });
                }
                return modules[_module];
            };

            /**
             * Check if Timing is mandatory
             * @return {Boolean}
             */
            model.isRestricted = function(){
                return model.getAttr('restricted') == true;
            };

            /**
             * Get all objects chained with timing
             * @return {Array}
             */
            model.objects = function(){
                if(!objects.length)
                {
                    _.each(model.getAttrs(), function(value, key)
                    {
                        if(
                            key != 'restricted' &&
                            key != 'obligatory' && 
                            key != 'seconds'
                        )
                            objects = objects.concat(model.getModule(key));
                    });
                    objects = _.compact(objects);
                }
                return objects;
            };

            model.details = function () {
                return _.filter(model.objects(), function (object) {
                    return object.__is('detailed')
                });
            }

            model.mandatoryChilds = function () {
                return _.filter(model.objects(), function (object) {
                    return object.getAttr('mandatory');
                })
            }

            model.hasMandatoryChild = function () {
                return !! model.mandatoryChilds().length;
            }

            model.hasViewedAllMandatoryChilds = function () {
                return ! (!!_.find(model.mandatoryChilds(), function (object) {
                    // if (typeof object.viewed !== 'undefined')
                        return ! object.viewed()
                    // if (typeof object.isBlocked !== 'undefined')
                    //     return object.isBlocked()
                }));
            }

            model.hasObligatoryChild = function () {
                return !! model.getAttr('obligatory');
            };

            model.audio = function () {
                if (!audio) {
                    if (model.getAttr('audio')) {
                        audio = Sound.create(model.getAttr('audio'));
                    }
                }
                return audio;
            };

            /**
             * Check if page has audio and is playing
             * @return {Boolean}
             */
            model.hasAudioAndIsPlaying = function () {
                if (model.audio()) {
                    if (model.audio().isPaused()) {
                        return false;
                    }
                    return true;
                }
            };

            return model;
        };

        var service = {
            create: function (attrs) {
                return new Timing(attrs);
            },
            events: eventer
        };

        return service;

    };

    TimingFactory.$inject = ['$rootScope', '$timeout', '$injector', 'Model', 'Event'];

    angular.module('Application')
        .factory('Timing', TimingFactory);

})();

(function() {

    'use strict';

    var VideoService = function($rootScope, $timeout, $interval, $translate, Helper, Panel, Timing, Event, $compile, $filter) {

        var baseName = 'video';
        var eventer = Event.create(baseName);
        var _videoInterval = false;
        var _videoJsInstantiated = false;
        var player = false;

        function VideoAdvancedPanelInner() {
            var _this = Panel.create('video.advanced.inner');
            var _type = false;
            var _element = false;

            _this.openAndSet = function(type, el) {
                _type = type;
                _element = el;
                _this.open();
            };

            _this.getElement = function() {
                return _element;
            };

            _this.isTypeOpened = function(type) {
                return _type == type;
            }

            return _this;
        };

        function VideoAdvancedPanel() {
            var _this = Panel.create('video.advanced');
            _this.inner = new VideoAdvancedPanelInner();

            return _this;
        };

        function Video(attrs, setup) {

            var video = {};

            // Panel of advanced features during video playing
            video.advanced = new VideoAdvancedPanel;

            video.attrs = attrs;

            var _timing = false;
            var _timingsArray = [];

            video.replay = function() {
                video.pause();
                video.player().currentTime(0);
                video.play();

                return video;
            };

            video.ended = function() {
                return video.player().ended();
            };

            video.play = function() {
                return video.player().play();
            };

            video.pause = function() {
                return video.player().pause();
            };

            video.paused = function() {
                return video.player().paused();
            };

            video.dispose = function() {
                if (player)
                    video.pause();
                if (service.isLoadedVideoJs())
                    service.disposeVideoJs();
                _videoJsInstantiated = false;
                player = false;
            }

            video.src = function(params) {
                video.player().src(params).load();
                return player;
            };

            video.requestFullscreen = function() {
                eventer.emit('fullscreen');
                return video.player().requestFullscreen();
            };

            video.exitFullscreen = function() {
                eventer.emit('fullscreenOut');
                return video.player().isFullscreen() && video.player().exitFullscreen();
            };

            video.isFullscreen = function() {
                return (screen.availHeight || screen.height - 30) <= window.innerHeight;
            };

            video.currentTime = function() {
                return video.player().currentTime();
            };

            video.duration = function() {
                return video.player().duration();
            };

            video.player = function() {
                if (!player) {
                    player = service.loadVideoJs(setup);
                }
                return player;
            };

            video.updateSrc = function(src) {
                var srcVideo = $translate.use() + '/' + $filter('translate')(src);
                video.src({
                    type: 'video/mp4',
                    src: 'video/' + srcVideo + '.mp4'
                });
                video.stopInterval();
                video.closeAllTimings();
                return video;
            };

            video.backward = function() {
                var time = video.player().currentTime();
                video.player().currentTime(time - 15);
                return video;
            };

            video.forward = function() {
                var time = video.player().currentTime();
                video.player().currentTime(time + 15);
                return video;
            };

            video.durationString = function() {
                return Helper.toMMSS(video.duration());
            };

            video.currentTimeString = function() {
                return Helper.toMMSS(video.currentTime());
            };

            video.getAttr = function(attr) {
                var value = video.attrs[attr];
                if (attr == 'src') value = 'video/' + $filter('translate')(value) + '.mp4';
                return value;
            };

            video.toggle = function() {
                if (video.paused())
                    video.play()
                else
                    video.pause();
                return video;
            };

            video.currentTiming = function() {
                return _timing;
            }

            video.setTiming = function(newTiming) {
                _timing = newTiming;
                return video;
            }

            video.timings = function() {
                if (!_timingsArray.length) {
                    _.each(video.getAttr('timing'), function(item) {
                        _timingsArray.push(Timing.create(item));
                    });
                }
                return _timingsArray;
            }

            /**
             * @description get last timing
             * @return object
             */
            video.lastTiming = function() {
                if(!video.getAttr('timing')) return false;
                return video.timings()[video.getAttr('timing').length-1];
            };

            video.hasRestrictedTimings = function() {
                return !! _.find(video.timings(), function(timing) {
                    return timing.getAttr('restricted') == true;
                });
            }

            video.mandatoryTimings = function () {
                return _.filter(video.timings(), function (timing) {
                    return timing.hasMandatoryChild();
                })
            }

            video.hasMandatoryTiming = function () {
                return !! video.mandatoryTimings().length;
            }

            video.hasViewedAllMandatoryTimingsChilds = function () {
                return ! (!! _.find(video.mandatoryTimings(), function (timing) {
                    return ! timing.hasViewedAllMandatoryChilds();
                }))
            }

            video.obligatoryTimings = function () {
                return _.filter(video.timings(), function (timing) {
                    return timing.hasObligatoryChild();
                });
            }

            video.hasObligatoryTiming = function () {
                return !! video.obligatoryTimings().length;
            }

            video.loopTimings = function() {
                if (!video.timings())
                    return false;

                // check if current timing has to be closed
                // and when
                if (video.currentTiming() && video.currentTiming().hasToClose(video)) {
                    video.currentTiming().close();
                }

                // loop timings to view if one has to be launched
                _.each(video.timings(), function(item) {
                    var time = video.ended() ? 'ended' : video.currentTime();
                    if (item.canLaunch(time)) {
                        if (video.currentTiming() != item) {
                            video.setTiming(item)
                                .currentTiming()
                                .open(video.currentTime());
                        }
                    }
                });
            };

            video.closeAllTimings = function() {
                _.each(video.timings(), function(timing) {
                    timing.close();
                });

                video.advanced.close();
            };

            /**
             * Start to check if objects have to appear in video
             * @return {void}
             */
            video.startInterval = function() {

                video.stopInterval();

                _videoInterval = $interval(function() {
                    video.loopTimings();

                }, 1000);
            };

            /**
             * Remove the check to the video for Timing objects
             * @return {boolean}
             */
            video.stopInterval = function() {
                return $interval.cancel(_videoInterval);
            };

            video.updateSrc(attrs.src);

            video.advanced.inner.on('open', function() {
                video.pause();
            });

            // video.advanced.on('close', function() {
            //     if (!video.ended()) video.play();
            // });

            Timing.events.on('close', function() {

                if (video.advanced.isOpened())
                    video.advanced.close();

                video.setTiming(false);
            });

            Timing.events.on('open', function() {
                video.exitFullscreen();
                video.advanced.open();
            });

            return video;
        };

        var service = {
            create: function(attrs, setup) {

                if (this.isLoadedVideoJs())
                    return new Video(attrs, setup);

                return false;
            },
            on: function(event, _function) {
                return $rootScope.$on(baseName + '.' + event, function() {
                    _function.call(this);
                });
            },
            events: eventer,
            disposeVideoJs: function() {
                if (!angular.element('#videojs').length) {
                    return;
                }

                _videoJsInstantiated = false;
                videojs('videojs')
                    .pause()
                    .off('ended')
                    .off('timeupdate')
                    .off('play')
                    .off('pause')
                    .dispose();
            },
            loadVideoJs: function(setup) {

                if (!angular.element('#videojs').length) {
                    return;
                }

                var baseSetup = {
                    width: '100%',
                    height: '100%',
                    controls: false,
                    type: 'video/mp4',
                };

                var setup = angular.extend(baseSetup, setup);
                player = videojs('videojs', setup);

                player.ready(function() {
                    this.off('ended').on('ended', function() {
                        eventer.emit('ended');
                        eventer.emit('ended.timings');
                    });

                    this.off('play').on('play', function() {
                        eventer.emit('play');
                    });

                    this.off('pause').on('pause', function() {
                        eventer.emit('pause');
                    });

                    this.on('timeupdate', function() {
                        eventer.emit('timeupdate', {
                            video: video
                        });

                        $timeout(function() {
                            $rootScope.$apply();
                        });
                    });
                    _videoJsInstantiated = true;
                    eventer.emit('videojs');
                });
                return player;
            },
            isLoadedVideoJs: function() {
                return _videoJsInstantiated;
            }
        };

        return service;
    };

    VideoService.$inject = ['$rootScope', '$timeout', '$interval', '$translate', 'Helper', 'Panel', 'Timing', 'Event', '$compile', '$filter'];

    angular.module('Application')
        .service('Video', VideoService)
        .run(['Video', 'App', '$rootScope', 'Timing', 'Page', 'Overlay', function(Video, App, $rootScope, Timing, Page, Overlay) {

            Video.events.on('ended', function() {
                //if (!App.module().lesson().page().video().hasRestrictedTimings()) {   
                if (
                    !App.module().lesson().page().video().hasMandatoryTiming() &&
                    !App.module().lesson().page().video().hasObligatoryTiming())
                    App.module().lesson().page().viewed();
                //}

                if (App.config().getAttr('layout').autoplay) {
                    if (
                        !App.module().lesson().page().video().timings().length && 
                        !App.module().lesson().page().getAttr('preventAutoplay')
                    )
                        Page.next();
                }
            });

            Video.events.on('ended.timings', function() {
                
                if (App.module()) {
                    var video = App.module().lesson().page().video();
                    if (video)
                        video.loopTimings();
                }

                $rootScope.$apply();

                if (App.module() && App.module().lesson().page().audio())
                    App.module().lesson().page().audio().play();
            });

            Video.events.on('pause', function() {
                if (App.module())
                    if (App.module().lesson().page().video())
                        App.module().lesson().page().video().stopInterval();
            });

            Video.events.on('play', function() {
                if (App.module().lesson().page().video())
                    App.module().lesson().page().video().startInterval();

                if (App.module().lesson().page().video() &&
                    App.module().lesson().page().video().currentTiming() &&
                    App.module().lesson().page().video().currentTiming().isRestricted()
                )
                    App.module().lesson().page().video().currentTiming().close();
            });

            Overlay.events.on('close', function () {
                // console.log(App.module());
                if (
                    App.module().lesson().page().video() &&
                    App.module().lesson().page().video().hasMandatoryTiming() &&
                    App.module().lesson().page().video().hasViewedAllMandatoryTimingsChilds()
                ) {
                    App.module().lesson().page().viewed(true);
                }
            });

            Timing.events.on('open', function() {

                if (
                    App.module().lesson().page().video() &&
                    App.module().lesson().page().video().currentTiming() &&
                    App.module().lesson().page().video().currentTiming().isRestricted() && !App.module().lesson().page().video().paused()
                ) {
                    App.module().lesson().page().video().pause();
                }

            });

            App.events.on('module.close', function() {
                _.each(App.pages(), function(p) {
                    if (p.video()) p.disposeVideo();
                });
                Video.disposeVideoJs();
            });

            // App.events.on('module.open', function () {
            //     Video.loadVideoJs();
            // });

            App.events.on('menu.change', function () {
                Video.loadVideoJs();
            });

            Video.events.on('videojs', function() {
                Page.events.emit('change');
            });
        }]);

})();


(function(){

	'use strict';

	var VideoExerciseFactory = function($http, Model, MenuButton, Overlay){

		var all = [];

		$http.get('config/videoexercises.json').then(function(response){
			_.each(response.data.items, function(item)
            {
               all.push(new VideoExercise(item)); 
            });
		});

		function VideoExercise(attrs) {
			var model = Model.create({
	            attrs: attrs,
	            name: 'videoexercise'
	        });

			model.filepath = function(){
				return model.getAttr('file') + '.' + model.getAttr('type');
			};

			model.open = function() {
				MenuButton.find('video-exercises').open();
				Overlay.open('video-exercises', model) ;
			};

	        return model;
		};


		var service = {
			create: function(attrs){
				return new VideoExercise(attrs);
			},
			get: function(index){
				if(all[index])
					return all[index];

				return false;
			},
			all: function(){
				return all;
			}
		};

		return service;
	};


	VideoExerciseFactory.$inject = ['$http','Model', 'MenuButton', 'Overlay'];

	angular.module('Application')
		.factory('VideoExercise', VideoExerciseFactory);

})();



(function () {

    'use strict';

    var FileFactory = function ($http, Model) {

        var all = [];

        function File(attrs) {

            var model = Model.create({
                attrs: attrs,
                name: 'File'
            });

            model.filepath = function() {
                return model.getAttr('path') + '/' + model.getAttr('filename') + '.' + model.getAttr('type');
            };


            return model;
        };


        var service = {
            create: function (attrs) {
                return new File(attrs);
            },
            get: function (index) {
                if (all[index])
                    return all[index];

                return false;
            },
            all: function () {
                return all;
            },
            load: function (_callback) {
                $http.get('config/files.json').then(function (response) {
                    _.each(response.data.items, function (item) {
                        all.push(service.create(item));
                    });
                    return _callback ? _callback.call(this, response) : false;
                });
            }
        };

        return service;
    };

    FileFactory.$inject = ['$http', 'Model'];

    angular.module('Application')
        .factory('File', FileFactory)
        .run(['File', function (File) {
            File.load();
        }]);
 
})();

(function () {

    'use strict';

    var HtmlFactory = function ($http, Model, Exercise) {

        var all = [];

        var promise = $http.get('config/htmls.json');

        promise.then(function (response) {
            _.each(response.data.items, function (item) {
                all.push(service.create(item));
            });
        });

        function Html(attrs) {

            var model = Model.create({
                attrs: attrs,
                name: 'Html'
            });

            /**
             * @description get Exercises collection
             * @return {*}
             */
            model.exercises = ()=>{
                return Exercise.getById(model.getAttr('Exercise'));
            }

            model.source = function () {
                return 'html/' + model.getAttr('src') + '.html';
            };

            model.getBackground = function () {
                var backdrop = model.getAttr('backdrop');

                if (backdrop == false)
                    return '';

                if (backdrop == true)
                    return '';

                if (backdrop) {
                    var style = {
                        'background-repeat': 'no-repeat',
                        'background-size': 'cover',
                        'background-position': 'center center',
                        'background-image': 'url(images/' + backdrop + '.jpg)'
                    };
                    return style;
                }
            };

            return model;
        };


        var service = {
            create: function (attrs) {
                return new Html(attrs);
            },
            get: function (index) {
                if (all[index])
                    return all[index];

                return false;
            },
            all: function () {
                return all;
            },
            promise: function () {
                return promise;
            }
        };

        return service;
    };


    HtmlFactory.$inject = ['$http', 'Model', 'Exercise'];

    angular.module('Application')
        .factory('Html', HtmlFactory);

})();



(()=>{
    'use strict'

    let LessonLocationFactory = ()=>{

        function LessonLocation(app) {
            let model = this;
            let _app = app;

            model.create = function () {
                let string = '';
                _app.modules().forEach(module => {
                    module.lessons().forEach(lesson => {
                        string += lesson.pages().currentIndex() + '//';
                        lesson.pages().forEach(page => {
                            string += page.isViewed() ? '1' : '0';
                        });
                        string += '|';
                    });
                });
                return string;
            };

            model.get = function () {
                return model.create();
            };

            return model;
        };

        return LessonLocation;
    };

    LessonLocationFactory.$inject = [];

    angular.module('Application').factory('LessonLocation', LessonLocationFactory);

})();

(() => {
    'use strict'

    let LessonLocationParserFactory = () => {

        function LessonLocationParser(string, app) {
            let model = this;
            let _string = string;
            let _app = app;

            //_string="3//1111|4//11111|3//1111|4//11111|9//1111111111|8//111111111|9//1111111111|8//111111111|10//11111111111|8//111111111|"

            // _string = "0//1111|0//11111|0//1111|9//1111111110|0//0000000000|0//00000000000|"; // S1T1
            // _string = "0//1111|0//11111|0//1111|10//1111111111|7//1111111000|0//00000000000|"; // S1T1

            // _string = "0//1|0//1|0//00000000|0//000000|0//000000|0//0000000|0//0000000|0//00000000|0//000|"; // S2T1
            // _string = "0//1|0//1|7//11111111|5//111111|5//111111|6//1111111|6//1111111|7//11111110|0//000|"; // S2T1

            // _string = "0//1|0//1|7//11111111|5//111111|5//111111|6//1111111|6//1111111|0//1|7//11111110|0//0000|0//0000|0//0000|0//0000|"; // S2T2
            
            // _string = "0//1|0//1|7//11111111|0//000000|0//000000|0//0000000|0//0000000|0//0|0//000000|0//00000000|0//0000|0//0000|0//0000|0//0000|"; // S2T3
            // _string = "0//1|0//1|7//11111111|5//111111|5//111111|6//1111111|6//1111111|0//1|5//111111|7//11111110|0//0000|0//0000|0//0000|0//0000|"; // S2T3

            // _string = "0//1|2//111|2//111|1//11|0//1|3//1111|2//111|2//111|2//111|2//111|0//1|3//1111|0//1|4//11111|4//11111|0//0|0//00000000000000000|"; // S3T3

            model.parse = function () {
                if(_string) {
                    let splitted = _string.split('|');
                    let key = 0;
                    let counterLesson = -1;
                    let counterPage = 0;
                    var currentBookmark=0;
                    _app.modules().forEach(module => {
                        module.lessons().forEach(lesson => {
                            let pagesSplittedString = splitted[key].split('//');
                            //console.log("TCL: model.parse -> pagesSplittedString", pagesSplittedString)
                            lesson.pages().forEach((page, k) => {
                                if(pagesSplittedString[1][k] === '1') page.setViewed(true);
                            });
                            // if(pagesSplittedString[1].indexOf('1') !== -1) {
                            //     counterPage = pagesSplittedString[1].indexOf('1');
                            //     counterLesson++;
                            // }else{
                            //     return;
                            // }
                            //var currentBookmark = Number(pagesSplittedString[0]);
                            currentBookmark = Number(pagesSplittedString[0]);
                           //console.log("currentBookmark",currentBookmark)
                            //console.log("TCL: model.parse -> currentBookmark", currentBookmark)
                            var bookmark = (
                                pagesSplittedString[1].indexOf('0') > -1
                                //  || 
                                // (currentBookmark+1) != pagesSplittedString[1].length
                            ) ? currentBookmark : 0;
                            //console.log("bookmark",bookmark)
                            // if (bookmark===0)
                            //     currentBookmark=0
                            // lesson.pages().setCurrent(bookmark);
                            key++;
                        });

                        //console.log("currentBookmark",currentBookmark)
                        
                        // console.log("counterPage", counterPage);
                        //counterLesson = counterLesson > -1 ? counterLesson : 0;
                        //console.log("counterLesson", counterLesson);
                        //module.lessons().setCurrent(counterLesson);
                        //console.log("module",module)
                        //console.log("currentBookmark",currentBookmark)
                        module.lessons().setCurrent(0);
                        module.lessons().current().setCurrentPage(currentBookmark);
                    });
                }

                return model;
            };

            return model;
        };

        return LessonLocationParser;
    };

    LessonLocationParserFactory.$inject = [];

    angular.module('Application').factory('LessonLocationParser', LessonLocationParserFactory);

})();

(() => {
    'use strict'

    let OLDLessonLocationParserFactory = () => {

        function OLDLessonLocationParser(string, app) {
            let model = this;
            let _string = string;
            let _app = app;

            /*** PRIVACY ***/
            // _string = '3//1110000000000000000000|0//00000000000|0//00000000000000|0//0|'; // MOD1 - 1a domanda
            // _string = '9//1111111111000000000000|0//00000000000|0//00000000000000|0//0|'; // MOD1 - Approfondimento
            // _string = '0//1111111111111111111111|0//00000000000|0//00000000000000|0//0|'; // MOD1 - Completato
            // _string = '0//1111111111111111111111|0//11111111111|0//00000000000000|0//0|'; // MOD2 - Completato
            // _string = '0//1111111111111111111111|0//11111111111|0//11111111111111|0//0|'; // MOD3 - Completato
            // _string = '0//1111111111111111111111|0//11111111111|0//11111111111111|0//1|'; // MOD4 - Completato

            model.parse = function () {
                if(_string) {
                    let splitted = _string.split('|');
                    let key = 0;
                    let counterLesson = -1;
                    let counterPage = 0;

                    _app.modules().forEach(module => {
                        module.lessons().forEach(lesson => {
                            let pagesSplittedString = splitted[key].split('//');
                            lesson.pages().forEach((page, k) => {
                                if(pagesSplittedString[1][k] === '1') page.setViewed(true);
                            });
                            if(pagesSplittedString[1].indexOf('1') !== -1) {
                                counterPage = pagesSplittedString[1].indexOf('1');
                                counterLesson++;
                            }
                            var currentBookmark = Number(pagesSplittedString[0]);
                            var bookmark = (
                                pagesSplittedString[1].indexOf('0') > -1
                                //  || 
                                // (currentBookmark+1) != pagesSplittedString[1].length
                            ) ? currentBookmark : 0;
                            // lesson.pages().setCurrent(bookmark);
                            key++;
                        });
                        // console.log("counterLesson", counterLesson);
                        // console.log("counterPage", counterPage);
                        counterLesson = counterLesson > -1 ? counterLesson : 0;
                        module.lessons().setCurrent(counterLesson);
                        module.lessons().current().setCurrentPage(0);
                    });
                }

                return model;
            };

            return model;
        };

        return OLDLessonLocationParser;
    };

    OLDLessonLocationParserFactory.$inject = [];

    angular.module('Application').factory('OLDLessonLocationParser', OLDLessonLocationParserFactory);

})();

(()=>{

    'use strict';

    let SuspendDataFactory = ()=>{

        function SuspendData() {
            let model = this;
            let _modules = null;
            /**
             * @description set modules
             * @param modules
             */
            model.setModules = (modules)=>{
                _modules = modules;
                return model;
            };

            /**
             * @description return string for suspenddata
             * @return {string}
             */
            model.get = ()=>{
                let string = '';
                _modules.forEach((module, modIndex) => {
                    var modString = model.stringifyModule(module);
                    string += (modIndex+1);
                    if (modString) string += '_' + modString;
                    string += '|';
                });
                return string;
            };

            /**
             * @description stringify module
             * @param module
             * @return {string}
             */
            model.stringifyModule = (module)=>{
                let string = ``;

                module.moduleExercises().forEach((exercise, exIndex) => {

                    if (exercise.getAttr('type') == 'multiple') {

                        if (!exercise.isConfirmed() || !exercise.getAttr('choices').length) {
                            string += null + `!` ;
                        } else {
                            var choices = [];
                            exercise.getAttr('choices').forEach(choice => {
                                var choiceIndex = _.indexOf(exercise.getAttr('options'), choice);
                                choices.push(choiceIndex);
                            });

                            string += choices.join(':') + `!`;
                        }

                    }

                    if (exercise.getAttr('type') == 'single') {

                        if (exercise.isConfirmed() && exercise.getAnsweredIndex() >= 0) {
                            string += exercise.getAnsweredIndex() + `!`;
                        } else {
                            string += null + `!`;
                        }
                    
                    }

                });
                
                string = string.slice(0, -1);

                // module.lessons().forEach(lesson => string += model.stringifyLesson(lesson));
                string += '';
                return string;
            };

            /**
             * @description stringify lesson
             * @param lesson
             * @return {string}
             */
            model.stringifyLesson = (lesson)=>{
                let string = ``;
                lesson.pages().forEach(page => string += model.stringifyPage(page));
                string += '';
                return string;
            };

            /**
             * @description stringify page
             * @param page
             * @return {string}
             */
            model.stringifyPage = (page)=>{
                let string = '';
                let pageScore = page.getAttr('score') && page.isViewed() ? 1 : 0;
                let answeredIndex = null;

                // get index answer
                let answeredIndexes = [];
                let answeredIndexesString = null;
                let exs = page.hasTimingExercises();
                
                // if page has id i'll save all
                if(page.getAttr('id')) {
                    string += `${page.getAttr('id')}_${pageScore}`;
                    if(answeredIndexesString !== null) string += `_${answeredIndexesString}`;
                    string += '|';
                }

                return string;
            };

            return model;
        }

        return (SuspendData);

    };

    SuspendDataFactory.$inject = [];

    angular.module('Application')
        .factory('SuspendData', SuspendDataFactory);

})();

(()=>{

    'use strict';

    let SuspendDataParserFactory = ()=> {

        function Parser(string, app, score) {
            let _string = string;
            /*[
                1 => 1,
                2 => [0,0]
            ]*/
            // _string = '1_0|2_0:2!0:1:2!null!1|3|4|';
            // _string = '1_1!0!1!0|2_null!null|3_null!null!null|4_null!null!null!null!null!null!null!null!null!null!null!null!null!null|';
            
            let _app = app;
            let model = this;

            // console.log(score);
            // let _score = 82;//score;
            let _score = score;

            /**
             * @description parse suspend data
             */
            model.parse = ()=>{
                if(!_string) return;
                let temp = _string.split('|');
                let parsedStringModule = [];
                temp.splice(-1, 1);
                temp.forEach((page) => {
                    let array = page.split('_');
                    let pageId = array[0];
                    array.shift();
                    parsedStringModule[pageId] = array;
                });
                // console.log(parsedStringModule);
                _app.modules().forEach((module, modIndex) => {
                    let saved = parsedStringModule[modIndex + 1];
                    if (saved && saved.length > 0) {

                        var exAnswers = saved[0].split('!');
                        module.improvedModuleExercises().forEach((exercise, exIndex) => {

                            if (exercise.getAttr('type') == 'multiple' &&
                                exAnswers[exIndex] !== null &&
                                exAnswers[exIndex] !== 'null' &&
                                exAnswers[exIndex] != -1) 
                            {
                                var answers = exAnswers[exIndex].split(':');
                                answers.forEach(answer => {
                                    var answer = exercise.getAttr('options')[answer];
                                    exercise.getAttr('choices').push(answer);
                                })
                                exercise.setAttr('confirm', true);
                            }

                            if (exercise.getAttr('type') == 'single' && 
                                exAnswers[exIndex] !== null &&
                                exAnswers[exIndex] !== 'null' &&
                                exAnswers[exIndex] != -1)
                            {
                                var answer = exercise.getAttr('answers')[Number(exAnswers[exIndex])];
                                exercise.setAnswer(answer, true);
                                exercise.setAttr('confirm', true);
                            }

                        });

                    }

                    if (_score && _score > 70 && module.getAttr('finaltest')) { // FIXME **********************
                        // console.log("SET MOD SCORE");
                        module.setAttr('passed', true);
                    }

                });
            };

            return model;
        }

        return Parser;
    };

    SuspendDataParserFactory.$inject=[];

    angular.module('Application')
        .factory('SuspendDataParser', SuspendDataParserFactory);

})();



app.service('GameService', ['Tracking', function (Tracking) {

    var _progress = {
        'G_CRUC': {
            score: -1,
            remainingTime: 0,
            saved: false
        },
        'G_MEM': {
            score: -1,
            remainingTime: 0,
            saved: false
        },
        'G_ASSIGN': {
            score: -1,
            remainingTime: 0,
            saved: false
        }
    }

    var getSuspendData = function(){
        var strSuspendData = Tracking.getSuspendData() || "";//T15000|200
        return strSuspendData;
    }



    var str = getSuspendData();
    if (str && (str.length > 0)){
        var arrayScore = str.split("|"); // es. ["G_CRUC:100:200|G_MEM:200:200|G_ASSIGN:300:200"]
        _.each(arrayScore, (scoreEl)=>{
            console.log("score", scoreEl, scoreEl.split(':'));
            // let id = parseInt(scoreEl.split(':')[0]);
            let id = scoreEl.split(':')[0];
            let score = parseInt(scoreEl.split(':')[1]) || -1;
            let extraScore = parseInt(scoreEl.split(':')[2]) ;

            console.log(id, score, extraScore);
            if (score >= 0){ // se score < 0 l'esercitazione non è completata
                _progress[id].score = score;
                _progress[id].extraScore = extraScore;
                _progress[id].saved = true;
            }
        })
    }

    var buildStringSuspendData = function(){
        /*var outputStr = "T" + _progress.remainingTime + "|" + _progress.score;*/
        let keys = Object.keys(_progress);
        let outputStr = "";
        _.each(keys, (key)=>{
            if (outputStr.length){
                outputStr += '|';
            }
            outputStr += key + ':' + _progress[key].score + ':' + _progress[key].extraScore;
        })
        return outputStr;
    }

    var addScore = function(_score, _extraScore, _remainingTime = 0, _gameId){
        if (!_progress[_gameId].saved){ // salvo solo se non ho già tracciato
            _progress[_gameId].score = _score;
            _progress[_gameId].extraScore = _extraScore;
            _progress[_gameId].remainingTime = _remainingTime;
            _progress[_gameId].saved = true;
            Tracking.updateSuspendData(buildStringSuspendData());
        }
    }

    return {
        /*start: function(){
            Tracking.updateSuspendData("T0|0/"); // all'avvio traccio 0ms rimasti, così se l'utente chiude a metà è come se avesse consumato tutto il timer.
        },*/
        addScore: addScore,
        initGameScore: function(_gameId){ // richiamato all'apertura di un game, per tracciare 0 ed evitare che l'utente chiudda e riapra a metà
            _progress[_gameId].score = 0;
            _progress[_gameId].extraScore = 0;
            _progress[_gameId].remainingTime = 0;
        },
        getProgress: function(){
            return _progress;
        },
        getProgressById: function(_idGame){
            return _progress[_idGame];
        },
        getScore: function(){
            let keys = Object.keys(_progress);
            let totalScore = 0;
            _.each(keys, (key)=>{
                totalScore+=_progress[key].score+_progress[key].extraScore;
            })
            return totalScore;
        },
        updateSuspendData: function(){
            Tracking.updateSuspendData(buildStringSuspendData());
        },
        isCompleted: function(){
            return getSuspendData() && (getSuspendData().length > 0);
        }
    };
}]);

(function()
{
  angular.module('Application')
    .run(function()
    {
      // Check if browser is IE
      if(navigator.userAgent.indexOf('MSIE') > -1 || (!(window.ActiveXObject) && "ActiveXObject" in window))
      {
        var doc = document.documentElement;
        doc.setAttribute('data-useragent', 'ie');
      }
    });

})();

app.service('Overlay', ['MenuButton', 'Page', 'Event', function(MenuButton, Page, Event) {

	var objOpened = false;
    var _overlay = false;
    var sectionName = false;

    var eventer = Event.create('overlay');

	var service = {
		events: eventer,
		
		tmpObj: function(obj){
			objOpened = obj;
		},
		getTmpObj: function(){
			return objOpened;
		},
		open: function(name, obj){
        	if(obj) {
        		sectionName = name;
            	this.tmpObj(obj);
			}
			
			_overlay = true;
			
            eventer.emit('open');
		},
		close: function(){
			_overlay = false;
			this.tmpObj(false);

            eventer.emit('close');
		},
		isOpened: function(){
			return _overlay;
		},
		isSectionOpened: function(name){
			return sectionName == name;
		}
	};

	/**
	 * Events
	 */
	MenuButton.events.on('open', function () {
        service.close();
    });

    MenuButton.events.on('close', function () {
        service.close();
    });


	Page.events.on('change', function() {
		service.close();
	});

	return service;

}]);

(function () {

    'use strict';

    let TrackingService = function (App, SuspendData, LessonLocation, SuspendDataParser, LessonLocationParser, $timeout) {

        var lms = $.LMS({
            debug: false,
            pages: false
        });

        var storedString = false;

        let suspend_data = new SuspendData();

        var string = false;

        var service = {
            init: function () {
                string = new LessonLocation(App);
                suspend_data.setModules(App.modules());
                (new LessonLocationParser(lms.getLessonLocation(), App)).parse();
                (new SuspendDataParser(lms.getSuspendData(), App, lms.getScore())).parse();
            },
            string: function () {
                return string.get();
            },
            getLastOpened: function () {
                return string.getLastOpened();
            },
            update: function () {
                // console.log("App.isAtLastPage()", App.isAtLastPage());
                if (App.isAtLastPage() && false) {
                    //FIXME (if there's a test at the end)
                    // var stringaToPass=string.get().split("//")[1];
                    // var isComplete = stringaToPass.indexOf("0") === -1;
                    // if (isComplete) 
                        //this.complete();
                }
                else {
                    //console.log("string.get()",string.get())
                    $timeout(function () {
                        // console.log("%cTracking.update()[lessonLocation]: ", "background-color: black;color: yellowgreen;", string.get());
                        // console.log("%cTracking.update()[suspendData]: ", "background-color: black;color: yellowgreen;", suspend_data.get());
                        if (string)
                            lms.updateStrings({
                                lessonLocation: string.get(),
                                suspendData: suspend_data.get()
                            });

                        if (App.areAllModulesViewed()) lms.setCompleted();
                    });
                }
            },
            complete: function () {
                $timeout(function () {
                    lms.setCompleted();
                    if (string)
                        lms.updateStrings({
                            lessonLocation: string.get(),
                            suspendData: suspend_data.get()
                        });
                });
                return this;
            },
            stored: function () {
                return storedString;
            },
            logout: function () {
                return lms.exitAu();

            },
            getSuspendData: function(){
                return lms.getSuspendData();
            },
            // save statement on LMS
            save: function (params) {
                lms.updateScore(params.score, params.status);
            },
            lms: function(){
                return lms;
            }
        };

        return service;
    };

    TrackingService.$inject = ['App', 'SuspendData', 'LessonLocation','SuspendDataParser', 'LessonLocationParser', '$timeout'];

    var InteractionModel = function ($timeout, Tracking) {
        var nInteractions = 0;

        // Interaction Object
        function Interaction(attrs) {
            var model = this;
            var attrs = attrs;

            var root = 'cmi.interactions.';

            function convertiSecToTime(tmSecs) {
                var tm = "00:00:00";
                if (tmSecs > 0) {
                    var hrs = Math.floor(tmSecs / 3600);
                    var min = Math.floor((tmSecs % 3600) / 60);
                    var sec = Math.floor(tmSecs % 60);
                    tm = convertiZeri(hrs, min, sec);
                }
                return tm;
            };

            function convertiZeri(h, m, s) {
                var tm;
                tm = (h < 10 ? "0" : "") + h + ":";
                tm += (m < 10 ? "0" : "") + m + ":";
                tm += (s < 10 ? "0" : "") + s;
                //
                return tm;
            }

            model.getAttr = function (attr) {
                return attrs[attr];
            };

            model.getRoot = function () {
                return root + nInteractions + '.';
            };

            model.get = function (attr) {
                return model.getRoot() + attr;
            };

            model.set = function (attr, value) {
                return Tracking.lms().setValue(model.get(attr), value);
            };

            /**
             *    Send data to LMS
             * @return void
             **/
            model.submit = function () {
                //attrs.txt[2] = attrs.txt[2].join('_');

                $timeout(function () {
                    model.set('id', attrs.id);
                    //model.set('objectives.0.id', '');
                    model.set('time', model.getTimeString());
                    model.set('type', 'performance');
                    /** INDICE DELLA Risposta corretta **/
                    model.set('correct_responses.0.pattern', attrs.response.join('_'));
                    //model.set('weighting', '');
                    /** DOMANDA TESTO :: RISPOSTA UTENTE :: PUNTI OTTENUTI **/
                    model.set('student_response', attrs.txt.join('||'));
                    /** CORRECT || WRONG */
                    model.set('result', attrs.result);
                    /** TEMPO nella DOMANDA **/
                    model.set('latency', convertiSecToTime(attrs.latency));

                    Tracking.lms().update();

                    nInteractions++;
                });
                return;
            };

            model.getTimeString = function () {
                var date = new Date();
                return date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
            };

            model.getResponseStatus = function () {
                return model.getAttr('correct') == model.getAttr('response');
            };

            model.getString = function () {
                return model.getAttr('id') + '//' +
                    model.getTimeString() + '//' +
                    'performance' + '//' +
                    attrs.response.join('_') + '//' +
                    attrs.txt.join(' | ') + '//' +
                    attrs.result + '//' +
                    convertiSecToTime(attrs.latency);
            };
        };

        return {
            create: function (attrs) {
                return new Interaction(attrs);
            }
        }

    };

    InteractionModel.$inject = ['$timeout', 'Tracking'];

    angular.module('Application')
        .service('Tracking', TrackingService)
        .factory('Interaction', InteractionModel)
        .run(['$rootScope', '$timeout', 'Html', 'Exercise', 'Tracking', 'App', 'Page', 'Test', 'Video', function ($rootScope, $timeout, Html, Exercise, Tracking, App, Page, Test, Video) {

            App.promise.then(function () {
                Exercise.promise().then(function() {
                    Html.promise().then(()=>{
                        Tracking.init();
                    });
                });
            });

            App.events.on('logout', function () {
                $timeout(function () {
                    Tracking.logout();
                }, 1000);
            });

            Page.events.on('viewed', function () {
                // if (App.config().isFree())
                Tracking.update();
            });

            Page.events.on('change', function () {
                // if (App.config().isFree())
                Tracking.update();
            });

            Page.events.on('prev', function () {
                // if (App.config().isFree())
                Tracking.update();
            });
            
            Page.events.on('next', function () {
                // if (App.config().isFree())
                Tracking.update();
            });

            Video.events.on('ended', function () {
                if (!App.config().isFree())
                    Tracking.update();
            });

            /**
             * Track score if test must be tracked
             */
            Test.events.on('ended', function (e, params) {
                var test = params.test;

                if (test.isTrackingScore()) {
                    Tracking.save({
                        score: test.score() * 10,
                        status: test.isPassed()
                    });
                }
            });
        }]);

})();


(function () {
    'use strict';

    var TranslationService = function (Model, Event, $http, $translate) {
        var all = [];

        var promise = false;

        var eventer = Event.create('translation');

        var TranslationModel = function (attrs) {
            var model = Model.create({
                attrs: attrs,
                name: 'translation'
            });

            model.isDisabled = function () {
                return model.getAttr('disabled');
            };

            model.active = function () {
                eventer.emit('change');
                if (!model.isDisabled()) {
                    $translate.use(model.getAttr('lang'));
                }
            };

            model.isActive = function () {
                return $translate.use() == model.getAttr('lang');
            };

            return model;
        };

        var service = {
            all: function () {
                return all;
            },
            listLang: function () {
                var array = [];
                _.each(all, function (item) {
                    array.push(item.getAttr('lang'));
                });

                return array;
            },
            promise: promise,
            init: function () {
                promise = $http.get('config/translations.json')
                    .success(function (data) {
                        _.each(data.translations, function (item) {
                            all.push(new TranslationModel(item));
                        });
                    });
            },
            current: function () {
                var _return = false;
                _.each(all, function (item) {
                    if (item.isActive()) {
                        _return = item;
                        return false;
                    }
                });
                return _return;
            },
            isSelected: function () {
                return this.current() ? this.current() : false;
            },
            events: eventer
        };

        return service;
    };

    TranslationService.$inject = ['Model', 'Event', '$http', '$translate'];

    angular.module('Application')
        .service('Translation', TranslationService)
        .config(['$translateProvider', function ($translateProvider) {
            $translateProvider
                .useStaticFilesLoader({
                    prefix: 'config/locales/locale-',
                    suffix: '.json'
                })
                .useSanitizeValueStrategy('sanitizeParameters')
                .useLoaderCache(true)
                .uniformLanguageTag('bcp47')
                .preferredLanguage('it')
                ;
        }])
        .run(['Translation', 'App', '$rootScope', function (Translation, App, $rootScope) {
            Translation.init();

            // when app is loaded
            App.promise.then(function () {
                // when language change
                $rootScope.$on('$translateChangeEnd', function () {
                    if (App.module()) {
                        // necessary to update current video when language change
                        App.module().lesson().page().updateVideo();
                    }
                });
            });
        }]);

})();